import React, { useState, useEffect, useCallback, useRef, useMemo, use } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { phoneValidation } from "validationSchemas/common";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import { showSuccess, showError } from "toast/toast";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import Select, { SingleValue, components } from "react-select";
import { AsyncPaginate, LoadOptions } from "react-select-async-paginate";
import { License, Office, Agent, Addresses, Address, Product, PaymentMethod, PaymentGateway, StatusHistoryItem, PaymentInfoItem, Addresstax } from "types";
import { sub } from "date-fns";
import { to } from "assets/libs/moment/src/lib/moment/to";
import { Button } from "react-bootstrap";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import PaymentFormManualOrder from "../../components/PaymentFormManualOrder";
import { StatusBadge } from "components/Productlocationstatus";
import { INSTALLATION_ORDER_CANCELLED_STATUS_CODE, InstallationStatusBadge } from "components/Installationstatus";
import InstallationStatusTracker from "components/InstallationStatusTracker";
import BrokerageAssociationStatusBadge from "components/BrokerageAssociationStatusBadge";
import RealtorProductPicker from "components/installationpop";
import SectionHeader from "components/SectionPillPropsIcons";
import AddressFormModal from "components/AddAddressFormModal";
import OrderInvoice from "components/OrderInvoice";
import Instructions from "components/Instructions";
import PONumber from "components/PONumber";
import DeleteConfirmModal from "components/ToolTips/DeleteConfirmModal";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";
import ProofSection, { ProofFile } from "../../components/ProofOfInstallation";
import OrderLog, { buildInstallationLogEventsFromOrder } from "../../components/OrderLog";
import ProductSelection from "assets/images/brands/ProductSelection.png"
import Doller from "assets/images/brands/doller.png"
import PaymentPanel from "components/PaymentOptionsCard";
import CompactApprovedProofCard from "components/CompactApprovedProofCard";
import RefreshIconButton from "components/RefreshIconButton";
import type { InvoiceType } from "components/InvoiceDocument";
import AddressAutocomplete from "components/AddressAutocomplete";
import SpecialFeeui from "components/Tax/InstallationandremovalSpecialfeeui";
import ProjectGetCard from "components/projectgetcard";
import {
  requestInstallationTaxRefund,
  type Product as TaxProduct,
} from "components/Tax/INstallationandRemovalsTaxEngine";
import {
  postInstallationOrderResolve,
  buildInstallationResolvePayload,
  buildInstallationEditResolveLineItems,
  buildInstallationAddResolveLineItems,
  applyInstallationEditResolveResponse,
  buildInstallationPatchFromResolved,
  mergeResolvedTaxIntoLineItems,
  inferInstallationDiscountScope,
  getInstallationResolveRootDiscountCode,
  mapInstallationOrderLinesToResolved,
  type InstallationDiscountScope,
  getResolvedDiscountDisplay,
  getOrderDiscountFieldDisplay,
  getInstallationCostBreakdownDiscount,
  mapInstallationSpecialFeeForResolve,
  mapInstallationSpecialFeeForSubmit,
  mapSavedInstallationSpecialFeeToUi,
  normalizeInstallationSelectedFee,
  overlayInstallationSubmitFromResolved,
  type InstallationResolveAddress,
  type OrderResolveAction,
  type ResolvedInstallationOrder,
  type ResolvedInstallationLineItem,
} from "orderResolve";
import { OrderDiscountCodeField } from "components/orderResolve";
import {
  DiscountAmountDisplay,
  inferInstallationDiscountAppliesTo,
  sumInstallationLineItemDiscounts,
} from "components/DiscountLabelBadge";
import {
  computeInstallationUnitsCostFromChangedUnitPrice,
  getInstallationLineDiscountDisplay,
  getInstallationLineUnitCostDisplay,
  orderLineKey,
} from "utils/orderResolveLinePricing";
import { getProductLineDiscountAmount, resolveLineDiscountMap, round2 } from "utils/fixedAmountDiscountAllocation";
import PostTypeSignConfiguration, {
  type InstallationPostPayload,
  type PostTypeSignConfigurationRef,
} from "pages/signage/PostTypeSignConfiguration";
import { GENERAL_SETTINGS_KEYS } from "pages/signage/SignageGeneralSettings";
import type { LinkedProduct } from "components/ProductSelectionModal";
import { getImageSrc, useVariantImageUrlMap } from "components/Tableimageshelpers";
import { sendTriggerEmails } from "utils/emailService";
import { resolveSendQuoteEmailTrigger } from "components/SalesOrderDetails/resolveSendQuoteEmailTrigger";
import {
  buildInstallationOrderInvoicePdfAttachment,
  buildInstallationOrderPdfAttachment,
} from "utils/installationOrderPdfAttachment";
import { resolveInstallationBrokerageTeamMemberEmail } from "utils/brokerageTeamMemberEmail";
import {
  buildInstallationLineItemImages,
  isMeaningfulObjectId,
  normalizeInstallationLineItemImages,
} from "utils/buildInstallationLineItemImages";
import {
  base64PdfToBlob,
  buildInvoiceEmailParamsForSend,
  buildInvoiceSendRecipientPlan,
  sendInvoiceTriggerEmails,
  triggerBrowserDownload,
} from "utils/invoiceEmailHelpers";
import SendOrderEmailRecipientsModal, {
  appendAdditionalRecipientEmails,
  mergeAdditionalIntoInvoiceCustomerRecipients,
} from "components/SendOrderEmailRecipientsModal";
import { handleApiError } from "utils/errorHandler";
import { safeConsole, createSafeNavigate } from "utils/envUtils";
// TaxCloud helpers + types
import {
  toTaxCloudAddressFromObject,
  upsertTaxCloudCartMulti,
  GetVersionOrdernumber,
  PostVersionOrdernumber,
  type TaxCloudAddress,
  type UiFee,
} from "components/Tax/InstallationandRemovalTaxcloud";

// Active tax type by Bobba
import { getActiveTaxType } from "components/Tax/manualtax";
import { di } from "@fullcalendar/core/internal-common";
import { getAuthCookie } from "../../utils/authCookies";
import { buildLoggedInPaymentPaidBy } from "../../utils/buildPaymentPaidBy";
import { resolveMembershipIdForAddresses } from "../../utils/orderPartyIdentity";
import {
  buildInstallationPartyIdentityPayload,
  resolveInstallationPartyContext,
  sanitizeInstallationOrderSubmitPayload,
  buildInstallationDetailsParticipantFields,
  installationDetailsParticipantFromSaved,
} from "../../utils/installationPartyIdentity";
import {
  fetchPublicOrderQuoteModeSetting,
  fetchProjectApprovedMessage,
  linkProjectQuote,
  unlinkProjectQuote,
  resolveApprovedProofVersionSummary,
  fetchProjectPublicAccess,
  createStripePaymentIntent,
  fetchPaymentGatewaysCreatedByUserId,
  fetchInstallationOrderByIdUnwrapped,
  postInstallationDynamicCost,
  fetchInstallationScheduledJobs,
  patchInstallationOrder,
  postInstallationOrderAction,
  postInstallationOrderPayment,
  postInstallationOrderNet30Payment,
  putInstallationOrderUploadProof,
  patchInstallationOrderLineItems,
  fetchInstallationPaymentMethods,
  resolveInstallationPaymentMethodsMembershipId,
  resolveInstallationInventoryEntityMembershipId,
  fetchInstallationPaymentGateway,
  createInstallationStripePaymentIntent,
  resolveInstallationSellerOrganizationId,
  resolveInstallationSellerMembershipId,
  fetchInstallationInventoryByType,
  fetchInstallationInventoryProduct,
  fetchInstallationAgentInventory,
  fetchInstallationOfficeInventory,
  fetchSignageRotationalProducts,
  fetchRotationalSerializedUnits,
  fetchInstallationLocations,
  fetchInstallationLocationById,
  searchOrganizationProfiles,
  searchUsers,
  fetchAgentsByOfficeId,
  fetchUserAddresses,
  resolveMembershipAddressesRouteId,
  salesOrderUrls,
  SALES_ORDER_API_BASE,
  fetchSignageAgentsSelect2,
  fetchPaymentMethodsBySupplierAndUser,
  syncUserEmailToDocument,
  getInstallationImageUploadUrl,
  installationOrderUrls,
  installationRequest,
} from "api/installationApi";
import {
  buildSalesAddressSelectOptions,
  fetchOfficeAddresses,
  pickSyncMembershipId,
  resolveSalesOrderAddressId,
  unwrapAddressListResponse,
} from "api/salesOrderApi";
import { isSignagePortalRoute } from "utils/isSignagePortalRoute";
import { createSendLogEntry } from "api/postTypeApiCalls";
import { downloadWorkDriveFile } from "api/realesyStudioApi";
import { batchPresignUrls } from "components/Imageshelper";
import { formatOrderReadyPaymentDisplay, buildOrderReadyLineItemsHtml, buildOrderReadyAddressFieldRowHtml, buildOrderReadyCustomerDisplayName } from "components/SalesOrderDetails/buildYourOrderReadyEmailParams";
import { sendInstallationOrderTriggerEmail } from "utils/salesOrderTriggerEmailEngine";
import { buildSpecialFeeCostBreakdownDisplay } from "utils/specialFeeCostBreakdownDisplay";
import {
  getCustomizationsBlockFromLineItem,
  getVisibleCustomizationFieldsForDisplay,
  getVisibleCustomInformationRowsForDisplay,
  resolveSelectedLineItemForDisplay,
} from "utils/installationProductCustomizationDisplay";

// toast helpers are already imported: showSuccess, showError

// import TaxCloudButtonsV2 from "components/TaxCloudButtons";
export type FlattenedProduct = {
  product_id: string;
  name: string;
  sku: string;
  /** When set for custom inventory lines, preferred for display */
  custom_sku?: string;
  inventory_type: "agent" | "office" | string;
  product_location_status?: string;
  user_id?: string;
  product_current_status?: string;
  current_status?: string;
  availableqty: number;
  quantity: number;
  updateStatus?: string;
  productionStatus?: string;
  is_production?: boolean;
  image_url?: string;
  location?: Array<{
    quantity: number;
    warehouse_id: string;
    warehouse_name?: string;
    zone_id?: string;
    zone_name?: string;
    rack_id?: string;
    rack_name?: string;
    bin_id?: string;
    bin_name?: string;
  }>;
  storage_locations?: Array<{
    quantity: number;
    current_status: string;
    location?: Array<{
      quantity: number;
      warehouse_id: string;
      warehouse_name?: string;
      zone_id?: string;
      zone_name?: string;
      rack_id?: string;
      rack_name?: string;
      bin_id?: string;
      bin_name?: string;
    }>;
  }>;
  is_accessory?: boolean;
  /** Backend slot id for post-type sign configuration */
  slot_id?: string;
  /** Logical slot key (e.g. main_panel) — set when adding via Post Type config */
  slotKey?: string;
  variant_id?: string;
  is_new_catalog?: boolean;
  /** Mirrors API `is_accessories` when present */
  is_new_purchase?: boolean;
  source_product_id?: string | null;
  /** Studio customization — echoed from installation order line item */
  design_id?: string;
  design_name?: string;
  preview_url?: string;
  images?: Array<{ url: string; alt_text?: string; default?: boolean }>;
  /** Per line_item from API — template answers for Product Selection */
  customizations?: unknown;
  /** Free-form agent/office details for custom inventory lines */
  custom_information?: string;
  unit_price?: number;
  unit_retail_price?: number;
  changed_unit_price?: number;
  is_taxable?: boolean;
};

async function fetchNewUniqueId(token: string): Promise<string> {
  const url = `${process.env.REACT_APP_API_URL}/utils/new-unique-id`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({ message: res.statusText }));
    throw new Error(errorData.message || `Failed to fetch unique ID: ${res.statusText}`);
  }
  const data = await res.json().catch(() => ({}));
  const id = data?.id || data?.data?.id || data?.data?.unique_id || data?.unique_id || null;
  if (!id) throw new Error("Unique ID not found in API response");
  return String(id);
}

/** Show a readable label for generated custom-product SKUs. */
function displayInstallationLineItemSku(item: {
  sku?: string;
  custom_sku?: string;
  inventory_type?: string;
  inventory_source?: string;
}): string {
  const src = String(item.inventory_type ?? item.inventory_source ?? "");
  if (src !== "custom") return String(item.sku ?? "");

  const customSku = String(item.custom_sku ?? item.sku ?? "").trim();
  if (!customSku) return "";

  if (/^custom_sku(?:_|$)/i.test(customSku)) {
    return "Custom SKU";
  }

  return customSku;
}

/** Agent/office stock only — custom and rotational lines do not use inventory available-qty API. */
function shouldShowAvailableQty(item: {
  inventory_type?: string;
  inventory_source?: string;
  is_rotational?: boolean;
}): boolean {
  const src = String(item.inventory_type ?? item.inventory_source ?? "")
    .trim()
    .toLowerCase();
  if (src === "custom" || src === "rotational") return false;
  if (item.is_rotational) return false;
  return src === "agent" || src === "office";
}

type ProductObj = {
  product_id: string;
  agent_id: string;
  office_id: string;
  inventory_type: string;
  product: Product;
  linked_installer_details: any;
  created_by: {
    id: string;
    name: string;
  }
  source_order_id: string; // New field for source order ID
};

type Selected = {
  value: string;
  label: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  membershipId?: string;
  globalUserId?: string;
  organizationId?: string;
}

type InstallationTaxEngineHandle = {
  recalculate: (forceType?: "manual" | "taxcloud", options?: { allowRefund?: boolean }) => Promise<boolean>;
};

// Select2 types for team members
type TeamMemberOption = {
  value: string;
  label: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  membershipId?: string;
  offices: any[]; // Array of office objects from API
};

// Select2 types for signage team members (installers)
type SignageTeamMemberOption = {
  value: string;
  label: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  membershipId?: string;
  globalUserId?: string;
  organizationId?: string;
};

// Select2 types for agents
type OfficeAgentOption = {
  value: string;
  label: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
};

type LinkedInstallerLocation = {
  quantity: number;
  warehouse_id: string;
  warehouse_name?: string;
  zone_id?: string;
  zone_name?: string;
  rack_id?: string;
  rack_name?: string;
  bin_id?: string;
  bin_name?: string;
};

const libraries: Array<"places"> = ["places"];
const apiKey: string = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

const mapContainerStyle = {
  width: "100%",
  height: "350px",
  borderRadius: "12px",
  overflow: "hidden",
  // boxShadow: "0 0 10px rgba(0,0,0,0.1)", // Soft shadow
  // border: "1px solid #dee2e6",          // Light border
};

const center = {
  lat: 40.712776, // Default latitude (e.g., New York City)
  lng: -74.005974, // Default longitude
};

// Pagination constants for AsyncPaginate
const PAGE_SIZE = 10;

/** Hide arrow when disabled */
const DropdownIndicator = (props: any) => {
  if (props.selectProps.isDisabled) return null;
  return (
    <components.DropdownIndicator {...props}>
      <i className="ri-arrow-down-s-line fs-5" style={{ color: "#6c757d" }} />
    </components.DropdownIndicator>
  );
};

const customSelectStyles = {
  /* hide all indicators when disabled */
  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    display: state.isDisabled ? "none" : "flex",
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    display: state.isDisabled ? "none" : "flex",
  }),
  indicatorSeparator: () => ({ display: "none" }),

  /* keep bg and cursor right; do NOT fade */
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isDisabled ? "#f2f2f2" : provided.backgroundColor,
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    opacity: 1,
  }),

  /* ——— make text BLACK when disabled ——— */
  singleValue: (provided: any, state: any) => ({
    ...provided,
    color: state.isDisabled ? "#000" : provided.color,
  }),
  valueContainer: (provided: any, state: any) => ({
    ...provided,
    color: state.isDisabled ? "#000" : provided.color,
  }),
  input: (provided: any, state: any) => ({
    ...provided,
    color: state.isDisabled ? "#000" : provided.color,
    WebkitTextFillColor: state.isDisabled ? "#000" : undefined, // Safari
  }),
  placeholder: (provided: any, state: any) => ({
    ...provided,
    /* if field has no value, keep placeholder readable too */
    color: state.isDisabled ? "#000" : provided.color,
  }),

  /* if you ever use isMulti, keep chips readable */
  multiValue: (p: any, s: any) => ({
    ...p,
    backgroundColor: s.isDisabled ? "#e5e7eb" : p.backgroundColor,
  }),
  multiValueLabel: (p: any, s: any) => ({
    ...p,
    color: s.isDisabled ? "#000" : p.color,
  }),
  multiValueRemove: (p: any, s: any) => ({
    ...p,
    display: s.isDisabled ? "none" : p.display,
  }),
};

type Order = any; // keep loose to be drop-in with your current shape
type TimelineItem = {
  type: string;
  subtitle: React.ReactNode | string;
  at: string | number | Date;
  by?: string;
};

type Props = {
  order: Order | null | undefined;

  // header actions
  onBack: () => void;
  onDownloadInvoice: () => void;
  onOrderStatus: (status: number) => void;

  // order log
  timelineItems: TimelineItem[];
  colors: string[];
  parseDate: (d: any) => string;

  // OPTIONAL plug-in area for your PaymentPanel + Stripe block
  rightTopPanel?: React.ReactNode;

  // product table helpers (optional; we'll fall back gracefully)
  baseUrl?: string; // e.g., process.env.REACT_APP_BASE_URL

  // Dynamic routing support
  baseRoute?: string; // e.g., "/signage", "/realtor", "/teammember", "/signageteammember", "/agent"
};

/** Same pattern as SalesOrderDetails `buildYourOrderReadyEmailParams`, but installation order + /installationsummary URL. */
async function buildInstallationYourOrderReadyEmailParams(order: any, token: string) {
  const baseUrl = (
    process.env.REACT_APP_BASE_URL ||
    (typeof window !== "undefined" ? window.location.origin : "") ||
    ""
  ).replace(/\/+$/, "");
  const orderIdForPay = String(order?._id || order?.id || "").trim();
  const items = Array.isArray(order?.line_items) ? order.line_items : [];
  const firstOrderItem = items[0] || {};
  const orderReadyItemName = String(firstOrderItem?.product_name || "Installation Service");
  const orderReadyQty = String(firstOrderItem?.quantity || 1);
  const orderReadyTotal = `$${Number(order?.total_amount || 0).toFixed(2)}`;
  const customerName = buildOrderReadyCustomerDisplayName(order);

  let projectIdFromQuery = String(order?.project_id || "").trim();
  let accessProjectIdForPay = projectIdFromQuery;
  let accessTokenForPay = "";
  const payUserIdForStripeLinks =
    String(order?.seller_org_id || "").trim() ||
    resolveInstallationSellerOrganizationId(
      String(order?.signage_id || "").trim() || null,
      order
    );

  if (token && projectIdFromQuery) {
    try {
      const { fetchProjectPublicAccess } = await import("components/proejctsandquoteapicalls");
      const accessRes = await fetchProjectPublicAccess(token, projectIdFromQuery);
      const accessData: any = (accessRes as any)?.data || {};
      const rawAccess: any = accessRes as any;
      accessProjectIdForPay = String(
        accessData.project_id ||
        accessData.projectId ||
        rawAccess?.project_id ||
        projectIdFromQuery ||
        ""
      ).trim();
      accessTokenForPay = String(
        accessData.access_token ||
        accessData.accessToken ||
        rawAccess?.access_token ||
        rawAccess?.accessToken ||
        ""
      ).trim();
      const publicUrlValue = String(
        accessData.public_url || accessData.publicUrl || rawAccess?.public_url || ""
      ).trim();
      if (!accessTokenForPay && publicUrlValue) {
        try {
          const parsed = publicUrlValue.startsWith("http")
            ? new URL(publicUrlValue)
            : new URL(publicUrlValue, window.location.origin);
          accessTokenForPay = String(
            parsed.searchParams.get("access_token") || parsed.searchParams.get("token") || ""
          ).trim();
        } catch {
          /* ignore */
        }
      }
    } catch (e) {
      safeConsole.warn("fetchProjectPublicAccess (installation order summary email):", e);
    }
  }

  let viewPayUrl = `${baseUrl}/installationsummary?project_id=${encodeURIComponent(accessProjectIdForPay)}&order_id=${encodeURIComponent(orderIdForPay)}&access_token=${encodeURIComponent(accessTokenForPay)}${payUserIdForStripeLinks ? `&supplier_id=${encodeURIComponent(payUserIdForStripeLinks)}` : ""
    }`;

  try {
    const { createStripePaymentIntent, fetchPaymentGatewaysCreatedByUserId } = await import(
      "components/proejctsandquoteapicalls"
    );
    const payUserId = payUserIdForStripeLinks;
    const orderTotal = Number(order?.total_amount || 0);
    const amountCents = Math.max(0, Math.round(orderTotal * 100));
    let stripeClientSecret = "";
    if (token && payUserId && amountCents > 0) {
      const pi = await createStripePaymentIntent(token, payUserId, {
        amount: amountCents,
        currency: "usd",
      });
      stripeClientSecret = String((pi as any)?.client_secret || (pi as any)?.clientSecret || "").trim();
    }
    let stripePublishableKeyForUrl = "";
    if (token && payUserId) {
      const gateways = await fetchPaymentGatewaysCreatedByUserId(token, payUserId);
      const stripeGw = gateways.find((g: any) => String(g?.gateway || "").toLowerCase() === "stripe");
      stripePublishableKeyForUrl = String(stripeGw?.publishable_key || "").trim();
    }
    const withClientSecret = (u: string) => {
      if (!stripeClientSecret || !u) return u;
      const sep = u.includes("?") ? "&" : "?";
      return `${u}${sep}client_secret=${encodeURIComponent(stripeClientSecret)}`;
    };
    const withPublishableKey = (u: string) => {
      if (!stripePublishableKeyForUrl || !u) return u;
      const sep = u.includes("?") ? "&" : "?";
      return `${u}${sep}publishable_key=${encodeURIComponent(stripePublishableKeyForUrl)}`;
    };
    viewPayUrl = withPublishableKey(withClientSecret(viewPayUrl));
  } catch (e) {
    safeConsole.warn("Stripe helpers (installation order summary email):", e);
  }

  const { alreadyPaid, remainingBalance } = formatOrderReadyPaymentDisplay(order);

  return {
    customerName,
    orderReadyItemName,
    orderReadyQty,
    orderReadyTotal,
    alreadyPaid,
    remainingBalance,
    publicViewPayUrl: viewPayUrl,
    lineItems: buildOrderReadyLineItemsHtml(items),
    addressFieldRow: buildOrderReadyAddressFieldRowHtml(
      "Installation Address",
      order?.installation_details?.installation_address ||
        order?.shipping_address ||
        order?.shippingAddress
    ),
    email_signature_display_name: String(order?.signage_company_name || "").trim(),
  };
}

/** Discount fields for installation order PATCH — API requires amount > 0 when code is set. */
function getSubmitInstallationDiscount(values: any): {
  code: string;
  amount: number;
  scope: InstallationDiscountScope;
} {
  const scope = inferInstallationDiscountScope({
    discountAppliesTo: values?.discount_applies_to,
    discountCode: values?.discount_code,
    discountAmount: values?.discount_amount,
    productDiscountAmount: values?.product_discount_amount,
    lineItems: values?.resolved_line_items,
  });
  const code = String(values?.discount_code ?? "").trim();
  const amount = Math.max(
    0,
    Number(values?.discount_amount ?? values?.discount ?? 0) ||
      Number(values?.product_discount_amount ?? 0)
  );
  return { code, amount, scope };
}

const SignageInstallationWorkOrder = () => {
  const mapRef = useRef<google.maps.Map | null>(null);
  const { installationId } = useParams<{ installationId: string }>();
  const location = useLocation();
  const type = location.state?.type ?? "View"; // 
  const mode = (type || "View").toLowerCase() as "view" | "edit";
  const isEdit = mode === "edit";
  const isSignageTeammember = location.pathname.includes('/signageteammember');
  const baseRoute = isSignageTeammember ? '/signageteammember' : '/signage';
  const token = getAuthCookie("sessionToken");
  const getInstallationSendLogOrderId = (order: any) =>
    String(order?.id || order?._id || order?.order_id || "").trim();
  const userName = getAuthCookie("userName");
  const licenseType = getAuthCookie("licenseType");
  const organizationId = getAuthCookie("organizationId");
  const sessionMembershipId = getAuthCookie("membershipId");
  const membershipId = sessionMembershipId || "";
  const globalUserId = getAuthCookie("globalUserId") || "";
  // Legacy userId cookie removed — actor/self uses membershipId; seller scope uses organizationId.
  const userId = membershipId;
  const projectIdFromQuery = useMemo(
    () => new URLSearchParams(location.search).get("project_id") || "",
    [location.search]
  );
  const [linkedProjectId, setLinkedProjectId] = useState<string | null>(null);
  const [linkedProjectNumber, setLinkedProjectNumber] = useState<string | null>(null);
  const userClearedProjectRef = React.useRef(false);
  /** After user applies/clears coupon in edit, ignore saved order discount in breakdown + payload UI */
  const [discountUserTouched, setDiscountUserTouched] = useState(false);
  const latestDiscountCodeRef = React.useRef("");

  const getInstallationLineTaxAmount = React.useCallback((line: any) => {
    return Number(
      line?.item_tax_info?.total_product_tax_amount ??
      line?.tax_amount ??
      0
    );
  }, []);

  // Refs to track what has been fetched to prevent duplicate calls
  const addressesFetchedRef = useRef<Set<string>>(new Set());
  const productsFetchedRef = useRef<Set<string>>(new Set());

  // State for parent signage firm (for signageteammember login)
  const effectiveSignageOrgId = organizationId || "";
  const effectiveSignageOrgName = userName || "";
  const signageId = effectiveSignageOrgId;
  // const [brokerageFirms, setBrokerageFirms] = useState<License[]>([]);
  const [teamMembers, setTeamMembers] = useState<any[]>([]);
  const [selectedTeamMember, setSelectedTeamMember] = useState<any | null>(null);
  const [installer, setInstaller] = useState<any[]>([]);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [offices, setOffices] = useState<Office[]>([]);
  const [officeAgents, setOfficeAgents] = useState<Agent[]>([]);
  const [preview, setPreview] = useState<string | null>(null);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [showReportTaxConfirmModal, setShowReportTaxConfirmModal] = useState(false);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [quantity, setQuantity] = useState(1);
  const [addressObjects, setAddressObjects] = useState<any[]>([]);
  const [showAllocateModal, setShowAllocateModal] = useState(false);
  const [showViewInventoryModal, setShowViewInventoryModal] = useState(false);
  const [installationOrder, setInstallationOrder] = useState<any>();
  const [approvedMessageData, setApprovedMessageData] = useState<any>(null);
  const [hasApprovedMessage, setHasApprovedMessage] = useState(false);
  const [quoteModeEnabled, setQuoteModeEnabled] = useState(false);

  useEffect(() => {
    const orgId = String(organizationId || "").trim();
    if (!orgId) {
      setQuoteModeEnabled(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await fetchPublicOrderQuoteModeSetting(orgId);
        if (!cancelled) setQuoteModeEnabled(Boolean(res.enabled));
      } catch {
        if (!cancelled) setQuoteModeEnabled(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [organizationId]);

  useEffect(() => {
    if (userClearedProjectRef.current) return;
    const pid = (installationOrder as any)?.project_id;
    if (pid) {
      setLinkedProjectId(String(pid));
      const pnum = (installationOrder as any)?.project_number;
      if (pnum != null && pnum !== "") setLinkedProjectNumber(String(pnum));
      return;
    }
    if (projectIdFromQuery) setLinkedProjectId(projectIdFromQuery);
  }, [installationOrder?._id, (installationOrder as any)?.project_id, projectIdFromQuery]);

  useEffect(() => {
    let cancelled = false;
    const pid = String(linkedProjectId || "").trim();
    if (!token || !pid) {
      setHasApprovedMessage(false);
      setApprovedMessageData(null);
      return;
    }
    (async () => {
      try {
        const approved = await fetchProjectApprovedMessage(token, pid);
        if (cancelled) return;
        const hasMessage = Boolean(approved?.has_approved_message);
        setHasApprovedMessage(hasMessage);
        setApprovedMessageData(hasMessage ? approved?.data ?? null : null);
      } catch {
        if (cancelled) return;
        setHasApprovedMessage(false);
        setApprovedMessageData(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [linkedProjectId, token]);

  const hasProjectIdForSendQuote = useMemo(() => {
    const raw = (installationOrder as any)?.project_id;
    let fromOrder = "";
    if (raw != null && raw !== "") {
      if (typeof raw === "object" && raw.$oid != null) fromOrder = String(raw.$oid).trim();
      else {
        fromOrder = String(raw).trim();
        if (fromOrder === "[object Object]") fromOrder = "";
      }
    }
    if (fromOrder) return true;
    if (String(projectIdFromQuery || "").trim()) return true;
    const l = String(linkedProjectId || "").trim();
    return Boolean(l && l !== "[object Object]");
  }, [installationOrder, projectIdFromQuery, linkedProjectId]);

  // ✅ Track initial form values to detect changes
  const initialFormValuesRef = React.useRef<any>(null);

  const [productObjs, setProductObjs] = useState<ProductObj[]>([]);
  const [productPerItemDiscountMap, setProductPerItemDiscountMap] = React.useState<Record<string, number>>({});
  const getCurrentProductLineDiscountAmount = React.useCallback(
    (productId: string, variantId: string, sourceProductId?: string | null) => {
      const exact = round2(
        getProductLineDiscountAmount(
          {
            product_id: productId,
            variant_id: variantId,
          },
          productPerItemDiscountMap,
          []
        )
      );
      if (exact > 0) return exact;

      const prefixes = [
        `${String(productId)}:`,
        sourceProductId ? `${String(sourceProductId)}:` : "",
      ].filter(Boolean);

      const fallbackEntry = Object.entries(productPerItemDiscountMap || {}).find(([key, value]) =>
        prefixes.some((prefix) => key.startsWith(prefix)) && Number(value || 0) > 0
      );
      return fallbackEntry ? round2(Number(fallbackEntry[1] || 0)) : 0;
    },
    [productPerItemDiscountMap]
  );
  const [selectedProductOption, setSelectedProductOption] = useState<any | null>(null);
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [installationPost, setInstallationPost] = useState<InstallationPostPayload | null>(null);
  const [customProductSettingEnabled, setCustomProductSettingEnabled] = useState(false);
  const postTypeConfigRef = React.useRef<PostTypeSignConfigurationRef | null>(null);
  const normalizeProductDiscountMap = React.useCallback(
    (perItemMap?: Record<string, number> | null) => {
      const source = perItemMap || {};
      const normalized: Record<string, number> = { ...source };
      const orderLineItems = Array.isArray(installationOrder?.line_items) ? installationOrder.line_items : [];

      for (const product of selectedProducts || []) {
        const productId = String(product?.product_id ?? "");
        const sourceProductId = String(product?.source_product_id ?? "");
        if (!productId) continue;

        const originalLine = orderLineItems.find(
          (li: any) =>
            String(li?.product_id ?? "") === productId &&
            String(li?.inventory_source ?? "") !== "rotational"
        );
        const resolvedVariantId = String(
          originalLine?.variant_id ?? product?.variant_id ?? ""
        );
        if (!resolvedVariantId) continue;

        const exactKey = `${productId}:${resolvedVariantId}`;
        if (normalized[exactKey] != null) continue;

        const fallbackEntry = Object.entries(source).find(([key, value]) =>
          (`${key}`.startsWith(`${productId}:`) ||
            (sourceProductId && `${key}`.startsWith(`${sourceProductId}:`))) &&
          Number(value || 0) > 0
        );
        if (fallbackEntry) {
          normalized[exactKey] = round2(Number(fallbackEntry[1] || 0));
        }
      }

      return normalized;
    },
    [installationOrder?.line_items, selectedProducts]
  );
  const buildResolvedProductDiscountMap = React.useCallback(
    (
      rows: Array<{
        key: string;
        productId: string;
        variantId: string;
        sourceProductId?: string | null;
        quantity: number;
      }>,
      totalDiscount: number
    ) => {
      const normalizedTotalDiscount = round2(Number(totalDiscount || 0));
      if (normalizedTotalDiscount <= 0 || rows.length === 0) {
        return Object.fromEntries(rows.map((row) => [row.key, 0])) as Record<string, number>;
      }

      const mapped: Record<string, number> = {};
      let mappedTotal = 0;

      for (const row of rows) {
        const amount = getCurrentProductLineDiscountAmount(
          row.productId,
          row.variantId,
          row.sourceProductId
        );
        mapped[row.key] = round2(amount);
        mappedTotal += round2(amount);
      }

      mappedTotal = round2(mappedTotal);
      if (mappedTotal >= normalizedTotalDiscount) {
        return mapped;
      }

      const zeroRows = rows.filter((row) => Number(mapped[row.key] || 0) <= 0);
      if (zeroRows.length === 0) {
        return mapped;
      }

      const remainder = round2(normalizedTotalDiscount - mappedTotal);
      const fallback = resolveLineDiscountMap(
        zeroRows.map((row) => ({ key: row.key, quantity: row.quantity })),
        remainder,
        null
      );

      for (const row of zeroRows) {
        mapped[row.key] = round2(
          Number(mapped[row.key] || 0) + Number(fallback[row.key] || 0)
        );
      }

      return mapped;
    },
    [getCurrentProductLineDiscountAmount]
  );
  const liveProductDiscountMapTotal = React.useMemo(
    () =>
      round2(
        Object.values(productPerItemDiscountMap || {}).reduce(
          (sum, value) => sum + Number(value || 0),
          0
        )
      ),
    [productPerItemDiscountMap]
  );
  const [installationCost, setInstallationCost] = useState<number | null>(null);
  const installationCostRef = React.useRef<number | null>(null);
  const triggerRecomputeWithRef = React.useRef<
    (override?: {
      fees?: any[];
      destination?: any;
      discountCode?: string;
      installationCost?: number;
    }) => void
  >(() => {});

  React.useEffect(() => {
    installationCostRef.current = installationCost;
  }, [installationCost]);
  const [isEditingInstallationCost, setIsEditingInstallationCost] = useState(false);
  const [manualInstallationCost, setManualInstallationCost] = useState("");
  const [scheduledJobsCount, setScheduledJobsCount] = useState<number | null>(null);
  const [totalUnits, setTotalUnits] = useState<number>(0);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [uploadedFileMeta, setUploadedFileMeta] = useState<any[]>([]);
  const proofUploadHandlerRef = useRef<(() => Promise<void>) | null>(null);
  const [imagePreviews, setImagePreviews] = useState<string[]>([]);
  const [previewFiles, setPreviewFiles] = useState<{ file: File; url: string }[]>([]);
  const [openStatusIndex, setOpenStatusIndex] = useState<number | null>(null);
  const [openProductStatusIndex, setOpenProductStatusIndex] = useState<number | null>(null);
  const [installationLocations, setInstallationLocations] = useState<any[]>([]);
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod[]>([]);
  const [payment, setPayment] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<{ name: string; _id: string } | null>(null);
  const [rotationalPoolProducts, setRotationalPoolProducts] = useState<any[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<any | null>(null);
  const [warehouseOptions, setWarehouseOptions] = useState<any[]>([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState<any | null>(null);
  const [availableSerializedUnits, setAvailableSerializedUnits] = useState<any[]>([]);
  const [clientSecret, setClientSecret] = useState<string | "">();
  const [allocatedUnits, setAllocatedUnits] = useState<{
    [linkedProductId: string]: {
      rotationalProductId: string;
      warehouseId: string;
      serial_id: string;
      serial_number: string;
      product_name: string;
      sku: string;
      storage_location: {
        warehouse_id: string;
        warehouse: string;
        zone_id: string;
        zone: string;
        rack_id: string;
        rack: string;
        bin_id: string;
        bin: string;
      };
    }[];
  }>({});

  // ✅ State for selected special fees (bypasses Formik timing issues)
  const [selectedSpecialFees, setSelectedSpecialFees] = useState<any[]>([]);
  const [allAvailableSpecialFees, setAllAvailableSpecialFees] = useState<any[]>([]);
  const [isRecomputing, setIsRecomputing] = useState(false);

  const canEditProof = [400, 500, 600].includes(installationOrder?.status);

  const [linkedProductIdContext, setLinkedProductIdContext] = useState<string | null>(null);
  const [instructions, setInstructions] = useState<string>("");
  /** Presigned URLs for instruction attachment file_ids (`installationOrder.uploaded_files`). */
  const [instructionFileUrlMap, setInstructionFileUrlMap] = useState<Record<string, string>>({});

  const navigate = useNavigate();
  const safeNavigate = createSafeNavigate(navigate);

  const [orderSummarySending, setOrderSummarySending] = useState(false);
  const [emailRecipientsModal, setEmailRecipientsModal] = useState<null | "quote" | "invoice">(null);

  /** Quote mode: send “Your order is ready” email; success toast only (no order summary preview). */
  const handleInstallationSendQuoteClick = React.useCallback(async (additionalEmails: string[] = []) => {
    if (!installationOrder || orderSummarySending) return;
    const cust = String(installationOrder?.customer_email || "").trim();
    const userEm = String(installationOrder?.user_email || "").trim();
    const teamMemberEmail = resolveInstallationBrokerageTeamMemberEmail(installationOrder);
    const primaryEmail =
      teamMemberEmail && cust && userEm && cust.toLowerCase() !== userEm.toLowerCase()
        ? cust
        : String(userEm || cust || "").trim();
    if (!primaryEmail) {
      showError("No customer email on this order; cannot send the order summary email.");
      return;
    }
    if (!token) {
      showError("Session expired. Please sign in again.");
      return;
    }
    setOrderSummarySending(true);
    try {
      await new Promise<void>((r) => requestAnimationFrame(() => requestAnimationFrame(() => r())));
      const installationOrderId = String(
        installationOrder?._id || installationOrder?.id || ""
      ).trim();
      if (!installationOrderId) {
        showError("Missing installation order id. Email was not sent.");
        return;
      }
      const safeNum = String(
        installationOrder.order_number || installationOrder._id || installationOrder.id || "order"
      ).replace(/[^\w.-]+/g, "_");
      const pdfAttachment = await buildInstallationOrderPdfAttachment({
        installationOrderId,
        token,
        fileLabel: safeNum,
      });
      if (!pdfAttachment) {
        showError("Could not fetch installation order PDF. Email was not sent.");
        return;
      }
      const p = await buildInstallationYourOrderReadyEmailParams(installationOrder, token);
      const licenseTypes: string[] = ["AGENT"];
      const recipients: string[] = [primaryEmail];
      if (
        teamMemberEmail &&
        teamMemberEmail.toLowerCase() !== primaryEmail.toLowerCase()
      ) {
        licenseTypes.push("BROKERAGE_TEAM_MEMBER");
        recipients.push(teamMemberEmail);
      }
      const merged = appendAdditionalRecipientEmails(
        recipients,
        licenseTypes,
        additionalEmails
      );
      const sendQuoteTrigger = await resolveSendQuoteEmailTrigger(
        "installation",
        installationOrder
      );
      await sendTriggerEmails(
        sendQuoteTrigger,
        merged.licenseTypes,
        {
          customerName: p.customerName,
          orderId: String(
            installationOrder.order_number || installationOrder._id || installationOrder.id || ""
          ),
          quantity: p.orderReadyQty,
          totalDue: p.orderReadyTotal,
          alreadyPaid: p.alreadyPaid,
          remainingBalance: p.remainingBalance,
          viewPayUrl: p.publicViewPayUrl,
          lineItems: p.lineItems,
          addressFieldRow: p.addressFieldRow,
          email_signature_display_name: p.email_signature_display_name,
        },
        merged.emails,
        process.env.REACT_APP_FROM_EMAIL2 || "",
        token,
        pdfAttachment
      );
      const sendLogOrderId = getInstallationSendLogOrderId(installationOrder);
      if (sendLogOrderId) {
        try {
          await createSendLogEntry({
            orderType: "installation_orders",
            orderId: sendLogOrderId,
            type: "quote",
            token,
          });
        } catch (e) {
          safeConsole.warn("[SignageInstallationWorkOrder] send-log quote failed:", e);
        }
      }
      showSuccess("Quote sent successfully.");
    } catch (e) {
      showError(e instanceof Error ? e.message : "Failed to send order summary email.");
    } finally {
      setOrderSummarySending(false);
    }
  }, [installationOrder, orderSummarySending, token]);

  /** Non–quote mode: open order summary preview only (no email). */
  const handleInstallationOrderSummaryPreviewClick = React.useCallback(() => {
    if (!installationOrder) return;
    const br = baseRoute || "/signage";
    const orderForPreview = {
      ...installationOrder,
      order_type: "installation",
      signage_id:
        installationOrder?.signage_id ??
        installationOrder?.seller_owner_node_id ??
        organizationId ??
        "",
    };
    try {
      sessionStorage.setItem(
        "orderSummaryPrivatePreview",
        JSON.stringify({
          privateOrderSummaryPreview: true,
          order: orderForPreview,
          ts: Date.now(),
        })
      );
    } catch {
      /* ignore */
    }
    safeNavigate(`${br}/OrderSummary`, {
      state: {
        privateOrderSummaryPreview: true,
        order: orderForPreview,
      },
    });
  }, [installationOrder, baseRoute, safeNavigate, organizationId]);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: apiKey,
    libraries,
  });

  const [selectedLocation, setSelectedLocation] = useState<{
    lat: number;
    lng: number;
  } | null>(null);
  const installationTaxRef = React.useRef<InstallationTaxEngineHandle | null>(null);

  const [selectedBrokerageFirm, setSelectedBrokerageFirm] = useState<Selected | null>(null);

  const [selectedOffice, setSelectedOffice] = useState<Selected | null>(null);

  const [selectedOfficeAgent, setSelectedOfficeAgent] = useState<Selected | null>(null);

  const [selectedInstaller, setSelectedInstaller] = useState<Selected | null>(null);

  const [selectedAgent, setSelectedAgent] = useState<Selected | null>(null);

  // AsyncPaginate state for team members and installers
  const [selectedTeamMemberOption, setSelectedTeamMemberOption] = useState<TeamMemberOption | null>(null);
  const [selectedInstallerOption, setSelectedInstallerOption] = useState<SignageTeamMemberOption | null>(null);

  const [selectedBillingAddress, setSelectedBillingAddress] =
    useState<Addresses | null>(null);
  const [selectedOfficeBillingAddress, setSelectedOfficeBillingAddress] =
    useState<Addresses | null>(null);

  const [installationAddress, setInstallationAddress] = useState<Addresses>();
  const [zeroOrNegativeMsg, setZeroOrNegativeMsg] = React.useState<string>("");
  const [dynamicCostId, setDynamicCostId] = React.useState<string>("");
  const [dynamicTaxable, setDynamicTaxable] = React.useState<boolean>(false);
  const [showTaxDetails, setShowTaxDetails] = useState(false);
  // Tax type + live tax workflow state
  const [taxType, setTaxType] = useState<"manual" | "taxcloud" | "unknown">("unknown");
  const [liveTaxLoading, setLiveTaxLoading] = useState(false);
  const skipLiveTaxNavigateRef = React.useRef(false);
  const [liveTaxReady, setLiveTaxReady] = useState(false);
  const [taxCartId, setTaxCartId] = useState<string | undefined>(undefined);
  const [ordernumber, setOrderNumber] = useState<string | null>(null);
  const lastResolvedInstallationRef = useRef<ResolvedInstallationOrder | null>(null);

  const handlePaymentMethodSelect = React.useCallback(
    (method: { name: string; _id: string }) => {
      setSelectedPaymentMethod(method);
    },
    []
  );

  const buyerOptions: { value: string; label: string }[] = [
    { value: "brokerageFirm", label: "Brokerage Firm" },
    { value: "agent", label: "Agent" },
  ];

  const teamMemberOptions = teamMembers?.map((member) => ({
    value: member.id,
    label: `${member.firstName} ${member.lastName}`,
    email: member.email,
  }));

  const officeOptions = offices?.map((office) => ({
    value: office?._id,
    label: office?.officeName,
    firstName: office?.officeName,
    lastName: office?.officeName,
    email: "",
    phone: office?.officeAddress?.[0]?.phone,
  }));

  const officeAgentOptions = officeAgents?.map((agent) => ({
    value: agent.id,
    label: agent.firstName + " " + agent.lastName,
    firstName: agent.firstName,
    lastName: agent.lastName,
    email: agent.email,
    phone: agent.phone1,
  }));

  // Removed agentOptions - now using AsyncPaginate

  const productOptions = productObjs?.map((item) => ({
    value: item.product_id,
    label: item.product.name,
  }));

  const priorityOptions = [
    { value: 1, label: "High" },
    { value: 2, label: "Medium" },
    { value: 3, label: "Low" },
  ];
  const [pickerOpen, setPickerOpen] = useState(false);
  const closePicker = () => setPickerOpen(false);
  const [manualUnitPriceMap, setManualUnitPriceMap] = useState<Record<string, number>>({});
  const [couponInput, setCouponInput] = useState("");
  const [couponResolveError, setCouponResolveError] = useState("");

  const keyForInstallationProduct = (p: { product_id: string; variant_id?: string }) =>
    `${p.product_id}:${p.variant_id ?? ""}`;

  const getBaseUnitPriceForInstallation = useCallback(
    (p: { product_id: string; variant_id?: string; unit_price?: number; unit_retail_price?: number }) => {
      const savedRetail = Number(p.unit_retail_price ?? 0);
      if (savedRetail > 0) return savedRetail;
      return Number(p.unit_price ?? 0);
    },
    []
  );

  const getUnitRetailPriceForPayload = useCallback(
    (p: { product_id: string; variant_id?: string; unit_price?: number; unit_retail_price?: number }) => {
      const key = keyForInstallationProduct(p);
      if (manualUnitPriceMap[key] !== undefined) return Number(manualUnitPriceMap[key] || 0);
      return getBaseUnitPriceForInstallation(p);
    },
    [manualUnitPriceMap, getBaseUnitPriceForInstallation]
  );

  const getChangedUnitPriceForInstallation = useCallback(
    (p: { product_id: string; variant_id?: string; unit_price?: number; changed_unit_price?: number }) => {
      const key = keyForInstallationProduct(p);
      const resolved =
        (lastResolvedInstallationRef.current?.line_items || []).find(
          (li) => orderLineKey(li.product_id, li.variant_id) === key
        ) ??
        (installationOrder?.line_items || []).find((li: any) => {
          const pid = String(li?.product_id ?? "");
          return pid === String(p.product_id) && String(li?.variant_id ?? "") === String(p.variant_id ?? "");
        });
      return Number(
        manualUnitPriceMap[key] ??
          (resolved as { changed_unit_price?: number })?.changed_unit_price ??
          p.changed_unit_price ??
          p.unit_price ??
          0
      );
    },
    [manualUnitPriceMap, installationOrder?.line_items]
  );

  const isPurchasedInstallationLine = (product: any) => {
    const inventorySource = String(product?.inventory_type || product?.inventory_source || "").trim().toLowerCase();
    return (
      Boolean(product?.is_new_purchase) ||
      Boolean(product?.is_new_catalog) ||
      inventorySource === "custom"
    );
  };

  const rows = useMemo(
    () => selectedProducts.filter((p) => p.inventory_type !== "rotational" && p.inventory_type !== ""),
    [selectedProducts]
  );

  /** Stable list for PostTypeSignConfiguration view mode; avoids "Maximum update depth" from new array ref every render */
  const viewModeLineItemsForPost = useMemo(
    () =>
      selectedProducts
        ?.filter((p) => p.inventory_type !== "rotational" && p.inventory_type !== "")
        ?.map((p) => ({
          slot_id: p.slot_id,
          is_accessory: !!(p.is_accessory ?? p.is_accessories),
          images: p.images || [],
        })) ?? [],
    [selectedProducts]
  );

  const editModeHydrationProducts = useMemo(
    () =>
      selectedProducts
        ?.filter((p) => p.inventory_type !== "rotational" && p.inventory_type !== "")
        ?.map((p) => ({
          slot_id: p.slot_id,
          slotKey: p.slotKey,
          is_accessory: !!(p.is_accessory ?? p.is_accessories),
          product_id: String(p.product_id ?? ""),
          name: p.name,
          sku: p.sku,
          variant_id: p.variant_id,
          images: p.images,
          image_url: p.image_url,
        }))
        ?.filter((p) => p.product_id) ?? [],
    [selectedProducts]
  );

  /** Current selection for Avl Qty consumption in ProductSelectionModal. */
  const selectedStockLines = useMemo(
    () =>
      (selectedProducts || [])
        .map((p) => {
          const product_id = String(p.product_id ?? "").trim();
          if (!product_id) return null;
          const src = String(p.inventory_type || p.inventory_source || "").toLowerCase();
          if (src === "custom" || src === "rotational") return null;
          return {
            product_id,
            variant_id: p.variant_id != null ? String(p.variant_id).trim() : "",
            quantity: Number(p.quantity) || 1,
          };
        })
        .filter(Boolean) as Array<{ product_id: string; variant_id?: string; quantity: number }>,
    [selectedProducts]
  );

  /**
   * Original order line qtys (edit mode). API available often excludes stock already
   * on this order; baseline returns that qty to Avl when the user removes a line.
   */
  const baselineStockLines = useMemo(() => {
    const toId = (raw: any) => {
      if (raw == null) return "";
      if (typeof raw === "object") return String(raw.$oid || raw.toString?.() || "").trim();
      return String(raw).trim();
    };
    return (installationOrder?.line_items || [])
      .map((li: any) => {
        const product_id = toId(li?.product_id);
        if (!product_id) return null;
        const src = String(li?.inventory_source || li?.inventory_type || "").toLowerCase();
        if (src === "custom" || src === "rotational") return null;
        return {
          product_id,
          variant_id: toId(li?.variant_id),
          quantity: Number(li?.quantity) || 1,
        };
      })
      .filter(Boolean) as Array<{ product_id: string; variant_id?: string; quantity: number }>;
  }, [installationOrder?.line_items]);

  const imageUrlMap = useVariantImageUrlMap(selectedProducts, token);

  /** Work-drive / Mongo file ids in `line_items[].customizations.fields` — presign via useVariantImageUrlMap (same as SignageAddInstallation). */
  const customizationWorkDriveFileIds = useMemo(() => {
    const HEX = /^[a-f0-9]{24}$/i;
    const ids: string[] = [];
    for (const p of selectedProducts || []) {
      const block = getCustomizationsBlockFromLineItem(p);
      const fields = Array.isArray((block as { fields?: unknown[] })?.fields)
        ? ((block as { fields: unknown[] }).fields as Array<{ field_type?: string; value?: unknown }>)
        : [];
      for (const f of fields) {
        const t = String(f?.field_type || "").toLowerCase();
        const v = String(f?.value ?? "").trim();
        if ((t === "file" || t === "image") && v && HEX.test(v)) ids.push(v);
      }
    }
    return Array.from(new Set(ids));
  }, [selectedProducts]);

  const customizationImageUrlMapData = useMemo(
    () =>
      customizationWorkDriveFileIds.length === 0
        ? []
        : [{ product: { variants: [{ images: customizationWorkDriveFileIds.map((url) => ({ url })) }] } }],
    [customizationWorkDriveFileIds]
  );
  const customizationImageUrlMap = useVariantImageUrlMap(customizationImageUrlMapData as any, token);

  // near your other useState hooks
  const [lastTaxes, setLastTaxes] = React.useState<{
    productTaxAmount: number;
    productTaxPercentage: number;
    shippingTaxAmount: number;
    shippingTaxPercentage: number;
    specialFeeTaxAmount: number;
    specialFeeTaxPercentage: number;
    totalTaxAmount: number;
  } | null>(null);


  const updateProducts = (next: FlattenedProduct[]) => {
    setSelectedProducts(next);
    // onProductsChange?.(next);
  };

  const fetchAvailableQuantities = async (products: FlattenedProduct[]) => {
    if (!products || products.length === 0) return products;

    const productsNeedingQty = products.filter((p) => shouldShowAvailableQty(p));
    if (productsNeedingQty.length === 0) return products;

    let invSource: "agent" | "office" | null = null;
    let entityId = "";

    if (pickerUserType && pickerUserId) {
      invSource = pickerUserType;
      entityId = resolveInstallationInventoryEntityMembershipId({
        invSource: pickerUserType,
        agentOption: selectedOfficeAgent ?? selectedAgent,
        teamMemberOption: selectedTeamMemberOption,
        sessionMembershipIdFallback: sessionMembershipId,
      });
    } else if (installationOrder) {
      invSource =
        String(installationOrder.inventory_source || "").trim().toLowerCase() ===
        "office"
          ? "office"
          : "agent";
      entityId = resolveInstallationInventoryEntityMembershipId({
        order: installationOrder,
        sessionMembershipIdFallback: sessionMembershipId,
      });
    }

    if (!invSource || !entityId) {
      return products;
    }

    const productIds = productsNeedingQty.map((p) => p.product_id);

    const responses = await Promise.all(
      productIds.map(async (id) => {
        try {
          const parsed = await fetchInstallationInventoryProduct(
            token,
            invSource,
            entityId,
            id
          );
          return { id, available: Number(parsed?.available ?? 0) };
        } catch {
          return { id, available: null as number | null };
        }
      })
    );

    const byId = new Map<string, number>();
    for (const { id, available } of responses) {
      if (available != null) byId.set(id, available);
    }

    return products.map((p) => {
      if (!shouldShowAvailableQty(p)) return p;
      return {
        ...p,
        availableqty: byId.get(p.product_id) ?? p.availableqty ?? 0,
      };
    });
  };

  const handleAddFromPicker = async (flattened: FlattenedProduct) => {
    const hasSlotAssignment = Boolean(flattened.slotKey && flattened.slotKey !== "accessory");
    const isAccessoryAdd = flattened.slotKey === "accessory" || flattened.is_accessory;

    if (!hasSlotAssignment && !isAccessoryAdd) {
      const exists = selectedProducts.some((p) => p.product_id === flattened.product_id);
      if (exists) {
        showError?.("Product already added");
        return;
      }
    }

    let next: FlattenedProduct[];
    if (hasSlotAssignment) {
      next = selectedProducts.filter(
        (p) => p.slotKey !== flattened.slotKey && String(p.slot_id || "") !== String(flattened.slot_id || "")
      );
      next = [...next, { ...flattened, location: flattened.location || [] }];
    } else {
      next = [...selectedProducts, { ...flattened, location: flattened.location || [] }];
    }

    const productsWithAvailableQty = await fetchAvailableQuantities(next);
    updateProducts(productsWithAvailableQty);
    setPickerOpen(false);
  };

  const removeRow = (prodId: string) => {
    const item = selectedProducts.find((p) => p.product_id === prodId);
    if (item?.slotKey) {
      postTypeConfigRef.current?.clearSlot(item.slotKey);
    } else {
      postTypeConfigRef.current?.clearSlotByProductId(prodId);
    }
    const next = selectedProducts.filter((p) => p.product_id !== prodId);
    updateProducts(next);
  };

  const removeCustomProduct = (product: FlattenedProduct) => {
    const prodId = String(product.product_id ?? "");
    if (!prodId) return;

    const key = keyForInstallationProduct(product);
    setManualUnitPriceMap((prev) => {
      if (prev[key] === undefined) return prev;
      const next = { ...prev };
      delete next[key];
      return next;
    });

    const resolved = (
      (formik.values as { resolved_line_items?: ResolvedInstallationLineItem[] }).resolved_line_items || []
    ).filter((li) => orderLineKey(li.product_id, li.variant_id) !== key);
    formik.setFieldValue("resolved_line_items", resolved, false);

    const next = selectedProducts.filter((p) => String(p.product_id) !== prodId);
    updateProducts(next);
    triggerRecomputeWithRef.current?.();
  };
  const pickerUserType: "agent" | "office" | null =
    selectedOfficeAgent?.value || selectedAgent?.value
      ? "agent"
      : selectedOffice?.value
        ? "office"
        : null;

  const pickerUserId: string =
    selectedOfficeAgent?.value ||
    selectedAgent?.value ||
    selectedOffice?.value ||
    "";
  const pickerEndUserId: string | undefined =
    selectedOfficeAgent?.value ||
    selectedAgent?.value ||
    selectedTeamMemberOption?.value ||
    selectedTeamMember?.value ||
    undefined;
  const postTypeOrderContext = useMemo((): import("pages/signage/PostTypeSignConfiguration").PostTypeOrderEndUserContext | null => {
    const fromOpt = (opt: any, fallbackLicense: string) => {
      if (!opt) return null;
      const membershipId = String(
        opt.membershipId ?? opt.membership_id ?? opt.value ?? ""
      ).trim();
      if (!membershipId) return null;
      return {
        membershipId,
        licenseType: String(opt.license_type || fallbackLicense).trim(),
        globalUserId: String(opt.globalUserId ?? opt.global_user_id ?? "").trim() || undefined,
        organizationId: String(opt.organizationId ?? opt.organization_id ?? "").trim() || undefined,
      };
    };
    return (
      fromOpt(selectedOfficeAgent, "BROKERAGE_AGENT") ||
      fromOpt(selectedAgent, "AGENT") ||
      fromOpt(selectedTeamMemberOption, "BROKERAGE_TEAM_MEMBER")
    );
  }, [selectedOfficeAgent, selectedAgent, selectedTeamMemberOption]);
  const pickerSignageCompanyId: string = String(organizationId || "").trim();

  const handleSlotProductSelect = (product: LinkedProduct, slotKey: string, slotId?: string) => {
    const isLinked = product.linked_mode !== "catalog" && (product.inventory_source === "agent" || product.inventory_source === "office");
    const isNewCatalog = product.linked_mode === "catalog";
    const inventoryTypeForNew =
      isNewCatalog && pickerUserType
        ? pickerUserType === "agent"
          ? "agent"
          : "office"
        : product.inventory_source || "";
    const hasDesign = isMeaningfulObjectId(product.design_id);
    const previewId = String(product.preview_url ?? "").trim();
    const imageForRow =
      hasDesign && previewId ? previewId : product.images?.[0]?.url || "";
    const lineImages = imageForRow
      ? [{ url: imageForRow }]
      : normalizeInstallationLineItemImages(product.images);
    const flattened: FlattenedProduct = {
      product_id: product.product_id,
      name: product.name,
      sku: product.sku,
      inventory_type: inventoryTypeForNew,
      current_status: isNewCatalog ? "with_supplier" : product.current_status,
      availableqty: product.available_quantity ?? 0,
      quantity: 1,
      images: lineImages,
      image_url: imageForRow,
      location: product.location,
      is_accessory: slotKey === "accessory",
      ...(slotKey !== "accessory" ? { slotKey, slot_id: slotId ?? "" } : { slot_id: "" }),
      ...(isLinked && pickerUserId ? { user_id: pickerUserId } : {}),
      ...(product.variant_id ? { variant_id: String(product.variant_id).trim() } : {}),
      ...(isNewCatalog
        ? {
            is_new_catalog: true,
            is_new_purchase: true,
            source_product_id: product.product_id,
            variant_id: product.variant_id,
            unit_price: product.retail_price != null ? Number(product.retail_price) : undefined,
            is_taxable: Boolean((product as any).is_taxable ?? (product as any).taxable ?? (product as any)["product.is_taxable"]),
            ...(product.customizations ? { customizations: product.customizations } : {}),
          }
        : {}),
      ...(hasDesign
        ? {
            design_id: String(product.design_id ?? "").trim(),
            design_name: String(product.design_name ?? "").trim(),
            preview_url: previewId,
          }
        : {}),
    };
    void handleAddFromPicker(flattened);
  };

  const handleCustomItemAdd = async (data: {
    item_name: string;
    custom_info: string;
    price: string;
    quantity: string;
    taxable: boolean;
    length: string;
    height: string;
    width: string;
    weight: string;
  }) => {
    const t = token || "";
    if (!t) {
      showError("Session expired. Please log in again.");
      return;
    }
    try {
      const productId = await fetchNewUniqueId(t);
      const variantId = await fetchNewUniqueId(t);
      const qty = Math.max(1, parseInt(String(data.quantity), 10) || 1);
      const price = parseFloat(String(data.price)) || 0;
      const customProduct: FlattenedProduct = {
        product_id: productId,
        variant_id: variantId,
        name: String(data.item_name || "").trim() || "Custom Item",
        sku: `custom_sku_${productId}`,
        inventory_type: "custom",
        current_status: "with_supplier",
        availableqty: 0,
        quantity: qty,
        is_new_purchase: true,
        source_product_id: productId,
        unit_price: price,
        unit_retail_price: price,
        changed_unit_price: price,
        is_taxable: !!data.taxable,
        custom_information: String(data.custom_info || "").trim(),
      };
      updateProducts([...selectedProducts, customProduct]);
    } catch (err) {
      showError(err instanceof Error ? err.message : "Failed to add custom item");
      throw err;
    }
  };

  useEffect(() => {
    return () => {
      if (preview) URL.revokeObjectURL(preview);
    };
  }, [preview]);

  // ===== Types =====
  type Status = "on_site" | "with_supplier";

  type LinkedInstallerLocation = {
    quantity: number;
    warehouse_id: string;
    warehouse_name?: string;
    zone_id?: string;
    zone_name?: string;
    rack_id?: string;
    rack_name?: string;
    bin_id?: string;
    bin_name?: string;
  };

  type LinkedInstallerRow = {
    current_status: Status;                 // "on_site" | "with_supplier"
    product_location_status: string;        // mirror to result rows
    quantity?: number;                      // for bucket rows (no per-location)
    location?: LinkedInstallerLocation[];   // for per-location rows
  };

  type LinkedQuantityLocation = {
    quantity: number;
    current_status: Status;                 // EXACTLY "on_site" or "with_supplier"
    product_location_status: string;
    location?: Array<LinkedInstallerLocation & { quantity: number }>;
  };

  // ===== Helpers =====
  const fail = (msg: string): never => { showError(msg); throw new Error(msg); };

  function normalizeStatus(s: any): Status {
    const k = String(s || "").trim().toLowerCase();
    if (k === "on_site" || k === "on site" || k === "onsite") return "on_site";
    if (k === "with_supplier" || k === "with supplier" || k === "withsupplier") return "with_supplier";
    return "with_supplier";
  }

  const sumAll = (rows: LinkedInstallerRow[]) =>
    rows.reduce((t, r) => {
      if (r.location?.length) return t + r.location.reduce((s, l) => s + (Number(l.quantity) || 0), 0);
      return t + (Number(r.quantity) || 0);
    }, 0);

  const sumStorage = (items: LinkedQuantityLocation[] = []) =>
    items.reduce((t, r) => t + (Number(r.quantity) || 0), 0);

  function getLiRowsFromMatched(matched: any): LinkedInstallerRow[] {
    const rows: any[] = matched?.linked_installer_details?.storage_locations ?? [];
    if (!Array.isArray(rows) || rows.length === 0) {
      safeConsole.warn("[GET_ROWS] No storage_locations found in linked_installer_details");
      return [];
    }

    // console.log("[GET_ROWS] Processing rows:", rows.length);

    return rows.map((r, idx) => {
      const status = normalizeStatus(r.current_status);
      const hasLocsRaw = Array.isArray(r.location) && r.location.length > 0;

      // Force on_site to behave as bucket-only
      const hasLocs = status === "on_site" ? false : hasLocsRaw;

      // Canonical product_location_status: use the row's value
      // If you have mixed statuses within a warehouse, this picks the parent row's value
      const pls = String(r.product_location_status || "");

      const result = {
        current_status: status,
        product_location_status: pls,
        quantity: hasLocs ? undefined : Number(r.quantity) || 0,
        location: hasLocs
          ? r.location.map((loc: any) => {
            // Validate and coerce quantities
            const qty = Number(loc.quantity);
            if (!Number.isFinite(qty) || qty < 0) {
              safeConsole.warn(`[GET_ROWS] Invalid quantity in location:`, loc);
              return {
                quantity: 0,
                warehouse_id: String(loc.warehouse_id || ""),
                warehouse_name: String(loc.warehouse_name || ""),
                zone_id: String(loc.zone_id || ""),
                zone_name: String(loc.zone_name || ""),
                rack_id: String(loc.rack_id || ""),
                rack_name: String(loc.rack_name || ""),
                bin_id: String(loc.bin_id || ""),
                bin_name: String(loc.bin_name || ""),
              };
            }

            return {
              quantity: qty,
              warehouse_id: String(loc.warehouse_id || ""),
              warehouse_name: String(loc.warehouse_name || ""),
              zone_id: String(loc.zone_id || ""),
              zone_name: String(loc.zone_name || ""),
              rack_id: String(loc.rack_id || ""),
              rack_name: String(loc.rack_name || ""),
              bin_id: String(loc.bin_id || ""),
              bin_name: String(loc.bin_name || ""),
            };
          })
          : [],
      };

      // console.log(`[GET_ROWS] Row ${idx}:`, {
      //   status: result.current_status,
      //   pls: result.product_location_status,
      //   qty: result.quantity,
      //   locations: result.location?.length || 0,
      // });

      return result;
    });
  }

  /**
   * Strict allocator (Add / Edit delta)
   * - on_site first (bucket rows only)
   * - with_supplier must be from SINGLE WAREHOUSE (allows multi-bin from same warehouse)
   * - If total available < requested OR no single warehouse can cover remainder → showError + throw
   */
  function allocateFromLinkedInstallerStrict(
    requestedQty: number,
    liRows: LinkedInstallerRow[],
    preferredWarehouseId?: string // (optional) prefer this WH when adding delta on edit
  ): LinkedQuantityLocation[] {
    // console.log("[ALLOC] Starting allocation:", { requestedQty, preferredWarehouseId });

    if (!Number.isFinite(requestedQty) || requestedQty <= 0) {
      fail(`Invalid requested quantity: ${requestedQty}`);
    }
    if (!Array.isArray(liRows) || liRows.length === 0) {
      fail("No linked installer inventory for this product and scope (agent/office). Refresh product details or reselect the product.");
    }
    const totalAvail = sumAll(liRows);
    if (totalAvail < requestedQty) {
      fail(`Insufficient stock. Available: ${totalAvail}, Requested: ${requestedQty}.`);
    }

    let remaining = requestedQty;
    const out: LinkedQuantityLocation[] = [];

    // A) ON_SITE buckets first (no per-location)
    const onSiteBuckets = liRows.filter(
      (r) => r.current_status === "on_site" && (r.location?.length ?? 0) === 0
    );
    const onSiteTotal = onSiteBuckets.reduce((s, r) => s + (Number(r.quantity) || 0), 0);
    // console.log("[ALLOC] On-site buckets:", { count: onSiteBuckets.length, total: onSiteTotal });

    for (const row of onSiteBuckets) {
      if (remaining === 0) break;
      const avail = Number(row.quantity) || 0;
      const take = Math.min(remaining, avail);
      if (take > 0) {
        out.push({
          quantity: take,
          current_status: "on_site",
          product_location_status: row.product_location_status,
        });
        remaining -= take;
      }
    }
    if (remaining === 0) {
      // console.log("[ALLOC] ✅ Satisfied from on_site only");
      return out;
    }

    // B) WITH_SUPPLIER — SINGLE WAREHOUSE ONLY (allows multi-bin)

    // B1) Try a single supplier BUCKET that fully covers remaining
    const supplierBuckets = liRows.filter(
      (r) => r.current_status === "with_supplier" && (r.location?.length ?? 0) === 0
    );
    const bucketThatFits = supplierBuckets.find((r) => (Number(r.quantity) || 0) >= remaining);
    if (bucketThatFits) {
      // console.log("[ALLOC] ✅ Using supplier bucket (no warehouse):", { qty: remaining });
      out.push({
        quantity: remaining,
        current_status: "with_supplier",
        product_location_status: bucketThatFits.product_location_status,
        location: [
          {
            quantity: remaining,
            warehouse_id: "",
            warehouse_name: "",
            zone_id: "",
            zone_name: "",
            rack_id: "",
            rack_name: "",
            bin_id: "",
            bin_name: "",
          },
        ],
      });
      remaining = 0;
      return out;
    }

    // B2) Build warehouse groups from per-location rows
    type WarehouseGroup = {
      warehouseId: string;
      warehouseName: string;
      total: number;
      pls: string; // canonical product_location_status
      locations: Array<{ loc: LinkedInstallerLocation; pls: string }>;
    };

    const warehouseGroups = new Map<string, WarehouseGroup>();

    liRows.forEach((row) => {
      if (row.current_status !== "with_supplier") return;
      if (!Array.isArray(row.location) || row.location.length === 0) return;

      row.location.forEach((loc) => {
        const whId = String(loc.warehouse_id || "");
        const qty = Number(loc.quantity) || 0;
        if (qty <= 0) return;

        if (!warehouseGroups.has(whId)) {
          warehouseGroups.set(whId, {
            warehouseId: whId,
            warehouseName: loc.warehouse_name || "",
            total: 0,
            pls: row.product_location_status || "",
            locations: [],
          });
        }

        const group = warehouseGroups.get(whId)!;
        group.total += qty;
        group.locations.push({ loc, pls: row.product_location_status || "" });
      });
    });

    const supplierTotalsByWarehouse: Record<string, number> = {};
    warehouseGroups.forEach((group, whId) => {
      supplierTotalsByWarehouse[whId || "(no warehouse)"] = group.total;
    });

    // console.log("[ALLOC] Warehouse groups:", {
    //   count: warehouseGroups.size,
    //   totals: supplierTotalsByWarehouse,
    //   remaining,
    // });

    // B3) Choose a warehouse in priority order
    let chosenWarehouse: WarehouseGroup | undefined;

    // Priority 1: preferred warehouse (if specified and has enough)
    if (preferredWarehouseId && warehouseGroups.has(preferredWarehouseId)) {
      const preferred = warehouseGroups.get(preferredWarehouseId)!;
      if (preferred.total >= remaining) {
        chosenWarehouse = preferred;
        // console.log("[ALLOC] Using preferred warehouse:", { id: preferredWarehouseId, total: preferred.total });
      }
    }

    // Priority 2: largest warehouse that can cover remaining
    if (!chosenWarehouse) {
      const viable = Array.from(warehouseGroups.values())
        .filter((g) => g.total >= remaining)
        .sort((a, b) => b.total - a.total); // largest first

      if (viable.length > 0) {
        chosenWarehouse = viable[0];
        // console.log("[ALLOC] Using largest viable warehouse:", {
        //   id: chosenWarehouse.warehouseId,
        //   total: chosenWarehouse.total
        // });
      }
    }

    // B4) If no single warehouse can cover, fail with context
    if (!chosenWarehouse) {
      const maxWarehouse = Math.max(
        ...Array.from(warehouseGroups.values()).map((g) => g.total),
        0
      );
      const totalSupplier = Array.from(warehouseGroups.values()).reduce((s, g) => s + g.total, 0);
      const maxBucket = supplierBuckets.reduce((m, r) => Math.max(m, Number(r.quantity) || 0), 0);

      // console.error("[ALLOC] ❌ Cannot satisfy from single source:", {
      //   remaining,
      //   maxWarehouse,
      //   maxBucket,
      //   totalSupplier,
      //   warehouseTotals: supplierTotalsByWarehouse,
      // });

      fail(
        `Cannot satisfy remaining ${remaining} from a single supplier source. ` +
        `Max single warehouse: ${maxWarehouse}, Max bucket: ${maxBucket}, Total supplier: ${totalSupplier}. ` +
        `Choose a single warehouse or reduce quantity.`
      );
    }

    // B5) Allocate across bins within the chosen warehouse
    // TypeScript: chosenWarehouse is guaranteed non-null here (fail() throws if not found)
    const warehouse = chosenWarehouse!;
    const binsToUse: LinkedInstallerLocation[] = [];
    let allocRemaining = remaining;
    // Compute canonical PLS: first non-empty among this warehouse's contributing rows
    const chosenPls =
      (warehouse.locations.find(x => x.pls)?.pls) ||
      warehouse.pls ||
      "";

    // Sort locations for stable allocation (by bin_id for consistency)
    // Replace your current sort(...) with this composite/fallback sort
    const keyOf = (x: LinkedInstallerLocation) => [
      x.warehouse_id || "~",
      x.zone_name || "~",
      x.rack_name || "~",
      x.bin_name || "~",
      x.bin_id || "~"
    ].join("|");

    const sortedLocs = [...warehouse.locations].sort((a, b) =>
      keyOf(a.loc).localeCompare(keyOf(b.loc))
    );
    for (const { loc } of sortedLocs) {
      if (allocRemaining === 0) break;
      const locQty = Number(loc.quantity) || 0;
      const take = Math.min(allocRemaining, locQty);

      if (take > 0) {
        binsToUse.push({
          quantity: take,
          warehouse_id: loc.warehouse_id,
          warehouse_name: loc.warehouse_name,
          zone_id: loc.zone_id,
          zone_name: loc.zone_name,
          rack_id: loc.rack_id,
          rack_name: loc.rack_name,
          bin_id: loc.bin_id,
          bin_name: loc.bin_name,
        });
        allocRemaining -= take;
      }
    }

    // console.log("[ALLOC] ✅ Allocated from warehouse:", {
    //   warehouseId: warehouse.warehouseId,
    //   warehouseName: warehouse.warehouseName,
    //   binsUsed: binsToUse.length,
    //   totalAllocated: remaining,
    //   bins: binsToUse.map(b => ({ bin_id: b.bin_id, qty: b.quantity })),
    // });

    out.push({
      quantity: remaining,
      current_status: "with_supplier",
      product_location_status: chosenPls,
      location: binsToUse,
    });

    remaining = 0;
    return out;
  }

  /** Merge supplier entries - supports multi-bin from same warehouse. Also combine on_site entries. */
  function combineSupplierSingleWarehouse(items: LinkedQuantityLocation[]): LinkedQuantityLocation[] {
    // console.log("[COMBINE] Input items:", items.length);

    const onSite = items.filter((i) => i.current_status === "on_site");
    const supplier = items.filter((i) => i.current_status === "with_supplier");

    // Combine on_site entries into a single record
    let combinedOnSite: LinkedQuantityLocation[] = [];
    if (onSite.length > 0) {
      const totalOnSiteQty = onSite.reduce((n, s) => n + (Number(s.quantity) || 0), 0);
      const onSitePls = onSite[0].product_location_status || "";
      combinedOnSite = [{
        quantity: totalOnSiteQty,
        current_status: "on_site",
        product_location_status: onSitePls,
      }];
      // console.log("[COMBINE] Combined on_site:", { qty: totalOnSiteQty });
    }

    // If there's only one or no supplier entries, just combine on_site and return
    if (supplier.length <= 1) {
      if (supplier.length === 1 && Array.isArray(supplier[0].location) && supplier[0].location.length > 0) {
        supplier[0].quantity = supplier[0].location.reduce((n, l) => n + (Number(l.quantity) || 0), 0);
      }
      // console.log("[COMBINE] ✅ Single or no supplier entry, returning (healed qty if needed)");
      return [...combinedOnSite, ...supplier];
    }

    // Derive warehouse IDs from all supplier entries
    const warehouseIds = new Set<string>();

    supplier.forEach((s) => {
      if (!Array.isArray(s.location) || s.location.length === 0) {
        // Bucket entry (no warehouse)
        warehouseIds.add("");
      } else {
        // Validate all bins in this entry share the same warehouse_id
        const binWarehouseIds = s.location.map(loc => String(loc.warehouse_id || ""));
        const uniqueIds = new Set(binWarehouseIds);

        if (uniqueIds.size > 1) {
          fail("Invalid data: Single supplier entry has bins from multiple warehouses. Data corruption detected.");
        }

        warehouseIds.add(binWarehouseIds[0]);
      }
    });

    // console.log("[COMBINE] Warehouse IDs found:", Array.from(warehouseIds));

    // Policy: all supplier entries must be from the SAME warehouse (or all buckets)
    if (warehouseIds.size > 1) {
      fail(`Multiple supplier sources detected (${Array.from(warehouseIds).join(", ")}); policy requires a single supplier warehouse.`);
    }

    const warehouseId = Array.from(warehouseIds)[0];
    const pls = supplier[0].product_location_status || "";
    const totalQty = supplier.reduce((n, s) => n + (Number(s.quantity) || 0), 0);

    // Case 1: All entries are buckets (warehouse_id === "")
    if (warehouseId === "") {
      // console.log("[COMBINE] ✅ Merging supplier buckets:", { totalQty });
      return [
        ...combinedOnSite,
        {
          quantity: totalQty,
          current_status: "with_supplier",
          product_location_status: pls,
          location: [{
            quantity: totalQty,
            warehouse_id: "",
            warehouse_name: "",
            zone_id: "",
            zone_name: "",
            rack_id: "",
            rack_name: "",
            bin_id: "",
            bin_name: ""
          }],
        },
      ];
    }

    // Case 2: All entries are from the same warehouse - merge bins
    const binMap = new Map<string, LinkedInstallerLocation>();
    let warehouseName = "";

    supplier.forEach((s) => {
      if (!Array.isArray(s.location)) return;

      s.location.forEach((loc) => {
        const binId = loc.bin_id || "";
        if (!binId) return; // skip invalid bins

        warehouseName = warehouseName || loc.warehouse_name || "";

        if (binMap.has(binId)) {
          // Merge: sum quantities for duplicate bins
          const existing = binMap.get(binId)!;
          existing.quantity = (Number(existing.quantity) || 0) + (Number(loc.quantity) || 0);
        } else {
          // New bin: clone the location
          binMap.set(binId, {
            quantity: Number(loc.quantity) || 0,
            warehouse_id: loc.warehouse_id,
            warehouse_name: loc.warehouse_name,
            zone_id: loc.zone_id,
            zone_name: loc.zone_name,
            rack_id: loc.rack_id,
            rack_name: loc.rack_name,
            bin_id: loc.bin_id,
            bin_name: loc.bin_name,
          });
        }
      });
    });

    const mergedLocations = Array.from(binMap.values());
    const recalcTotal = mergedLocations.reduce((s, loc) => s + (Number(loc.quantity) || 0), 0);

    // console.log("[COMBINE] ✅ Merged supplier warehouse:", {
    //   warehouseId,
    //   warehouseName,
    //   bins: mergedLocations.length,
    //   totalQty: recalcTotal,
    //   bins_detail: mergedLocations.map(b => ({ bin_id: b.bin_id, qty: b.quantity })),
    // });

    return [
      ...combinedOnSite,
      {
        quantity: recalcTotal,
        current_status: "with_supplier",
        product_location_status: pls,
        location: mergedLocations,
      },
    ];
  }

  /** Trim for decreases; error if you try to trim more than allocated. Supports multi-bin trimming (LIFO). */
  function trimStorageDown(oldStorage: LinkedQuantityLocation[], toRemove: number): LinkedQuantityLocation[] {
    // console.log("[TRIM] Starting:", { toRemove, currentTotal: sumStorage(oldStorage) });

    let remaining = toRemove;
    const copy = JSON.parse(JSON.stringify(oldStorage)) as LinkedQuantityLocation[];

    // Trim supplier first (per-location) - LIFO (last bin first)
    const sIdx = copy.findIndex((s) => s.current_status === "with_supplier");
    if (sIdx >= 0 && remaining > 0) {
      const s = copy[sIdx];
      const initialBins = (s.location || []).length;

      if (Array.isArray(s.location) && s.location.length > 0) {
        // console.log("[TRIM] Trimming supplier bins (LIFO):", { bins: s.location.length, remaining });

        // Iterate from end (LIFO) - consistent with allocation order
        for (let i = s.location.length - 1; i >= 0 && remaining > 0; i--) {
          const loc = s.location[i];
          const locQty = Number(loc.quantity) || 0;
          const take = Math.min(remaining, locQty);

          if (take > 0) {
            // console.log(`[TRIM]   Bin ${loc.bin_id || "unknown"}: ${locQty} -> ${locQty - take}`);
            loc.quantity -= take;
            remaining -= take;

            if (loc.quantity <= 0) {
              s.location.splice(i, 1);
              // console.log(`[TRIM]   Removed empty bin ${loc.bin_id || "unknown"}`);
            }
          }
        }

        // Recalculate supplier entry total from remaining bins
        s.quantity = (s.location ?? []).reduce((n, l) => n + (Number(l.quantity) || 0), 0);

        // console.log("[TRIM] Supplier after trim:", {
        //   binsRemaining: s.location.length,
        //   totalQty: s.quantity,
        //   trimmed: initialBins - s.location.length
        // });

        // Remove supplier entry if no bins remain
        if ((s.location?.length ?? 0) === 0) {
          copy.splice(sIdx, 1);
          // console.log("[TRIM] Removed empty supplier entry");
        }
      } else if ((Number(s.quantity) || 0) > 0) {
        // Bucket entry (no locations)
        const take = Math.min(remaining, Number(s.quantity) || 0);
        // console.log("[TRIM] Trimming supplier bucket:", { before: s.quantity, take });
        (s as any).quantity = (Number(s.quantity) || 0) - take;
        remaining -= take;

        if ((Number(s.quantity) || 0) <= 0) {
          copy.splice(sIdx, 1);
          // console.log("[TRIM] Removed empty supplier bucket");
        }
      }
    }

    // Trim on_site next (if supplier couldn't cover all)
    if (remaining > 0) {
      // console.log("[TRIM] Trimming on_site entries:", { remaining });
      for (let i = copy.length - 1; i >= 0 && remaining > 0; i--) {
        const row = copy[i];
        if (row.current_status !== "on_site") continue;

        const take = Math.min(remaining, Number(row.quantity) || 0);
        // console.log(`[TRIM]   On-site: ${row.quantity} -> ${row.quantity - take}`);
        row.quantity -= take;
        remaining -= take;

        if (row.quantity <= 0) {
          copy.splice(i, 1);
          // console.log("[TRIM]   Removed empty on_site entry");
        }
      }
    }

    if (remaining > 0) {
      safeConsole.error("[TRIM] ❌ Cannot trim more than allocated:", { leftover: remaining });
      fail(`Cannot trim more than allocated; leftover ${remaining}.`);
    }

    // console.log("[TRIM] ✅ Complete:", { finalTotal: sumStorage(copy), entries: copy.length });
    return copy;
  }

  /** Edit reconcile (uses strict allocator + errors) */
  function reconcileStorageForEdit(
    originalStorage: LinkedQuantityLocation[] | undefined,
    requestedQty: number,
    liRows: LinkedInstallerRow[],
    opts?: { mode?: "delta" | "replan" }   // <-- add this
  ): LinkedQuantityLocation[] {
    // console.log("[RECONCILE] Starting:", { requestedQty, originalQty: sumStorage(originalStorage ?? []) });

    const old = originalStorage ?? [];
    const oldQty = sumStorage(old);

    if (requestedQty === oldQty) {
      // console.log("[RECONCILE] ✅ No change needed");
      return old;
    }

    if (opts?.mode === "replan") {
      // Prefer same supplier warehouse if old has one (multi-bin ok)
      let preferredWh: string | undefined;
      const oldSup = (originalStorage ?? []).find(s => s.current_status === "with_supplier");
      if (oldSup?.location?.length) {
        const wh0 = oldSup.location[0].warehouse_id || "";
        if (wh0 && oldSup.location.every(l => (l.warehouse_id || "") === wh0)) {
          preferredWh = wh0;
        }
      }

      // Plan the FULL requestedQty now (single warehouse, multi-bin)
      const target = allocateFromLinkedInstallerStrict(requestedQty, liRows, preferredWh);
      return combineSupplierSingleWarehouse(target);
    }

    if (requestedQty > oldQty) {
      const delta = requestedQty - oldQty;
      // console.log("[RECONCILE] Increase detected:", { delta });

      // Prefer same supplier warehouse (even if multi-bin)
      let preferredWh: string | undefined;
      const oldSuppliers = old.filter((s) => s.current_status === "with_supplier");

      if (oldSuppliers.length === 1) {
        const supplierEntry = oldSuppliers[0];
        if (Array.isArray(supplierEntry.location) && supplierEntry.location.length > 0) {
          // Get warehouse from first location
          const firstWhId = supplierEntry.location[0].warehouse_id || "";

          // Validate all bins share the same warehouse (should be true if data is clean)
          const allSameWh = supplierEntry.location.every(
            loc => (loc.warehouse_id || "") === firstWhId
          );

          if (allSameWh && firstWhId) {
            preferredWh = firstWhId;
            // console.log("[RECONCILE] Using preferred warehouse from existing allocation:", {
            //   preferredWh,
            //   bins: supplierEntry.location.length
            // });
          }
        }
      }

      const extra = allocateFromLinkedInstallerStrict(delta, liRows, preferredWh);
      const combined = combineSupplierSingleWarehouse([...old, ...extra]);
      // console.log("[RECONCILE] ✅ Combined after increase:", {
      //   entries: combined.length,
      //   total: sumStorage(combined)
      // });
      return combined;
    }

    // requested < old
    // console.log("[RECONCILE] Decrease detected:", { toTrim: oldQty - requestedQty });
    const trimmed = trimStorageDown(old, oldQty - requestedQty);
    // console.log("[RECONCILE] ✅ Trimmed:", { entries: trimmed.length, total: sumStorage(trimmed) });
    return trimmed;
  }

  // Helper function to normalize IDs (id vs _id)
  const normalizeId = (row: any) => String(row?.id ?? row?._id ?? "");
  const PAGE_SIZE = 10;

  // ===== Agent loader using Select2 endpoint =====
  const loadAgentOptions: LoadOptions<OfficeAgentOption, any, { page: number }> = useCallback(
    async (inputValue, _loadedOptions, additional) => {
      const page = additional?.page ?? 1;
      const q: string = (inputValue || "").trim();

      try {
        const signageId = effectiveSignageOrgId;

        if (!signageId) {
          return { options: [], hasMore: false, additional: { page: 1 } };
        }

        const url =
          `${process.env.REACT_APP_API_URL}/users/signage/${signageId}/agents/select2` +
          `?page=${page}&limit=${PAGE_SIZE}` +
          (q ? `&search=${encodeURIComponent(q)}` : "");

        const response = await fetch(url, {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          safeConsole.error("Failed to fetch agents:", response.statusText);
          return { options: [], hasMore: false, additional: { page } };
        }

        const json = await response.json();

        const list = Array.isArray(json) ? json : json.data ?? json.results ?? [];

        const options: OfficeAgentOption[] = list.map((u: any) => ({
          value: normalizeId(u),
          label: u?.name || `${u?.firstName || ""} ${u?.lastName || ""}`.trim() || "(no name)",
          firstName: u?.firstName || "",
          lastName: u?.lastName || "",
          email: u?.email || "",
          phone: u?.phone1 || "",
        }));

        const hasMore = Array.isArray(json)
          ? options.length === PAGE_SIZE
          : json?.pagination?.more ??
          (json?.total ? page * (json?.limit ?? PAGE_SIZE) < json.total : options.length === PAGE_SIZE);

        return {
          options,
          hasMore,
          additional: { page: page + 1 },
        };
      } catch (err) {
        safeConsole.error("Failed to load agent options:", err);
        // Send error email notification
        await handleApiError(err, {
          module: "installation",
          action: "Signage_Installation_Work_Order_load_agent_options",
          userId: (effectiveSignageOrgId) || undefined,
          licenseType: licenseType || undefined,
          userName: (isSignageTeammember && effectiveSignageOrgName) ? effectiveSignageOrgName : userName || undefined,
          url: `${process.env.REACT_APP_API_URL}/users/signage/${effectiveSignageOrgId}/agents/select2`,
          method: "GET",
          additionalInfo: {
            page,
            search: q || "",
            isSignageTeammember,
            effectiveSignageOrgId: effectiveSignageOrgId || null
          }
        }, token);
        return { options: [], hasMore: false, additional: { page } };
      }
    },
    [userId, isSignageTeammember, effectiveSignageOrgId, token]
  );

  // Helper function to fetch a specific agent by ID for initialization
  const fetchAgentById = useCallback(async (agentId: string): Promise<OfficeAgentOption | null> => {
    try {
      const signageId = effectiveSignageOrgId;
      if (!signageId) return null;

      const url = `${process.env.REACT_APP_API_URL}/users/signage/${signageId}/agents/select2?page=1&limit=100&search=${encodeURIComponent(agentId)}`;

      const response = await fetch(url, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) return null;

      const json = await response.json();
      const list = Array.isArray(json) ? json : json.data ?? json.results ?? [];
      const agent = list.find((u: any) => normalizeId(u) === agentId);

      if (!agent) return null;

      return {
        value: normalizeId(agent),
        label: agent?.name || `${agent?.firstName || ""} ${agent?.lastName || ""}`.trim() || "(no name)",
        firstName: agent?.firstName || "",
        lastName: agent?.lastName || "",
        email: agent?.email || "",
        phone: agent?.phone1 || "",
      };
    } catch (err) {
      safeConsole.error("Failed to fetch agent by ID:", err);
      // Send error email notification
      await handleApiError(err, {
        module: "installation",
        action: "Signage_Installation_Work_Order_fetch_agent_by_id",
        userId: (effectiveSignageOrgId) || undefined,
        licenseType: licenseType || undefined,
        userName: (isSignageTeammember && effectiveSignageOrgName) ? effectiveSignageOrgName : userName || undefined,
        url: `${process.env.REACT_APP_API_URL}/users/signage/${effectiveSignageOrgId}/agents/select2`,
        method: "GET",
        additionalInfo: {
          agentId: agentId || null,
          isSignageTeammember,
          effectiveSignageOrgId: effectiveSignageOrgId || null
        }
      }, token);
      return null;
    }
  }, [userId, isSignageTeammember, effectiveSignageOrgId, token]);

  // Extract fetchOrderDetails as a separate function so it can be called from other functions
  const fetchOrderDetails = useCallback(async () => {
    try {
      const data = await fetchInstallationOrderByIdUnwrapped(token, installationId!);
      setInstallationOrder(data);

      const initialManualPriceMap: Record<string, number> = {};
      for (const li of Array.isArray(data?.line_items) ? data.line_items : []) {
        if (li?.is_new_purchase !== true) continue;
        const key = orderLineKey(String(li.product_id ?? ""), String(li.variant_id ?? ""));
        if (li.is_price_overridden === true || li.manual_unit_price_override === true) {
          initialManualPriceMap[key] = Number(li.changed_unit_price ?? li.unit_price ?? 0);
        }
      }
      if (Object.keys(initialManualPriceMap).length > 0) {
        setManualUnitPriceMap(initialManualPriceMap);
      }

      // Sync product tax from API line_items so Cost Breakdown Tax line includes it
      const productTaxTotal = Array.isArray(data?.line_items)
        ? data.line_items.reduce(
          (sum: number, li: any) =>
            sum + Number((li?.item_tax_info as any)?.total_product_tax_amount ?? li?.tax_amount ?? 0),
          0
        )
        : 0;
      formik.setFieldValue("totals.product_tax_amount", productTaxTotal, false);

      const mappedResolvedLines = mapInstallationOrderLinesToResolved(data?.line_items);
      if (mappedResolvedLines.length > 0) {
        formik.setFieldValue("resolved_line_items", mappedResolvedLines, false);
        lastResolvedInstallationRef.current = {
          ...(lastResolvedInstallationRef.current || {}),
          line_items: mappedResolvedLines,
          installation_cost: Number(data?.installation_cost ?? 0),
          subtotal_amount: Number(data?.subtotal_amount ?? 0),
          total_amount: Number(data?.total_amount ?? 0),
          discount_code: String(data?.discount_code ?? ""),
          discount_amount: Number(data?.discount_amount ?? 0),
        };
      }

      // ✅ Store initial form values for change detection
      initialFormValuesRef.current = {
        scheduledDate: data?.installation_details?.scheduled_date,
        installerId:
          data?.installation_details?.installer_membership_id ||
          data?.installation_details?.assignee_membership_id ||
          data?.installation_details?.installer_id,
        installationAddress: JSON.stringify(data?.installation_details?.installation_address),
        billingAddress: JSON.stringify(data?.billing_address),
        notes: data?.notes,
        lineItems: JSON.stringify(data?.line_items || []),
        installationCost: data?.installation_cost,
        specialFees: JSON.stringify(data?.order_charges?.[0]?.specialfee || []),
      };
    } catch (err: any) {
      safeConsole.error("Order Detail Fetch Error:", err.message);
      // Send error email notification
      await handleApiError(err, {
        module: "installation",
        action: "Signage_Installation_Work_Order_fetch_order_details",
        userId: userId || undefined,
        licenseType: licenseType || undefined,
        userName: userName || undefined,
        url: installationOrderUrls.order(installationId!),
        method: "GET",
        additionalInfo: {
          installationId: installationId || null
        }
      }, token);
    }
  }, [installationId, token]);

  useEffect(() => {
    fetchOrderDetails();
  }, [installationId, token]);

  const runPostPaymentOrderRefresh = React.useCallback(async () => {
    await fetchOrderDetails();
  }, [fetchOrderDetails]);

  useEffect(() => {
    if (installationOrder) {
      const installAddr = installationOrder?.installation_details?.installation_address;
      setInstallationAddress(installAddr);

      const billAddr = installationOrder?.billing_address;
      // Set billing address based on buyer type
      if (installationOrder.inventory_source === "office") {
        setSelectedOfficeBillingAddress(billAddr);
      } else {
        setSelectedBillingAddress(billAddr);
      }

      // ✅ Initialize installation cost from backend
      if (installationOrder?.installation_cost !== undefined && installationCost === null) {
        // console.log("💰 Initializing installation cost from backend:", installationOrder.installation_cost);
        const initialCost = Number(installationOrder.installation_cost);
        installationCostRef.current = initialCost;
        setInstallationCost(initialCost);
      }

      // ✅ Initialize dynamic cost metadata
      if (installationOrder?.dynamic_cost_id && !dynamicCostId) {
        // console.log("🔑 Initializing dynamic_cost_id from backend:", installationOrder.dynamic_cost_id);
        setDynamicCostId(installationOrder.dynamic_cost_id);
      }

      // ✅ Initialize taxable flag
      if (installationOrder?.installation_taxable !== undefined && !dynamicTaxable) {
        setDynamicTaxable(installationOrder.installation_taxable);
      }else if (typeof installationOrder?.tax_inclusive === "boolean") {
        setDynamicTaxable(installationOrder.tax_inclusive);
      } 
    }
  }, [installationOrder]);

  // Derive brokerage ID from selected brokerage firm 
  const brokerageId = selectedBrokerageFirm?.value || null;

  // AsyncPaginate loadTeamMemberOptions function
  const loadTeamMemberOptions: LoadOptions<TeamMemberOption, any, { page: number }> = useCallback(
    async (inputValue, _loadedOptions, additional) => {
      const page = additional?.page ?? 1;
      const q: string = (inputValue || "").trim();
      // console.log("TeamMemberLoader firing with:", { brokerageId, page, inputValue });

      if (!brokerageId) {
        // console.log("❌ No brokerage selected, return empty");
        return { options: [], hasMore: false, additional: { page: 1 } };
      }

      try {
        const params = new URLSearchParams({
          brokerageFirmID: brokerageId,
          licenseType: "BROKERAGE_TEAM_MEMBER",
          signageOrganizationID: String(organizationId || "").trim(),
          page: String(page),
          limit: String(PAGE_SIZE)
        });
        if (q) params.set("search", q);

        const url = `${process.env.REACT_APP_API_URL}/organization-profiles/search?${params.toString()}`;
        // console.log('Loading team member options:', { page, q, brokerageId, url });

        const response = await fetch(url, {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          safeConsole.error("Failed to fetch team members:", response.statusText);
          return { options: [], hasMore: false, additional: { page } };
        }

        const data = await response.json();
        // console.log('Team member API response:', { page, q, data });

        const list = Array.isArray(data) ? data : data.data ?? data.results ?? [];

        const options: TeamMemberOption[] = list.map((u: any) => ({
          value: normalizeId(u),
          label: `${u?.firstName || ""} ${u?.lastName || ""}`.trim() || u?.text || "(no name)",
          firstName: u?.firstName || "",
          lastName: u?.lastName || "",
          email: u?.email || "",
          phone: u?.phone1 || "",
          offices: u?.offices || [],
        }));

        const hasMore = Array.isArray(data)
          ? options.length === PAGE_SIZE
          : data?.pagination?.more ??
          (data?.total ? page * (data?.limit ?? PAGE_SIZE) < data.total : options.length === PAGE_SIZE);

        // console.log('✅ Mapped team member options:', options);
        // console.log('📊 Returning:', { optionsCount: options.length, hasMore, nextPage: page + 1 });

        return {
          options,
          hasMore,
          additional: { page: page + 1 },
        };
      } catch (err) {
        safeConsole.error("Failed to load team member options:", err);
        // Send error email notification
        await handleApiError(err, {
          module: "installation",
          action: "Signage_Installation_Work_Order_load_team_member_options",
          userId: userId || undefined,
          licenseType: licenseType || undefined,
          userName: userName || undefined,
          url: `${process.env.REACT_APP_API_URL}/organization-profiles/search`,
          method: "GET",
          additionalInfo: {
            page,
            search: q || "",
            brokerageId: brokerageId || null,
            organizationId: organizationId || null,
          }
        }, token);
        return { options: [], hasMore: false, additional: { page } };
      }
    },
    [brokerageId, organizationId, token]
  );
  // Note: Brokerage team members are now loaded via AsyncPaginate in the Team Member dropdown


  const fetchOfficeAgents = async (office: any) => {
    setSelectedOffice(office);
    // console.log("selectedOffices In fetchOfficeAgents:", office);
    let officeId = office?.value;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/agent/office/${officeId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      // console.log("officeAgents :", data);

      if (!response.ok) {
        showError(data.error || "Failed to fetch agents");
      } else {
        setOfficeAgents(data);
        // If this order was placed for an office agent, auto-select that agent and clear standalone agent selection
        if (installationOrder?.agent_id) {
          const matched = (data || []).find((a: any) => a.id === installationOrder.agent_id);
          if (matched) {
            const option = {
              value: matched.id,
              label: `${matched.firstName} ${matched.lastName}`,
              firstName: matched.firstName,
              lastName: matched.lastName,
              email: matched.email,
              phone: matched.phone1,
            };
            setSelectedOfficeAgent(option);
            setSelectedAgent(null);
          }
        }
      }
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "An unknown error occurred"
      );
      // Send error email notification
      await handleApiError(err, {
        module: "installation",
        action: "Signage_Installation_Work_Order_fetch_office_agents",
        userId: userId || undefined,
        licenseType: licenseType || undefined,
        userName: userName || undefined,
        url: `${process.env.REACT_APP_API_URL}/agent/office/${officeId}`,
        method: "GET",
        additionalInfo: {
          officeId: officeId || null
        }
      }, token);
    } finally {
      setLoading(false);
    }
  };

  // Removed fetchAgents useEffect - now using AsyncPaginate with Select2 endpoint

  const fetchAddresses = async (opts?: {
    officeId?: string | null;
    teamMemberId?: string | null;
    selectedOfficeAgent?: any;
    selectedAgent?: any;
    selectedTeamMember?: any;
  }) => {
    const officeId = String(
      opts?.officeId ?? selectedOffice?.value ?? ""
    ).trim();
    const teamMemberId = String(
      opts?.teamMemberId ??
        opts?.selectedTeamMember?.value ??
        selectedTeamMemberOption?.value ??
        ""
    ).trim();
    const officeAgent =
      opts?.selectedOfficeAgent !== undefined
        ? opts.selectedOfficeAgent
        : selectedOfficeAgent;
    const agent =
      opts?.selectedAgent !== undefined ? opts.selectedAgent : selectedAgent;
    const teamMember =
      opts?.selectedTeamMember !== undefined
        ? opts.selectedTeamMember
        : selectedTeamMemberOption;
    const agentSelected = !!(officeAgent || agent);
    const isUnsetId = (id: string) =>
      !id || id === "000000000000000000000000";

    // Office (+ optional team member, no agent) → office addresses. Agent → membership.
    const useOfficeAddresses =
      !!officeId &&
      !isUnsetId(officeId) &&
      !agentSelected;

    const cacheKey = useOfficeAddresses
      ? `office:${officeId}`
      : resolveMembershipIdForAddresses(
          officeAgent || agent || teamMember,
          sessionMembershipId
        ) ||
        resolveMembershipAddressesRouteId({
          selectedOfficeAgent: officeAgent,
          selectedAgent: agent,
          selectedTeamMember: teamMember,
          sessionMembershipId,
        });

    if (!cacheKey) return;
    if (addressesFetchedRef.current.has(cacheKey)) return;

    let errorUrl = "";
    let errorMeta: Record<string, unknown> = {};

    try {
      let data: unknown;
      if (useOfficeAddresses) {
        data = await fetchOfficeAddresses(token || "", officeId || "");
        errorUrl = `${SALES_ORDER_API_BASE}${salesOrderUrls.officeAddresses(officeId)}`;
        errorMeta = { officeId, teamMemberId };
      } else {
        const routeMembershipId =
          typeof cacheKey === "string" && !cacheKey.startsWith("office:")
            ? cacheKey
            : resolveMembershipAddressesRouteId({
                selectedOfficeAgent: officeAgent,
                selectedAgent: agent,
                selectedTeamMember: teamMember,
                sessionMembershipId,
              });
        if (!routeMembershipId) return;
        data = await fetchUserAddresses(token || "", routeMembershipId || "");
        errorUrl = `${SALES_ORDER_API_BASE}${salesOrderUrls.membershipProfileAddresses(routeMembershipId)}`;
        errorMeta = { membershipId: routeMembershipId };
      }

      setAddressObjects(unwrapAddressListResponse(data));
      addressesFetchedRef.current.add(cacheKey);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "An unknown error occurred"
      );
      await handleApiError(err, {
        module: "installation",
        action: "Signage_Installation_Work_Order_fetch_addresses",
        userId: membershipId || undefined,
        licenseType: licenseType || undefined,
        userName: userName || undefined,
        url: errorUrl || `${SALES_ORDER_API_BASE}${salesOrderUrls.membershipProfileAddresses("")}`,
        method: "GET",
        additionalInfo: errorMeta,
      }, token);
    } finally {
      setLoading(false);
    }
  };

  // Office (+ optional TM, no agent) → office addresses; agent → membership addresses
  useEffect(() => {
    const hasOffice = !!String(selectedOffice?.value || "").trim();
    const hasTeamMember = !!String(selectedTeamMemberOption?.value || "").trim();

    if (hasOffice && !selectedOfficeAgent && !selectedAgent) {
      void fetchAddresses();
      return;
    }
    if (selectedOfficeAgent) {
      void fetchAddresses({ selectedOfficeAgent });
      return;
    }
    if (selectedAgent) {
      void fetchAddresses({ selectedAgent });
      return;
    }
    if (hasTeamMember && !hasOffice) {
      void fetchAddresses({ selectedTeamMember: selectedTeamMemberOption });
    }
  }, [selectedAgent, selectedOfficeAgent, selectedTeamMemberOption, selectedOffice?.value, token]);

  // Seed order billing into options so edit Select shows a value even before/without list match
  const addressOptions = React.useMemo(
    () =>
      buildSalesAddressSelectOptions(addressObjects, [
        installationOrder?.billing_address,
      ]),
    [addressObjects, installationOrder?.billing_address]
  );

  // const fetchLinkedProducts = async (
  //   userType: "agent" | "office",
  //   user_Id: string,
  // ) => {
  //   if (!user_Id) return;

  //   // Create a unique key for this combination
  //   const fetchKey = `${userType}-${user_Id}`;

  //   // Check if we already fetched products for this combination
  //   if (productsFetchedRef.current.has(fetchKey)) {
  //     // console.log("Products already fetched for:", fetchKey);
  //     return;
  //   }

  //   console.log("fetchLinkedProducts IN");
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}/inventory/${userType}/${user_Id}/signage/${effectiveSignageOrgId || ""}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     const data = await response.json();
  //     // console.log("Linked Products:", data);
  //     setProductObjs(data);

  //     // Mark this combination as fetched
  //     productsFetchedRef.current.add(fetchKey);

  //     if (!response.ok) {
  //       showError(data?.error || "Failed to fetch linked products");
  //     } else {
  //       // setLinkedProducts(data); if needed
  //     }
  //   } catch (err) {
  //     setError(err instanceof Error ? err.message : "Unknown error occurred");
  //   }
  // };

  // Fetch individual product by ID based on inventory_type


  const fetchProductById = async (
    inventoryType: "agent" | "office",
    userId: string,
    productId: string
  ): Promise<ProductObj | null> => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/${inventoryType}/${userId}/inventory/${productId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        // console.error(`Failed to fetch product ${productId}:`, errorData?.error || response.statusText);
        return null;
      }

      const data = await response.json();
      return data;
    } catch (err) {
      // console.error(`Error fetching product ${productId}:`, err);
      // Send error email notification
      await handleApiError(err, {
        module: "installation",
        action: "Signage_Installation_Work_Order_fetch_product_by_id",
        userId: userId || undefined,
        licenseType: licenseType || undefined,
        userName: userName || undefined,
        url: `${process.env.REACT_APP_API_URL}/${inventoryType}/${userId}/inventory/${productId}`,
        method: "GET",
        additionalInfo: {
          inventoryType: inventoryType || null,
          productId: productId || null,
          targetUserId: userId || null
        }
      }, token);
      return null;
    }
  };


  // Fetch dynamic cost metadata on load, but only reprice when the user changes the saved address.
  // Existing orders should keep their stored installation_cost while the lat/lng is unchanged.
  useEffect(() => {
    if (!installationAddress) return;

    const currentAddressDetails = installationAddress.address_details;
    const currentLatitude = Number(currentAddressDetails?.latitude);
    const currentLongitude = Number(currentAddressDetails?.longitude);

    if (
      !Number.isFinite(currentLatitude) ||
      !Number.isFinite(currentLongitude) ||
      currentLatitude === 0 ||
      currentLongitude === 0
    ) {
      showError(
        "Selected installation address is missing latitude/longitude. Please enter the address manually."
      );
      return;
    }

    const savedAddressDetails = installationOrder?.installation_details?.installation_address?.address_details;
    const savedLatitude = Number(savedAddressDetails?.latitude);
    const savedLongitude = Number(savedAddressDetails?.longitude);

    const isInstallationAddressChanged = !(
      Number.isFinite(savedLatitude) &&
      Number.isFinite(savedLongitude) &&
      savedLatitude === currentLatitude &&
      savedLongitude === currentLongitude
    );

    const fetchInstallationCost = async () => {
      const costPayload = {
        installation_address: {
          addressLine1: currentAddressDetails?.addressLine1,
          addressLine2: currentAddressDetails?.addressLine2,
          city: currentAddressDetails?.city,
          state: currentAddressDetails?.state,
          country: currentAddressDetails?.country,
          zip: currentAddressDetails?.zip,
          cityCode: currentAddressDetails?.cityCode,
          stateCode: currentAddressDetails?.stateCode,
          countryCode: currentAddressDetails?.countryCode,
          latitude: currentLatitude,
          longitude: currentLongitude,
        },
      };
      const sellerOrgId = String(
        organizationId ||
          resolveInstallationSellerOrganizationId(
            effectiveSignageOrgId || "",
            installationOrder
          )
      ).trim();
      try {
        const data = await postInstallationDynamicCost(token, sellerOrgId, costPayload);
        setDynamicCostId(data.id);
        setDynamicTaxable(data.is_taxable || data.taxabl);
        if (isInstallationAddressChanged) {
          const resolvedCost = Number(data.cost || 0);
          installationCostRef.current = resolvedCost;
          setInstallationCost(resolvedCost);
          formik.setFieldValue("installation_cost", resolvedCost, false);
          if (isEdit) {
            triggerRecomputeWithRef.current?.({ installationCost: resolvedCost });
          }
        }
      } catch (error: any) {
        safeConsole.error("Cost fetch error:", error.message);
        await handleApiError(error, {
          module: "installation",
          action: "Signage_Installation_Work_Order_fetch_installation_cost",
          userId: userId || undefined,
          licenseType: licenseType || undefined,
          userName: userName || undefined,
          url: installationOrderUrls.dynamicCost(sellerOrgId),
          method: "POST",
          requestBody: costPayload,
          additionalInfo: {
            isSignageTeammember,
            effectiveSignageOrgId: effectiveSignageOrgId || null,
          },
        }, token);
      }
    };

    fetchInstallationCost();
  }, [installationAddress, installationOrder, token, isEdit]);
  // ⬇️ Map BE → UI rows for Special Fees (Edit/View)
  // ✅ Check BOTH root-level specialfee AND order_charges[0].specialfee
  const preselectedSpecialFees = React.useMemo(() => {
    // Priority 1: Root-level specialfee (newer format)
    let list = Array.isArray(installationOrder?.specialfee)
      ? installationOrder.specialfee
      : [];

    // Priority 2: Fallback to order_charges[0].specialfee (older format)
    if (list.length === 0) {
      const oc = Array.isArray(installationOrder?.order_charges)
        ? installationOrder.order_charges
        : [];
      list = Array.isArray(oc[0]?.specialfee) ? oc[0].specialfee : [];
    }

    return list.map((f: any) => mapSavedInstallationSpecialFeeToUi(f));
  }, [installationOrder]);


  // Initial totals for Cost Breakdown from BE payload
  const initialTotals = React.useMemo(() => {
    // ✅ Check BOTH root-level specialfee AND order_charges[0].specialfee
    let list = Array.isArray(installationOrder?.specialfee)
      ? installationOrder.specialfee
      : [];

    // Fallback to order_charges if root-level is empty
    if (list.length === 0) {
      const oc = Array.isArray(installationOrder?.order_charges)
        ? installationOrder.order_charges
        : [];
      list = Array.isArray(oc[0]?.specialfee) ? oc[0].specialfee : [];
    }

    const feeSub = list.reduce((s: number, f: any) => s + Number(f?.specialfee_amount ?? f?.amount ?? 0), 0);
    const feeTax = list.reduce((s: number, f: any) => s + Number(f?.specialfee_tax_amount ?? f?.tax_amount ?? 0), 0);

    const installSub = Number(installationOrder?.installation_cost || 0);
    const productTaxTotal = Array.isArray(installationOrder?.line_items)
      ? installationOrder.line_items.reduce(
        (sum: number, li: any) =>
          sum + Number((li?.item_tax_info as any)?.total_product_tax_amount ?? li?.tax_amount ?? 0),
        0
      )
      : 0;

    // GET often returns over_all_tax_amount after TaxCloud draft but omits installation_tax_amount;
    // derive installation portion so enableReinitialize does not wipe the Cost Breakdown after fetchOrderDetails().
    let installTax = Number(installationOrder?.installation_tax_amount || 0);
    const overallTaxFromApi = Number(
      (installationOrder as any)?.over_all_tax_amount ??
        (installationOrder as any)?.over_all__tax_amount ??
        0
    );
    if (!(installTax > 0) && overallTaxFromApi > 0) {
      installTax = Math.max(0, overallTaxFromApi - feeTax - productTaxTotal);
    }

    const grand = installSub + feeSub + installTax + feeTax + productTaxTotal;

    return {
      installation_subtotal: installSub,
      installation_tax_amount: installTax,
      specialfee_subtotal: feeSub,
      specialfee_tax_amount: feeTax,
      product_tax_amount: productTaxTotal,
      grand_total: grand,
      cart_id: String(installationOrder?.cart_id || ""),
    };
  }, [installationOrder]);

  const toStringPct = (v: any) => {
    if (v === null || v === undefined || v === "") return "0";
    const n = Number(v);
    return Number.isFinite(n) ? String(n) : "0";
  };

  const initialResolvedLineItems = React.useMemo(
    () => mapInstallationOrderLinesToResolved(installationOrder?.line_items),
    [installationOrder?.line_items]
  );

  const toScheduledDateInput = (raw?: string) => {
    const date = String(raw || "").split("T")[0];
    if (!date || date.startsWith("0001-01-01")) return "";
    return date;
  };

  const toScheduleIso = (raw?: string, fallback?: string) => {
    // TODO: restore scheduled-date validation later (block empty / 0001-01-01).
    // if (!raw || String(raw).startsWith("0001-01-01")) return null;
    const source = String(raw || fallback || "").trim();
    const parsed = source ? new Date(source) : null;
    if (parsed && Number.isFinite(parsed.getTime())) return parsed.toISOString();
    return fallback || "0001-01-01T00:00:00.000Z";
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      userType: installationOrder?.user_type || "",
      userFirstName: installationOrder?.user_name?.split(' ')[0] || "",
      userLastName: installationOrder?.user_name?.split(' ').slice(1).join(' ') || "",
      userEmail: installationOrder?.user_email,
      userPhone: installationOrder?.user_phone,
      brokerageFirmsId: installationOrder?.brokerage_firm_id,
      brokerageFirmName: installationOrder?.brokerage_firm_name || "",
      teamMemberId: installationOrder?.team_member_id,
      teamMemberName: installationOrder?.team_member_name || "",
      company: "",
      office: installationOrder?.office,
      officeName: installationOrder?.office?.officeName || "",
      agent: installationOrder?.agent_id,
      agentName: installationOrder?.agent_name || "",
      scheduled_date: toScheduledDateInput(installationOrder?.installation_details?.scheduled_date),
      jobs_today: 0,
      installeId:
        installationOrder?.installation_details?.installer_membership_id ||
        installationOrder?.installation_details?.assignee_membership_id ||
        installationOrder?.installation_details?.installer_id ||
        "",
      priority: installationOrder?.priority,
      billing_address: installationOrder?.billing_address,
      installation_address: installationOrder?.installation_details.installation_address,
      isSameAsBilling: !!installationOrder?.both_address_same,
      billingAddressId: resolveSalesOrderAddressId(installationOrder?.billing_address),
      installationAddressId: `${installationOrder?.installation_details?.installation_address.label}: ${installationOrder?.installation_details?.installation_address.address_details?.addressLine1}, ${installationOrder?.installation_details?.installation_address.address_details?.city}, ${installationOrder?.installation_details?.installation_address.address_details?.state}, ${installationOrder?.installation_details?.installation_address.address_details?.zip ? installationOrder?.installation_details?.installation_address.address_details?.zip : ''}`,
      location: "",
      products: "",
      instructions: "",
      payment_method: "",
      image: null,
      installation_charge: installationOrder?.installation_cost,
      discount: installationOrder?.discount_amount,
      subtotal: installationOrder?.subtotal_amount || installationOrder?.total_amount || 0,
      total: installationOrder?.total_amount,
      tax: 0,
      localLawsChecked: installationOrder?.local_laws_checked,
      enable_partial_payment: false,
      partial_amount: 0,
      transactionId: "",
      paymentMethod: "",
      gatecode: installationOrder?.gate_access_code,
      gateCodeEnabled: false,
      label_of_address: "",
      firstName: "",
      lastName: "",
      phone: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zipcode: "",
      country: "",
      installation_cost: installationOrder?.installation_cost,
      install_taxable: installationOrder?.installation_taxable,
      install_tax_percentage: installationOrder?.installation_tax_percentage || "",
      totals: initialTotals,
      calc_fee_rate_str: installationOrder?.calc_fee_rate_str || 0,
      calc_overall_rate_str: installationOrder?.over_all__tax_amount || "",
      calc_install_rate_str: installationOrder?.installation_tax_amount || "",
      discount_amount: installationOrder?.discount_amount,
      discount_code: installationOrder?.discount_code,
      product_discount_amount: (installationOrder as any)?.product_discount_amount ?? 0,
      discount_applies_to: inferInstallationDiscountAppliesTo(installationOrder as any),
      resolved_line_items: initialResolvedLineItems,
      specialfee: preselectedSpecialFees,
      order_charges: {
        specialfee: preselectedSpecialFees,
      },

    },
    validationSchema: Yup.object({
      userEmail: Yup.string()
        .email("Enter a valid email")
        .required("Email is required"),
      userPhone: phoneValidation,

      // ✅ Phone required (basic pattern check optional)
      // userPhone: Yup.string()
      //   .required("Phone number is required")
      //   .matches(/^[0-9]{10}$/, "Enter a valid phone number"),

      // ✅ Billing Address required
      billingAddressId: Yup.string().required("Billing address is required"),

      // ✅ Installation address required only if isSameAsBilling is false
      installationAddressId: Yup.string().when("isSameAsBilling", {
        is: false,
        then: (schema) => schema.required("Installation address is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      // ✅ Checkbox (just a boolean, no error)
      isSameAsBilling: Yup.boolean(),

      // Scheduled date is optional — past, today, and future dates are all allowed
      scheduled_date: Yup.string().notRequired(),

      // ✅ Jobs Today - optional (disabled field)
      jobs_today: Yup.string().notRequired(),

      // ✅ Installer required
      installeId: Yup.string().required("Installer is required"),

      // ✅ Priority required
      priority: Yup.string().required("Priority is required"),
      // installer: Yup.string().required("Installer is required"),
      // installation_date: Yup.string().required("Installation date is required"),
      // billing_address: Yup.string().required("Billing address is required"),
      // installation_address: Yup.string().required(
      //   "Installation address is required"
      // ),
      // image: Yup.mixed().required("Image is required"),
    }),
    onSubmit: async (values) => {
      // console.log("Form values on submit:", values);
      // ✅ Validate required special fees BEFORE submission
      const requiredFees = allAvailableSpecialFees.filter((f: any) => f.required === true);
      const selectedFeeIds = selectedSpecialFees.map((f: any) => String(f.id));
      const missingRequiredFees = requiredFees.filter((f: any) => !selectedFeeIds.includes(String(f.id || f._id)));

      if (missingRequiredFees.length > 0) {
        const feeNames = missingRequiredFees.map((f: any) => f.name).join(", ");
        showError(`The following required special fees must be selected: ${feeNames}`);
        return; // Don't submit
      }
      let refundSuccess = false;
      const isTaxComplete = installationOrder?.tax_status === "complete";
      const isTaxDraft = installationOrder?.tax_status === "draft";
      if (isTaxComplete) {
        try {
          const recalcResult = await (
            installationTaxRef.current?.recalculate?.("taxcloud", { allowRefund: true }) ?? false
          );

          // Only true when TaxCloud refund actually succeeded (not on draft — that block never runs)
          refundSuccess = recalcResult === true;
          if (!refundSuccess) {
            safeConsole.warn("[INSTALL:ORDER_SUBMIT] tax recalc/refund did not succeed; skipping PostVersionOrdernumber");
          }
        } catch (err) {
          safeConsole.error("[INSTALL:ORDER_SUBMIT] tax recalc failed", err);
        }

        // if (refundSuccess) {
        //   if (!token) {
        //     showError("Missing session token while attempting TaxCloud refund.");
        //     return;
        //   }

        //   const order_type = installationOrder?.order_type || "installation";
        //   const res = await PostVersionOrdernumber(token, installationOrder?.order_number || "", order_type);
        //   // console.log("[INSTALL:ORDER_SUBMIT] TaxCloud refund result:", { res });
        //   if (!res) throw new Error("TaxCloud refund failed");
        //   nextTaxStatus = "";
        // }
      }

      await waitForRecomputeIdle();
      const resolveOk = await recomputeRef.current?.();
      if (!resolveOk || !lastResolvedInstallationRef.current) {
        showError("Could not recalculate order before save. Please try again.");
        return;
      }
      const submitResolved = lastResolvedInstallationRef.current;

      setFormSubmitting(true);
      try {
        // Example file upload handling
        const imageUrl = values.image ? await uploadFile(values.image) : null;

        const partyContext = resolveInstallationPartyContext({
          selectedOfficeAgent,
          selectedAgent,
          selectedOffice,
          selectedBrokerageFirm,
          selectedTeamMemberOption,
          selectedTeamMember,
          valuesTeamMemberId: values.teamMemberId,
          valuesTeamMemberName: values.teamMemberName,
          offices,
          savedOrder: installationOrder as Record<string, unknown>,
        });
        const partyIdentity = buildInstallationPartyIdentityPayload({
          seller: {
            organizationId: effectiveSignageOrgId,
            membershipId: sessionMembershipId || "",
            globalUserId,
          },
          party: partyContext,
          signageId: effectiveSignageOrgId,
        });

        let finalBillingAddress = null;
        let finalInstallationAddress = null;
        if (selectedOfficeAgent) {
          finalBillingAddress = selectedBillingAddress;
          finalInstallationAddress = installationAddress;
        } else if (selectedAgent) {
          finalBillingAddress = selectedBillingAddress;
          finalInstallationAddress = installationAddress;
        } else if (selectedOffice) {
          finalBillingAddress = selectedOfficeBillingAddress;
          finalInstallationAddress = installationAddress;
        }

        let lineItems: any[] = [];

        // 📦 1. Regular products (agent or office)
        // Fetch individual products based on inventory_type and user_id from selectedProducts
        // Skip rotational products - don't call fetchProductById for them
        const fetchedProductObjs: ProductObj[] = [];
        for (const product of selectedProducts) {
          // Skip rotational products - don't fetch them
          if (product.inventory_type === "rotational") continue;

          if (product.inventory_type && product.user_id && product.product_id) {
            const productData = await fetchProductById(
              product.inventory_type as "agent" | "office",
              product.user_id,
              product.product_id
            );
            if (productData) {
              fetchedProductObjs.push(productData);
            }
          }
        }

        const submitDiscount = getSubmitInstallationDiscount(values);
        const submitDiscountScope = submitDiscount.scope;

        const activeProductDiscountTotal =
          submitDiscountScope === "product"
            ? round2(
                Number(values.product_discount_amount ?? 0) ||
                Number(values.discount_amount ?? 0) ||
                liveProductDiscountMapTotal
              )
            : 0;
        const submitDiscountRows = (selectedProducts || [])
          .filter((product) => product.inventory_type !== "rotational")
          .map((product) => {
            const matched = fetchedProductObjs.find((p) => p.product_id === product.product_id);
            const variant: any = matched?.product?.variants?.[0] || {};
            const originalLine = installationOrder?.line_items?.find((item: any) => {
              const pid = String(item?.product_id ?? "");
              return pid === String(product.product_id) && item.inventory_source !== "rotational";
            });
            const resolvedVariantId = String(
              originalLine?.variant_id ?? product.variant_id ?? variant?.variant_id ?? ""
            );
            const isNewPurchase = originalLine != null
              ? Boolean(originalLine.is_new_purchase)
              : Boolean((product as FlattenedProduct).is_new_purchase ?? true);
            return isNewPurchase
              ? {
                  key: `${String(product.product_id)}:${resolvedVariantId}`,
                  productId: String(product.product_id),
                  variantId: resolvedVariantId,
                  sourceProductId: String(
                    product.source_product_id ?? originalLine?.source_product_id ?? ""
                  ),
                  quantity: Math.max(0, Number(product.quantity) || 0),
                }
              : null;
          })
          .filter(Boolean) as Array<{
            key: string;
            productId: string;
            variantId: string;
            sourceProductId?: string | null;
            quantity: number;
          }>;
        const submitResolvedDiscountMap = buildResolvedProductDiscountMap(
          submitDiscountRows,
          activeProductDiscountTotal
        );
        const payloadDiscountCode = String(
          latestDiscountCodeRef.current ||
          values.discount_code ||
          (installationOrder as any)?.discount_code ||
          (installationOrder as any)?.coupon_code ||
          (
            Array.isArray(installationOrder?.line_items)
              ? installationOrder.line_items.find(
                  (li: any) =>
                    li?.is_new_purchase === true &&
                    String(li?.discount_code ?? "").trim()
                )?.discount_code
              : ""
          ) ||
          ""
        ).trim();

        lineItems = selectedProducts?.filter((product) => product.inventory_type !== "rotational")?.map((product) => {
          let matched = fetchedProductObjs.find((p) => p.product_id === product.product_id);
          const variant: any = matched?.product?.variants?.[0] || {};
          const allocated = allocatedUnits[product.product_id] || [];

          // 🧠 Match installation order line item (non-rotational) for edit payload fields
          const originalLineFromOrder = installationOrder?.line_items?.find((item: any) => {
            const pid = String(item?.product_id ?? "");
            return pid === String(product.product_id) && item.inventory_source !== "rotational";
          });

          // 🧠 Check if quantity changed
          const originalItem = originalLineFromOrder;
          const originalQty = Number(originalItem?.quantity || 0);
          const currentQty = Number(product.quantity || 0);
          const quantityUnchanged = originalQty === currentQty;

          // // 🌐 Build liRows and reconcile storage
          // const liRows = getLiRowsFromMatched(matched);
          // const oldQtyFromStorage = sumStorage(originalItem?.storage_locations ?? []);
          // const reconcileOpts = oldQtyFromStorage === 0 ? ({ mode: "replan" } as const) : undefined;

          // const storage_locations = reconcileStorageForEdit(
          //   originalItem?.storage_locations,
          //   currentQty,
          //   liRows,
          //   reconcileOpts
          // );

          // ✅ Construct storage_locations from linked_installer_details
          const storage_locations = [{
            quantity: Number(product.quantity) || 0,
            current_status: matched?.linked_installer_details?.storage_locations?.[0]?.current_status || "",
            location: [],
          }];

          const designId = isMeaningfulObjectId((product as FlattenedProduct).design_id)
            ? String((product as FlattenedProduct).design_id).trim()
            : isMeaningfulObjectId(originalLineFromOrder?.design_id)
              ? String(originalLineFromOrder!.design_id).trim()
              : "";
          const previewUrl = String(
            (product as FlattenedProduct).preview_url ?? originalLineFromOrder?.preview_url ?? ""
          ).trim();
          const lineItemImages = buildInstallationLineItemImages({
            product: product as FlattenedProduct,
            originalLine: originalLineFromOrder,
            variantCatalogImages: variant?.images,
          });

          const studioLinePayload =
            designId && previewUrl
              ? {
                  design_id: designId,
                  design_name: String(
                    originalLineFromOrder?.design_name ?? (product as FlattenedProduct).design_name ?? ""
                  ).trim(),
                  preview_url: previewUrl,
                }
              : {};
          const resolvedVariantId =
            originalLineFromOrder?.variant_id ??
            product.variant_id ??
            variant?.variant_id ??
            "";
          const isNewPurchase =
            originalLineFromOrder != null
              ? Boolean(originalLineFromOrder.is_new_purchase)
              : Boolean((product as FlattenedProduct).is_new_purchase ?? true);
          const originalTaxable =
            typeof originalLineFromOrder?.item_tax_info?.taxable === "boolean"
              ? originalLineFromOrder.item_tax_info.taxable
              : Boolean((product as FlattenedProduct).is_taxable);

          return {
            product_id: product.product_id,
            variant_id: resolvedVariantId,
            slot_id: product.is_accessory
              ? ""
              : String(product.slot_id ?? originalLineFromOrder?.slot_id ?? "").trim(),
            source_product_id:
              originalLineFromOrder?.source_product_id ?? product.source_product_id ?? null,
            is_new_purchase: isNewPurchase,
            inventory_source:
              originalLineFromOrder?.inventory_source ?? product?.inventory_type ?? "",
            is_accessories: Boolean(
              originalLineFromOrder?.is_accessories ??
                originalLineFromOrder?.is_accessory ??
                product.is_accessory
            ),
            is_production:
              originalLineFromOrder?.is_production ?? product.is_production ?? false,
            product_name: product?.name || "",
            sku: product?.sku || "",
            quantity: Number(product.quantity),
            unit_price: isNewPurchase
              ? round2(getUnitRetailPriceForPayload(product))
              : Number(product?.unit_price || 0),
            total_price: isNewPurchase
              ? round2(getChangedUnitPriceForInstallation(product) * Number(product.quantity))
              : Number(product?.unit_price || 0) * Number(product.quantity),
            tax_amount: 0,
            inventory_deducted: false,
            fulfillment_type: "stock",
            production_status: product.productionStatus || "not started",
            is_rotational: product?.is_rotational || false,
            current_status: product?.current_status || product?.product_current_status || product?.product_location_status || "",
            notes: product.notes || "",
            rotational_allocated: quantityUnchanged ? allocated.length : 0,
            images: lineItemImages,
            item_tax_info: {
              tax_percentage: 0,
              unit_product_tax_amount: 0,
              total_product_tax_amount: 0,
              tax_details: {
                tax_rate: 0,
                tax_amount: 0,
                applied_state: "",
              },
              taxable: originalTaxable,
            },
            ...(isNewPurchase === true
              ? (() => {
                  const qty = Number(product.quantity) || 0;
                  const payloadUnitRetail = round2(getUnitRetailPriceForPayload(product));
                  const changedUnitPrice = round2(getChangedUnitPriceForInstallation(product));
                  const rowKey = `${String(product.product_id)}:${String(resolvedVariantId)}`;
                  const rowDiscTotal = round2(Number(submitResolvedDiscountMap[rowKey] || 0));
                  const lineTax = round2(getInstallationLineTaxAmount(originalLineFromOrder));
                  const perUnitDiscount = qty > 0 ? round2(rowDiscTotal / qty) : 0;
                  return {
                    unit_price: payloadUnitRetail,
                    total_price: round2(changedUnitPrice * qty + lineTax - rowDiscTotal),
                    changed_unit_price: changedUnitPrice,
                    discount_on_unit_quantity: perUnitDiscount,
                    discount_on_total_quantity: rowDiscTotal,
                    discount_code:
                      submitDiscountScope === "product" &&
                      rowDiscTotal > 0 &&
                      payloadDiscountCode
                        ? payloadDiscountCode
                        : "",
                    item_sub_total: round2(changedUnitPrice * qty),
                    tax_amount: lineTax,
                  };
                })()
              : {}),
            ...studioLinePayload,
            ...(originalLineFromOrder?.customizations
              ? { customizations: originalLineFromOrder.customizations }
              : {}),
            ...((product as FlattenedProduct).custom_information || originalLineFromOrder?.custom_information
              ? {
                  custom_information:
                    (product as FlattenedProduct).custom_information ||
                    originalLineFromOrder?.custom_information ||
                    "",
                }
              : {}),
            storage_locations,
          };
        });

        // 🔄 2. Rotational allocations
        // First, preserve existing rotational products from original order when quantity is unchanged
        const processedSourceProductIds = new Set<string>();

        installationOrder?.line_items?.forEach((originalItem: any) => {
          console.log("Processing original line item for rotational preservation:", {
            product_id: originalItem,
          });
          // Only process rotational products
          if (originalItem.inventory_source !== "rotational" || !originalItem.source_product_id) return;

          const sourceProductId = String(originalItem.source_product_id);

          // Find the corresponding normal product in selectedProducts
          const updatedProduct = selectedProducts.find(
            (p) => p.product_id === sourceProductId && p.inventory_type !== "rotational"
          );

          if (!updatedProduct) return;

          // Find the original normal product line item
          const originalNormalItem = installationOrder?.line_items?.find(
            (item: any) => item.product_id === sourceProductId && item.inventory_source !== "rotational"
          );

          if (!originalNormalItem) return;

          const originalQty = Number(originalNormalItem.quantity || 0);
          const currentQty = Number(updatedProduct.quantity || 0);

          // ✅ Only preserve if quantity is unchanged
          if (originalQty === currentQty) {
            processedSourceProductIds.add(sourceProductId);

            // Preserve the existing rotational product from original order
            lineItems.push({
              product_id: originalItem.product_id,
              variant_id: originalItem.variant_id || "",
              source_product_id: sourceProductId,
              is_new_purchase: Boolean(originalItem.is_new_purchase),
              inventory_source: "rotational",
              is_accessories: Boolean(
                originalItem.is_accessories ?? originalItem.is_accessory
              ),
              is_production: originalItem.is_production ?? false,
              product_name: originalItem.product_name || "",
              sku: originalItem.sku || "",
              quantity: originalItem.quantity || 0,
              unit_price: originalItem.unit_price || 0,
              total_price: originalItem.total_price || 0,
              tax_amount: originalItem.tax_amount || 0,
              inventory_deducted: originalItem.inventory_deducted || false,
              fulfillment_type: originalItem.fulfillment_type || "stock",
              production_status: originalItem.production_status || null,
              is_rotational: true,
              current_status: originalItem.current_status || "",
              notes: originalItem.notes || "",
              rotational_allocated: originalItem.rotational_allocated || 0,
              serial_allocations: originalItem.serial_allocations || [],
              ...(String(originalItem.design_id ?? "").trim()
                ? {
                    design_id: String(originalItem.design_id).trim(),
                    design_name: String(originalItem.design_name ?? "").trim(),
                    preview_url: String(originalItem.preview_url ?? "").trim(),
                  }
                : {}),
            });
          }
        });

        // Then, add any new allocations from allocatedUnits (for newly allocated products)
        Object.entries(allocatedUnits).forEach(([linkedProductId, units]) => {
          if (units.length === 0) return;

          // Skip if we already processed this source product from original order
          if (processedSourceProductIds.has(linkedProductId)) return;

          // Get the original line item for this linked product
          const originalItem = installationOrder?.line_items?.find(
            (item: any) => item.product_id === linkedProductId && item.inventory_source !== "rotational"
          );

          // Get the current (edited) selected product
          const updatedProduct = selectedProducts.find(
            (p) => p.product_id === linkedProductId && p.inventory_type !== "rotational"
          );

          if (!originalItem || !updatedProduct) return;

          const originalQty = Number(originalItem.quantity || 0);
          const currentQty = Number(updatedProduct.quantity || 0);

          // ❌ Skip if quantities are different
          if (originalQty !== currentQty) return;

          // ✅ Push rotational product allocation
          const existingRotationalLi = installationOrder?.line_items?.find(
            (item: any) =>
              String(item.product_id) === String(units[0].rotationalProductId) &&
              item.inventory_source === "rotational"
          );
          lineItems.push({
            source_product_id: linkedProductId,
            product_id: units[0].rotationalProductId,
            is_new_purchase: existingRotationalLi
              ? Boolean(existingRotationalLi.is_new_purchase)
              : Boolean(originalItem.is_new_purchase),
            inventory_source: "rotational",
            is_accessories: Boolean(
              existingRotationalLi?.is_accessories ??
                existingRotationalLi?.is_accessory ??
                originalItem.is_accessories ??
                originalItem.is_accessory
            ),
            is_production:
              existingRotationalLi?.is_production ?? originalItem.is_production ?? false,
            product_name: units[0].product_name || "",
            sku: units[0].sku || "",
            quantity: 1,
            unit_price: 0,
            total_price: 0,
            tax_amount: 0,
            inventory_deducted: false,
            fulfillment_type: "stock",
            production_status: null,
            is_rotational: true,
            current_status: "",
            notes: "",
            serial_allocations: units?.map((u: any) => ({
              source_product_id: linkedProductId,
              serial_id: u.serial_id,
              serial_code: u.serial_number,
              warehouse_id: u.storage_location?.warehouse_id || "",
              zone_id: u.storage_location?.zone_id || "",
              rack_id: u.storage_location?.rack_id || "",
              bin_id: u.storage_location?.bin_id || "",
              status: u.storage_location?.status || "",
            })),
            ...(String(existingRotationalLi?.design_id ?? "").trim()
              ? {
                  design_id: String(existingRotationalLi.design_id).trim(),
                  design_name: String(existingRotationalLi.design_name ?? "").trim(),
                  preview_url: String(existingRotationalLi.preview_url ?? "").trim(),
                }
              : {}),
          });
        });


        // ✅ Use state-based special fees (more reliable)
        const uiFees = selectedSpecialFees || [];
        // zeroOutTaxFields only when tax was "complete" and refund succeeded — never on draft
        const zeroOutTaxFields = refundSuccess && isTaxComplete;
        const feeRows = uiFees.map((f) =>
          mapInstallationSpecialFeeForSubmit(f, {
            zeroOutTaxFields,
            catalog: allAvailableSpecialFees,
          })
        );

        // (Optional) recompute fee subtotals if you want to keep root totals aligned for UI
        const feeSub = uiFees.reduce((s, x) => s + Number(x.amount || 0), 0);
        const feeTax = uiFees.reduce((s, x) => s + Number(x.tax_amount || 0), 0);

        const resolvedLines = (
          (formik.values as { resolved_line_items?: ResolvedInstallationLineItem[] })
            .resolved_line_items || []
        ) as ResolvedInstallationLineItem[];
        const resolvedLineItemsSource =
          resolvedLines.length > 0
            ? resolvedLines
            : lastResolvedInstallationRef.current?.line_items;
        const lineItemsForPatch =
          resolvedLineItemsSource?.length
            ? (mergeResolvedTaxIntoLineItems(lineItems, resolvedLineItemsSource) as typeof lineItems)
            : lineItems;
        const lineItemsForSubmit =
          submitDiscountScope === "installation"
            ? lineItemsForPatch.map((li: any) =>
                li?.is_new_purchase === true ? { ...li, discount_code: "" } : li
              )
            : lineItemsForPatch;

        // existing totals you already compute or keep in formik.values.totals
        const installSub = Number(installationCost || 0);
        const installTax = Number(
          formik.values.totals?.installation_tax_amount ??
            lastResolvedInstallationRef.current?.installation_tax_amount ??
            0
        );
        // console.log("installSub:", installSub, "installTax:", installTax);
        const grand = Number(formik.values.totals?.grand_total || 0);
        // ✅ Calculate manual special fee subtotal (sum of all fees)
        const manualFeeSub = feeRows.reduce((sum, f) => sum + Number(f.specialfee_amount || 0), 0);

        // ✅ Fallback calculations if engine totals are missing
        const finalInstallSub = installSub > 0 ? installSub : Number(installationCost || 0);
        // console.log("finalInstallSub:", finalInstallSub);
        const finalFeeSub = feeSub > 0 ? feeSub : manualFeeSub;
        const finalDiscount =
          submitDiscountScope === "installation" ? submitDiscount.amount : 0;
        // console.log("finalDiscount:", finalDiscount);

        // ✅ Subtotal = installation_cost + units_cost - discount (special fees excluded)
        const finalSubtotal =
          finalInstallSub + Number(unitsCost ?? 0);
        const totalWithoutTax = finalSubtotal + finalFeeSub- finalDiscount;
        // console.log("totalWithoutTax:", totalWithoutTax);
        // console.log("finalFeeSub:", finalFeeSub);
        // console.log("finalDiscount:", finalDiscount);
        const productTaxSubmit = Number(
          (formik.values?.totals as any)?.product_tax_amount ??
            lastResolvedInstallationRef.current?.line_items?.reduce(
              (s, li) => s + Number(li.item_tax_info?.total_product_tax_amount ?? 0),
              0
            ) ??
            0
        );
        const overallTaxAmount = round2(installTax + feeTax + productTaxSubmit);
        // console.log("overallTaxAmount:", overallTaxAmount);
        const finalTotal = totalWithoutTax + overallTaxAmount;
        // console.log("finalTotal:", finalTotal);

        // Percent strings if you keep them
        const installationTaxPctStr =
          (formik.values as any).calc_install_rate_str ||
          lastResolvedInstallationRef.current?.installation_tax_percentage ||
          "";
        const overallTaxPctStr =
          (formik.values as any).calc_overall_rate_str ||
          lastResolvedInstallationRef.current?.over_all_tax_percentage ||
          "";

        // console.log("specialfee_ids:", {
        //   // order_number: installationOrder?.order_number,
        //   // inventory_source: inventorySource,
        //   // source_id: sourceId,
        //   // brokerage_firm_id: selectedBrokerageFirm?.value,
        //   // brokerage_firm_name: selectedBrokerageFirm?.label,
        //   // team_member_id: values.teamMemberId,
        //   // office: officeInfo,
        //   // agent_id: agentId,
        //   // agent_name: agentName,
        //   // signage_id: userId,
        //   // signage_company_name: userName,
        //   user_email: values.userEmail,
        //   user_phone: values.userPhone,
        //   line_items: lineItems,
        //   // customer_group_id: null,
        //   // payment_method: values.payment_method,
        //   gate_access_code: values.gatecode || "",
        //   installation_details: {
        //     scheduled_date: new Date(values.scheduled_date).toISOString(),
        //     installation_address: finalInstallationAddress,
        //     installer_id: selectedInstaller?.value,
        //     installer_name: selectedInstaller?.label,
        //     contact_number: selectedInstaller?.phone,
        //     estimated_duration: null,
        //     actual_installation_date: null,
        //     additional_instructions: [
        //       {
        //         value: values.instructions,
        //         added_by: {
        //           id: userId,
        //           name: userName,
        //         },
        //         added_at: new Date().toISOString(),
        //       },
        //     ],
        //     assignee_id: selectedInstaller?.value,
        //     tax_details: null,
        //   },
        //   billing_address: finalBillingAddress,
        //   both_address_same: values.isSameAsBilling,
        //   additional_instructions: values.instructions,
        //   order_type: "installation",
        //   // local_laws_compliance: true,
        //   priority: values.priority,
        //   uploaded_files: uploadedFileMeta || [],
        //   version: installationOrder?.version,
        //   // tax_inclusive: false,
        //   // tax_details: null,

        //   // ✅ Engine-driven amounts
        //   installation_cost: parseFloat(String(installationCost)) || 0, // InstallationCost
        //   additional_cost: 0,
        //   discount_amount: formik.values.discount_amount || 0,
        //   discount_code: formik.values.discount_code || "",


        //   tax_inclusive: false,                           // TaxInclusive
        //   subtotal_amount: installSub,
        //   total_amount: grand,
        //   installation_tax_amount: installTax,
        //   installation_tax_percentage: installationTaxPctStr || undefined,
        //   over_all_tax_amount: installTax + feeTax,
        //   overall_tax_percentage: overallTaxPctStr || undefined,
        //   cart_id: formik.values.totals?.cart_id || installationOrder?.cart_id || "000000000000000000000000",
        //   tax_status: installationOrder?.tax_status || "",    // or "draft" if you’re saving Live Tax draft
        //   // ✅ Keep all fee data **inside** order_charges
        //   order_charges: [
        //     {
        //       shipping_option: installationOrder?.order_charges?.[0]?.shipping_option ?? null,
        //       specialfee: feeRows,
        //     },
        //   ],

        // });

        let installationUpdatePayload: Record<string, unknown> = {
          // order_number: installationOrder?.order_number,
          // inventory_source: inventorySource,
          user_email: values.userEmail,
          user_phone: values.userPhone,
          line_items: lineItemsForSubmit,
          // customer_group_id: null,
          // payment_method: values.payment_method,
          gate_access_code: values.gatecode || "",
          installation_details: {
            ...(values.scheduled_date
              ? { scheduled_date: new Date(values.scheduled_date).toISOString() }
              : {}),
            installation_address: finalInstallationAddress,
            ...buildInstallationDetailsParticipantFields({
              role: "signage_assignee",
              selection: selectedInstaller,
              fallbackOrgId: effectiveSignageOrgId,
              fallbackName: selectedInstaller?.label,
              fallbackPhone: selectedInstaller?.phone,
            }),
            estimated_duration: null,
            actual_installation_date: null,
            installation_notes: [
              {
                value: values.instructions,
                added_by: {
                  id: userId,
                  name: userName,
                },
                added_at: new Date().toISOString(),
              },
            ],
            tax_details: null,
          },
          billing_address: finalBillingAddress,
          both_address_same: values.isSameAsBilling,
          additional_instructions: values.instructions,
          order_type: "installation",
          // local_laws_compliance: true,
          priority: values.priority,
          // uploaded_files: uploadedFileMeta || [],
          version: installationOrder?.version,
          // tax_inclusive: false,
          // tax_details: null,

          // ✅ Calculated amounts (with fallback)
          subtotal_amount: finalSubtotal,                         // SubtotalAmount
          installation_cost: parseFloat(String(installationCost)) || 0, // InstallationCost
          additional_cost: 0,
          discount_amount:
            submitDiscountScope === "installation" && submitDiscount.code
              ? submitDiscount.amount
              : 0,
          discount_code:
            submitDiscountScope === "installation" ? submitDiscount.code : "",

          // ✅ Totals (with fallback) — draft/edit: no tax in total until live tax
          total_amount: zeroOutTaxFields || isTaxDraft ? totalWithoutTax : finalTotal,

          // ✅ Special fees array
          specialfee: feeRows,                                          // Array of special fees

          // ✅ Tax fields from resolve / Formik totals
          tax_inclusive: dynamicTaxable,
          installation_tax_amount: zeroOutTaxFields ? 0 : installTax,
          installation_tax_percentage: zeroOutTaxFields ? "0" : toStringPct(installationTaxPctStr),
          over_all_tax_percentage: zeroOutTaxFields ? "0" : toStringPct(overallTaxPctStr),
          over_all_tax_amount: zeroOutTaxFields ? 0 : overallTaxAmount,
          project_id: userClearedProjectRef.current
            ? undefined
            : linkedProjectId || projectIdFromQuery || (installationOrder as any)?.project_id || undefined,
          project_number: userClearedProjectRef.current
            ? undefined
            : linkedProjectNumber || (installationOrder as any)?.project_number || undefined,
          ...(installationPost ? { installation_post: installationPost } : {}),
          ...partyIdentity,
          // cart_id: installationOrder?.cart_id || undefined,                               // TaxInclusive
        };

        installationUpdatePayload = sanitizeInstallationOrderSubmitPayload(
          overlayInstallationSubmitFromResolved(
            installationUpdatePayload,
            submitResolved
          ) as Record<string, unknown>
        );

        if (isTaxDraft) {
          installationUpdatePayload.total_amount = totalWithoutTax;
        }

        const response = await axios.patch(
          `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
          installationUpdatePayload,
          {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = response.data;

        if (response.status !== 200) {
          showError(data.message || data.error || "Failed to update installation order");
          throw new Error(data.message || "Failed to create installation order");
        }

        // Keep project↔quote link synced on installation edit (URL project or Project card selection).
        const effectiveProjectIdForLink = userClearedProjectRef.current
          ? ""
          : String(linkedProjectId || projectIdFromQuery || (installationOrder as any)?.project_id || "").trim();
        if (userClearedProjectRef.current && token) {
          const projectIdToUnlink = String((installationOrder as any)?.project_id || "").trim();
          if (projectIdToUnlink && projectIdToUnlink !== "[object Object]") {
            try {
              await unlinkProjectQuote(token, projectIdToUnlink);
            } catch (err) {
              safeConsole.warn("Failed to unlink installation order from project:", err);
            }
          }
        } else if (effectiveProjectIdForLink && effectiveProjectIdForLink !== "[object Object]" && token) {
          try {
            const linkedOrderId = String(data?.order_id || data?.id || installationOrder?._id || installationId || "").trim();
            const linkedOrderNumber = String(data?.order_number || installationOrder?.order_number || linkedOrderId).trim();
            if (linkedOrderId) {
              await linkProjectQuote(token, effectiveProjectIdForLink, {
                linked_order_id: linkedOrderId,
                linked_order_number: linkedOrderNumber || linkedOrderId,
                linked_order_type: "service_order",
              });
            }
          } catch (err) {
            safeConsole.warn("Failed to link edited installation order to project:", err);
          }
        }

        // ✅ Call PostVersionOrdernumber only after API call succeeds (status === 200) AND refundSuccess is true
        if (response.status === 200 && refundSuccess && installationOrder?.tax_status === "complete") {
          try {
            if (!token) {
              showError("Missing session token while attempting TaxCloud refund.");
              return;
            }

            const order_type = installationOrder?.order_type || "installation";
            const res = await PostVersionOrdernumber(token, installationOrder?.order_number || "", order_type);
            // console.log("[INSTALL:ORDER_SUBMIT] TaxCloud refund result:", { res });
            if (!res) {
              throw new Error("TaxCloud refund failed");
            }
          } catch (err) {
            safeConsole.error("[INSTALL:ORDER_SUBMIT] PostVersionOrdernumber failed", err);
            showError("TaxCloud refund call failed. Please try again.");
            return;
          }
        }

        // ✅ Check if form was modified
        const initialValues = initialFormValuesRef.current;
        const hasChanges = initialValues && (
          values.scheduled_date !== initialValues.scheduledDate ||
          selectedInstaller?.value !== initialValues.installerId ||
          JSON.stringify(installationAddress) !== initialValues.installationAddress ||
          JSON.stringify(selectedBillingAddress || selectedOfficeBillingAddress) !== initialValues.billingAddress ||
          // values.notes !== initialValues.notes ||
          JSON.stringify(selectedProducts) !== initialValues.lineItems ||
          installationCost !== initialValues.installationCost ||
          JSON.stringify(selectedSpecialFees) !== initialValues.specialFees
        );

        // ✅ Send email notifications if changes were made
        if (hasChanges) {
          try {
            const from = process.env.REACT_APP_FROM_EMAIL2;
            if (from && token) {
              const orderNumber = installationOrder?.order_number || `#${installationOrder?._id || installationId || "INST-XXXX"}`;
              const signageCompanyName = (isSignageTeammember && effectiveSignageOrgName) ? effectiveSignageOrgName : userName || "Signage Company";

              // Backend sends "Signage Installation order edit" emails after update.
              // await sendInstallationOrderTriggerEmail({
              //   triggerName: "Signage Installation order edit",
              //   installationOrderId: ...,
              //   token,
              //   fromEmail: from,
              // });

              // ✅ Trigger: Installation Order Edit - Send notifications
              try {
                const { createNotification } = await import("../../services/notificationApi");
                const { getInstallationOrderEditContent } = await import("../../services/notificationContent");
                const { fetchUserData } = await import("../../utils/userDataFetcher");

                // Send notification to single end user (effectiveCouponCreatedById) only
                if (effectiveCouponCreatedById && token) {
                  try {
                    const endUserData = await fetchUserData(
                      resolveInstallationPaymentMethodsMembershipId(installationOrder) || effectiveCouponCreatedById,
                      token
                    );
                    if (endUserData?.id) {
                      // Determine recipientType based on licenseType
                      let recipientType: "agent" | "brokerage_team" = "agent";
                      if (endUserData.licenseType === "BROKERAGE_FIRM" || endUserData.licenseType === "BROKERAGE_TEAM_MEMBER") {
                        recipientType = "brokerage_team";
                      } else if (endUserData.licenseType === "AGENT" || endUserData.licenseType === "BROKERAGE_AGENT") {
                        recipientType = "agent";
                      }

                      const endUserContent = getInstallationOrderEditContent({
                        orderId: orderNumber,
                        signageCompanyName: signageCompanyName,
                        recipientType: recipientType,
                      });
                      await createNotification(effectiveCouponCreatedById, endUserContent, token || "", recipientType);
                    }
                  } catch (err) {
                    safeConsole.warn("Failed to send edit notification to end user:", err);
                  }
                }
              } catch (notifError) {
                safeConsole.warn("Failed to send installation order edit notifications:", notifError);
              }
            }
          } catch (emailError) {
            safeConsole.warn("Failed to send installation order edit emails:", emailError);
            // Don't fail the order update if email fails
          }
        }

        // Removed bulk allocation here. Allocation will be triggered from view actions (Finalize & Schedule / Start).
        showSuccess("Installation order Updated successfully!");

        // Navigate to view mode with a small delay to ensure the success message is shown
        setTimeout(() => {
          safeNavigate(`${baseRoute}/jobs/installationWorkOrder/${installationId}`, { state: { type: "View" }, replace: true });
          // Reload the page to ensure fresh data is loaded and avoid version mismatch errors
          window.location.reload();
        }, 500);
      } catch (error: any) {
        showError(`Error: ${error.message}`);
      } finally {
        setFormSubmitting(false);
      }
    }
  });

  useEffect(() => {
    if (formik.submitCount < 1) return;
    if (!formik.errors?.scheduled_date) return;
    const el = document.getElementById("scheduled_date");
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    el.focus();
  }, [formik.submitCount, formik.errors?.scheduled_date]);

  // Initialize instructions from installation order after formik is declared
  useEffect(() => {
    if (installationOrder) {
      if (installationOrder?.additional_instructions) {
        const latestInstruction = installationOrder.additional_instructions[installationOrder.additional_instructions.length - 1];
        if (latestInstruction?.value) {
          setInstructions(latestInstruction.value);
          formik.setFieldValue("instructions", latestInstruction.value);
        }
      }
    }
  }, [installationOrder]);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      const files = Array.isArray(installationOrder?.uploaded_files)
        ? installationOrder.uploaded_files
        : Array.isArray((installationOrder as any)?.uploadedFiles)
          ? (installationOrder as any).uploadedFiles
          : [];
      const fileIds = files
        .map((f: any) => String(f?.file_id || "").trim())
        .filter((id: string) => /^[0-9a-f]{24}$/i.test(id));
      if (!token || fileIds.length === 0) {
        if (!cancelled) setInstructionFileUrlMap({});
        return;
      }
      try {
        const map = await batchPresignUrls(fileIds, token);
        if (!cancelled) setInstructionFileUrlMap(map || {});
      } catch {
        if (!cancelled) setInstructionFileUrlMap({});
      }
    };
    void run();
    return () => {
      cancelled = true;
    };
  }, [installationOrder?.uploaded_files, (installationOrder as any)?.uploadedFiles, token]);

  const instructionAttachments = useMemo(() => {
    const files = Array.isArray(installationOrder?.uploaded_files)
      ? installationOrder.uploaded_files
      : Array.isArray((installationOrder as any)?.uploadedFiles)
        ? (installationOrder as any).uploadedFiles
        : [];
    return files.map((f: any, index: number) => {
      const fileId = String(f?.file_id || "").trim();
      const href = (fileId && instructionFileUrlMap[fileId]) || String(f?.file_url || "").trim();
      return {
        id: fileId || `uploaded-${index}`,
        name: String(f?.file_name || "Attachment"),
        href,
        previewUrl: href,
        dateLabel: f?.uploaded_date ? new Date(f.uploaded_date).toLocaleDateString() : undefined,
      };
    });
  }, [installationOrder?.uploaded_files, (installationOrder as any)?.uploadedFiles, instructionFileUrlMap]);

  // AsyncPaginate loadSignageTeamMemberOptions function
  const loadSignageTeamMemberOptions: LoadOptions<SignageTeamMemberOption, any, { page: number }> = useCallback(
    async (inputValue, _loadedOptions, additional) => {
      const page = additional?.page ?? 1;

      try {
        const params = new URLSearchParams({
          signageOrganizationID: String(organizationId || "").trim(),
          licenseType: "SIGNAGE_TEAM_MEMBER",
          page: String(page),
          limit: String(PAGE_SIZE)
        });
        const q = (inputValue || "").trim();
        if (q) params.set("search", q);

        const url = `${process.env.REACT_APP_API_URL}/organization-profiles/search?${params.toString()}`;
        const response = await fetch(url, {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          safeConsole.error("Failed to fetch signage team members:", response.statusText);
          return { options: [], hasMore: false, additional: { page } };
        }

        const data = await response.json();
        // console.log('Signage team member API response:', { page, q, data });

        const list = Array.isArray(data) ? data : data.data ?? data.results ?? [];

        const options: SignageTeamMemberOption[] = list.map((u: any) => {
          const membershipId = String(
            u?.membership_id ?? u?.membershipId ?? normalizeId(u)
          ).trim();
          return {
            value: membershipId,
            label: `${u?.firstName || ""} ${u?.lastName || ""}`.trim() || u?.text || "(no name)",
            firstName: u?.firstName || "",
            lastName: u?.lastName || "",
            email: u?.email || "",
            phone: u?.phone1 || "",
            membershipId,
            globalUserId: String(u?.global_user_id ?? u?.globalUserId ?? "").trim() || undefined,
            organizationId: String(
              u?.organization_id ?? u?.organizationId ?? effectiveSignageOrgId ?? ""
            ).trim() || undefined,
          };
        });

        const hasMore = Array.isArray(data)
          ? options.length === PAGE_SIZE
          : data?.pagination?.more ??
          (data?.total ? page * (data?.limit ?? PAGE_SIZE) < data.total : options.length === PAGE_SIZE);

        return {
          options,
          hasMore,
          additional: { page: page + 1 },
        };
      } catch (err) {
        safeConsole.error("Failed to load signage team member options:", err);
        return { options: [], hasMore: false, additional: { page } };
      }
    },
    [userId, token, isSignageTeammember, effectiveSignageOrgId]
  );

  // Note: Signage team members are now loaded via AsyncPaginate in the Assigned To dropdown

  const uploadFile = async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("uploadDir", "installation_orders");

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", `${process.env.REACT_APP_API_URL}/images/upload`, true);
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          setUploadProgress((event.loaded / event.total) * 100);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200 || xhr.status === 201) {
          const response = JSON.parse(xhr.responseText);
          resolve(response.path);
        } else {
          reject(new Error("Failed to upload file"));
        }
      };

      xhr.onerror = () => reject(new Error("Network error during file upload"));
      xhr.send(formData);
    });
  };

  const handleLocationChange = (
    selectedOption: SingleValue<{ value: string; label: string }>
  ) => {
    formik.setFieldValue("location", selectedOption?.value || "");
  };

  const handleSaveInstructions = (newInstructions: string) => {
    setInstructions(newInstructions);
    formik.setFieldValue("instructions", newInstructions);
  };

  // Function to update gate access code only
  const handleSaveGateCode = async () => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
        {
          version: installationOrder?.version,
          gate_access_code: formik.values.gatecode,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        showSuccess("Gate access code updated successfully!");
        // Refresh the order details instead of reloading the page
        await fetchOrderDetails();
      } else {
        showError("Failed to update gate access code");
      }
    } catch (error: any) {
      showError(`Error updating gate access code: ${error.message}`);
      // Send error email notification
      const gateCodePayload = {
        version: installationOrder?.version,
        gate_access_code: formik.values.gatecode,
      };
      await handleApiError(error, {
        module: "installation",
        action: "Signage_Installation_Work_Order_update_gate_code",
        userId: userId || undefined,
        licenseType: licenseType || undefined,
        userName: userName || undefined,
        url: `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
        method: "PATCH",
        requestBody: gateCodePayload,
        additionalInfo: {
          installationId: installationId || null
        }
      }, token);
    }
  };

  // Function to update instructions only (text first; `Instructions` uploads pending files after via upload-documents-to-order)
  const handleSaveInstructionsOnly = async (
    instructionsText: string,
    context?: { hasPendingFiles: boolean }
  ) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
        {
          version: installationOrder?.version,
          additional_instructions: instructionsText,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        showSuccess("Instructions updated successfully!");
        // Update the local state to reflect the change
        setInstructions(instructionsText);
        // Also update formik value to keep them in sync
        formik.setFieldValue("instructions", instructionsText);
        // When pending files exist, `Instructions` runs upload then `onAfterFilesUploaded` refetches.
        if (!context?.hasPendingFiles) {
          await fetchOrderDetails();
        }
      } else {
        showError("Failed to update instructions");
      }
    } catch (error: any) {
      showError(`Error updating instructions: ${error.message}`);
      // Send error email notification
      const instructionsPayload = {
        version: installationOrder?.version,
        additional_instructions: instructionsText,
      };
      await handleApiError(error, {
        module: "installation",
        action: "Signage_Installation_Work_Order_update_instructions",
        userId: userId || undefined,
        licenseType: licenseType || undefined,
        userName: userName || undefined,
        url: `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
        method: "PATCH",
        requestBody: instructionsPayload,
        additionalInfo: {
          installationId: installationId || null
        }
      }, token);
    }
  };

  const handleMapClick = useCallback((event: google.maps.MapMouseEvent) => {
    if (event.latLng) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      setSelectedLocation({ lat, lng });
      formik.setFieldValue("location", { lat, lng });
    }
  }, []);


  // to get the scheduled job count based on the selected date
  useEffect(() => {
    const fetchScheduledJobs = async () => {
      if (!formik.values.scheduled_date || formik.values.scheduled_date.startsWith("0001-01-01") || !userId) return;

      const date = new Date(formik.values.scheduled_date).toISOString().split("T")[0]; // format as YYYY-MM-DD

      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/installation_orders/${formik.values.installeId}/${date}/scheduled_jobs`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Failed to fetch job count");
        // console.log("Scheduled Jobs:", data);

        setScheduledJobsCount(data.scheduled_jobs); // assuming response shape: { count: number }
        formik.setFieldValue("scheduled_jobs", data.scheduled_jobs);
      } catch (err: any) {
        safeConsole.error("Scheduled Jobs Error:", err.message);
        setScheduledJobsCount(null);
        // Send error email notification
        await handleApiError(err, {
          module: "installation",
          action: "Signage_Installation_Work_Order_fetch_scheduled_jobs",
          userId: userId || undefined,
          licenseType: licenseType || undefined,
          userName: userName || undefined,
          url: `${process.env.REACT_APP_API_URL}/installation_orders/${formik.values.installeId}/${date}/scheduled_jobs`,
          method: "GET",
          additionalInfo: {
            installerId: formik.values.installeId || null,
            scheduledDate: date || null
          }
        }, token);
      }
    };

    fetchScheduledJobs();
  }, [formik.values.installeId, userId, token]);

  // seting the total units based on the selected products
  useEffect(() => {
    const newTotal = selectedProducts.reduce((sum, product) => sum + Number(product.quantity || 0), 0);
    setTotalUnits(newTotal);
  }, [selectedProducts]);

  const unitsPurchased = React.useMemo(() => {
    const selectedTotal = (Array.isArray(selectedProducts) ? selectedProducts : []).reduce((sum: number, item: any) => {
      const inventorySource = String(item?.inventory_type || item?.inventory_source || "").trim().toLowerCase();
      const isNewPurchase = item?.is_new_purchase === true;
      const shouldCount = inventorySource === "custom" || isNewPurchase || Boolean(item?.is_new_catalog);
      if (!shouldCount) return sum;
      return sum + (Number(item?.quantity) || 0);
    }, 0);

    if (selectedTotal > 0) return selectedTotal;

    const lineItems = Array.isArray(installationOrder?.line_items) ? installationOrder.line_items : [];
    return lineItems.reduce((sum: number, item: any) => {
      const inventorySource = String(item?.inventory_source || "").trim().toLowerCase();
      const isNewPurchase = item?.is_new_purchase === true;
      const shouldCount = inventorySource === "custom" || isNewPurchase || Boolean(item?.is_new_catalog);
      if (!shouldCount) return sum;
      return sum + (Number(item?.quantity) || 0);
    }, 0);
  }, [selectedProducts, installationOrder?.line_items]);


  // seting the installation address based on the selected billing address
  useEffect(() => {
    if (formik.values.isSameAsBilling) {
      const isOffice = !selectedOfficeAgent && !selectedAgent && selectedOffice;
      const billing = isOffice ? selectedOfficeBillingAddress : selectedBillingAddress;

      if (billing) {
        // console.log("Billing Address:", billing);
        setInstallationAddress(billing);
        formik.setFieldValue("installationAddressId", `${billing?.label}: ${billing?.address_details?.addressLine1}, ${billing?.address_details?.city}, ${billing?.address_details?.state}, ${billing?.address_details?.zip ? billing?.address_details?.zip : ''}`);
      }
    }
  }, [formik.values.isSameAsBilling, selectedBillingAddress, selectedOfficeBillingAddress]);

  // calculating the subtotal and total
  useEffect(() => {
    const newTotal = selectedProducts
      .filter((p) => p.inventory_type !== "rotational")
      .reduce((sum, product) => sum + Number(product.quantity || 0), 0);

    setTotalUnits(newTotal);
  }, [selectedProducts]);

  // remove the preview images
  useEffect(() => {
    return () => {
      imagePreviews.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [imagePreviews]);

  useEffect(() => {
    if (
      installationAddress?.address_details?.latitude &&
      installationAddress?.address_details?.longitude &&
      installationAddress?.address_details?.latitude !== 0 &&
      installationAddress?.address_details?.longitude !== 0
    ) {
      // console.log("Setting marker from installationAddress");
      setSelectedLocation({
        lat: installationAddress?.address_details?.latitude,
        lng: installationAddress?.address_details?.longitude,
      });
    }
    // console.log("lat,lag :", installationAddress?.address_details?.latitude, installationAddress?.address_details?.longitude,)
  }, [installationAddress]);


  const handleMarkerDragEnd = async (event: google.maps.MapMouseEvent) => {
    const lat = event.latLng?.lat();
    const lng = event.latLng?.lng();

    if (!lat || !lng) return;

    setSelectedLocation({ lat, lng });

    try {
      const geocoder = new window.google.maps.Geocoder();
      const response = await geocoder.geocode({ location: { lat, lng } });

      if (response.results[0]) {
        const place = response.results[0];
        const addressComponents = place.address_components;

        const getComponent = (type: string) => {
          const component = addressComponents.find((c: any) =>
            c.types.includes(type)
          );
          return component
            ? { long_name: component.long_name, short_name: component.short_name }
            : { long_name: "", short_name: "" };
        };

        const streetNumber = getComponent("street_number").long_name;
        const route = getComponent("route").long_name;
        const cityObj =
          getComponent("locality") ||
          getComponent("administrative_area_level_2");
        const stateObj = getComponent("administrative_area_level_1");
        const postalCode = getComponent("postal_code").long_name;
        const countryObj = getComponent("country");

        const street = `${streetNumber} ${route}`.trim();

        const addressDetails: Address = {
          _id: "",
          label: place.formatted_address,
          addressLine1: street,
          addressLine2: "",
          country: countryObj.long_name,
          county: cityObj.long_name,
          city: cityObj.long_name,
          state: stateObj.long_name,
          zip: postalCode,
          cityCode: cityObj.short_name,
          stateCode: stateObj.short_name,
          countryCode: countryObj.short_name,
          latitude: lat,
          longitude: lng,
          phone: "",
        };

        // Build the full Addresses object (matches your imported type)
        const newAddresses: Addresses = {
          _id: "",
          user_id: "",
          user_type: "",
          label: place.formatted_address,
          first_name: "",
          last_name: "",
          company: "",
          default_address: false,
          address_details: addressDetails,
          created_by: {
            id: userId || "",
            name: userName || "",

          },
          updated_by: {
            id: userId || "",
            name: userName || "",
          },
        };

        setInstallationAddress(newAddresses);
        formik.setFieldValue("installationAddressId", place.formatted_address);

        // If installation address is changed in edit mode, set isSameAsBilling to false
        if (isEdit) {
          formik.setFieldValue("isSameAsBilling", false);
        }
        triggerRecomputeWithRef.current?.();
      }
    } catch (error) {
      safeConsole.error("Geocoder failed", error);
      showError("Unable to update address from marker position.");
      // Send error email notification
      await handleApiError(error, {
        module: "installation",
        action: "Signage_Installation_Work_Order_geocode_address",
        userId: userId || undefined,
        licenseType: licenseType || undefined,
        userName: userName || undefined,
        url: "Google Maps Geocoder API",
        method: "GET",
        additionalInfo: {
          lat: event.latLng?.lat() || null,
          lng: event.latLng?.lng() || null
        }
      }, token);
    }
  };

  const updateProductionStatus = async (productId: string, variantId: string, productionStatus: string) => {
    if (!installationId || !token) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/update_production_status`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            product_id: productId,
            variant_id: variantId,
            production_status: productionStatus,
          }),
        }
      );

      const data = await response.json();
      // console.log("updateProductionStatus:", data);

      if (!response.ok) {
        showError(data?.error || "Failed to update production status");
        return;
      }

      showSuccess("Production status updated successfully!");
      await fetchOrderDetails();
    } catch (err: any) {
      showError(err.message || "Error updating production status");
      // Send error email notification
      const productionStatusPayload = {
        product_id: productId,
        variant_id: variantId,
        production_status: productionStatus,
      };
      await handleApiError(err, {
        module: "installation",
        action: "Signage_Installation_Work_Order_update_production_status",
        userId: userId || undefined,
        licenseType: licenseType || undefined,
        userName: userName || undefined,
        url: `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/update_production_status`,
        method: "PUT",
        requestBody: productionStatusPayload,
        additionalInfo: {
          installationId: installationId || null,
          productId: productId || null,
          variantId: variantId || null
        }
      }, token);
    }
  };

  useEffect(() => {
    const fetchInstallationLocations = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/installation_locations`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Failed to load locations");
        // console.log("Fetched Installation Locations:", data.locations);
        setInstallationLocations(data.locations || []);
      } catch (err: any) {
        safeConsole.error("Error loading locations:", err.message);
        showError("Failed to load installation markers");
        // Send error email notification
        await handleApiError(err, {
          module: "installation",
          action: "Signage_Installation_Work_Order_fetch_installation_locations",
          userId: userId || undefined,
          licenseType: licenseType || undefined,
          userName: userName || undefined,
          url: `${process.env.REACT_APP_API_URL}/installation_locations`,
          method: "GET"
        }, token);
      }
    };

    fetchInstallationLocations();
  }, []);

  const getInstallationLocationById = async (locationId: string) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/installation_locations/${locationId}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Failed to fetch location");

      // console.log("Installation Location:", data);
      return data;
    } catch (error: any) {
      safeConsole.error("Fetch Location Error:", error.message);
      showError("Failed to fetch installation location.");
      // Send error email notification
      await handleApiError(error, {
        module: "installation",
        action: "Signage_Installation_Work_Order_get_installation_location_by_id",
        userId: userId || undefined,
        licenseType: licenseType || undefined,
        userName: userName || undefined,
        url: `${process.env.REACT_APP_API_URL}/installation_locations/${locationId}`,
        method: "GET",
        additionalInfo: {
          locationId: locationId || null
        }
      }, token);
      return null;
    }
  };

  const handleInstallationStatus = async (nextStatus: number): Promise<boolean> => {
    if (!installationId || !token) return false;

    setLoading(true);

    let action: "finalize" | "schedule" | "in_progress" | "complete" | "cancel" | null = null;
    let body: any = undefined;
    try {

      const scheduledDate = installationOrder?.installation_details?.scheduled_date;

      switch (nextStatus) {
        case 200: // Finalize
          action = "finalize";
          break;

        case 300: { // Schedule / Reschedule
          const newDate = formik.values.scheduled_date;
          action = "schedule";
          body = {
            installation_details: {
              // TODO: restore `new Date(newDate).toISOString()` once scheduled-date is required again.
              scheduled_date: toScheduleIso(
                newDate,
                installationOrder?.installation_details?.scheduled_date
              ),
              ...buildInstallationDetailsParticipantFields({
                role: "signage_assignee",
                selection: selectedInstaller,
                fallbackOrgId: effectiveSignageOrgId,
                fallbackName: selectedInstaller?.label,
                fallbackPhone: selectedInstaller?.phone,
              }),
            },
            note: formik.values.instructions,
          };
          break;
        }

        case 400:
          action = "in_progress";
          body = { note: formik.values.instructions };
          break;

        case 500:
          // Reuse existing TaxCloud cart eligibility logic used by "Get Live Tax".
          const selectedFeesForTax = getSelectedFees();
          const selectedFeesForCartTax = getSelectedFeesForCart();
          const mergedFeesForTax =
            selectedFeesForTax.length > 0 ? selectedFeesForTax : selectedFeesForCartTax;
          const taxableCartProducts = buildProductsMerged(mergedFeesForTax);
          const hasAnyTaxableCartLine = taxableCartProducts.length > 0;
          if (
            taxType === "taxcloud" &&
            hasAnyTaxableCartLine &&
            installationOrder?.tax_status !== "complete"
          ) {
            const reported = await handleLiveTaxNext();
            if (!reported) {
              setLoading(false);
              return false;
            }
          }
          // Upload selected proof images when user clicks Complete.
          if (proofUploadHandlerRef.current) {
            await proofUploadHandlerRef.current();
          }
          action = "complete";
          break;

        case 600:
          let refundSuccess = false;
          let nextTaxStatus = installationOrder?.tax_status || "draft";

          try {
            const forceType =
              installationOrder?.tax_status === "complete" ? "taxcloud" : undefined;

            refundSuccess = await (
              installationTaxRef.current?.recalculate?.(forceType, {
                allowRefund: true,
              }) ?? false
            );

            // console.log("[INSTALL:ORDER_SUBMIT] tax recalc result:", { refundSuccess });

            // 👉 RUN THIS ONLY IF refund is successful
            if (refundSuccess) {
              const order_type = installationOrder?.order_type || "installation";

              const res = await PostVersionOrdernumber(
                token,
                installationOrder?.order_number || "",
                order_type
              );

              // console.log("[INSTALL:ORDER_SUBMIT] TaxCloud refund result:", { res });

              if (!res) throw new Error("TaxCloud refund failed");
            } else {
              safeConsole.log("[INSTALL:ORDER_SUBMIT] Refund NOT successful → skipping PostVersionOrdernumber");
            }

          } catch (err) {
            safeConsole.error("[INSTALL:ORDER_SUBMIT] tax recalc failed", err);
          }

          action = "cancel";
          body = { note: formik.values.instructions };
          break;

        default:
          showError("Invalid status selected");
          setLoading(false);
          return false;
      }

      if (!action) {
        showError("Invalid status selected");
        setLoading(false);
        return false;
      }

      const response = await postInstallationOrderAction(token, installationId, action, body);

      const result = await response.json();
      if (!response.ok) throw new Error(result?.error);

      showSuccess(result.message || "Installation status updated");
      setInstallationOrder((prev: any) => ({ ...prev, status: nextStatus }));

      // Send emails for status changes and cancellation
      try {
        const from = process.env.REACT_APP_FROM_EMAIL2;
        if (from && installationOrder) {
          // Fetch updated order
          let updatedOrder = installationOrder;
          try {
            updatedOrder = await fetchInstallationOrderByIdUnwrapped(token, installationId);
          } catch (err) {
            safeConsole.warn("Failed to fetch updated order, using existing:", err);
          }

          // Import user data fetcher
          const { fetchUserData } = await import("utils/userDataFetcher");

          // Format order ID
          const orderId = `#${updatedOrder.order_number || updatedOrder._id || "INST-XXXX"}`;

          // Get agent name and brokerage firm name
          const agentName = updatedOrder.agent_name || "N/A";
          const brokerageFirm = updatedOrder.brokerage_firm_name || "N/A";

          // Format property address
          const propertyAddr = updatedOrder.installation_details?.installation_address?.address_details
            ? `${updatedOrder.installation_details.installation_address.address_details.addressLine1 || ""}, ${updatedOrder.installation_details.installation_address.address_details.city || ""}, ${updatedOrder.installation_details.installation_address.address_details.state || ""} ${updatedOrder.installation_details.installation_address.address_details.zip || ""}`.trim().replace(/^,\s*|,\s*$/g, "")
            : "N/A";

          // Build base URL for order links
          const baseUrl = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
          const viewOrderUrl = `${baseUrl}${baseRoute}/jobs/installationWorkOrder/${updatedOrder._id}`;
          const createOrderUrl = `${baseUrl}/agent/orders`;

          // Get current user info
          const currentUserName = userName || "";
          const signageCompanyName = updatedOrder.signage_company_name || "Signage Company";

          if (nextStatus === 600) {
            // Backend sends "Signage Installation order Canceled" emails.
            // const installationOrderIdForEmail = String(
            //   updatedOrder?._id || updatedOrder?.id || installationId || ""
            // ).trim();
            // if (installationOrderIdForEmail) {
            //   await sendInstallationOrderTriggerEmail({
            //     triggerName: "Signage Installation order Canceled",
            //     installationOrderId: installationOrderIdForEmail,
            //     token: token || "",
            //     fromEmail: from,
            //   });
            // }

            // ✅ Trigger: Installation Order Canceled - Send notifications
            try {
              const { createNotification } = await import("../../services/notificationApi");
              const { getInstallationOrderCanceledContent } = await import("../../services/notificationContent");

              // Send notification to Signage Admin/Team Member
              if (updatedOrder.signage_id && token) {
                try {
                  const signageData = await fetchUserData(resolveInstallationSellerMembershipId(updatedOrder), token);
                  if (signageData?.id) {
                    const signageContent = getInstallationOrderCanceledContent({
                      orderId: orderId,
                      canceledBy: agentName || brokerageFirm || "Agent/Brokerage admin/team member",
                      recipientType: signageData.licenseType === "SIGNAGE_TEAM_MEMBER" ? "team_member" : "signage_admin",
                    });
                    await createNotification(updatedOrder.signage_id, signageContent, token || "", signageData.licenseType === "SIGNAGE_TEAM_MEMBER" ? "team_member" : "signage_admin");
                  }
                } catch (err) {
                  safeConsole.warn("Failed to send cancellation notification to signage:", err);
                }
              }

              // Send notification to single end user (effectiveCouponCreatedById) only
              if (effectiveCouponCreatedById && token) {
                try {
                  const endUserData = await fetchUserData(resolveInstallationPaymentMethodsMembershipId(installationOrder) || effectiveCouponCreatedById, token);
                  if (endUserData?.id) {
                    // Determine recipientType based on licenseType
                    let recipientType: "agent" | "brokerage_team" = "agent";
                    if (endUserData.licenseType === "BROKERAGE_FIRM" || endUserData.licenseType === "BROKERAGE_TEAM_MEMBER") {
                      recipientType = "brokerage_team";
                    } else if (endUserData.licenseType === "AGENT" || endUserData.licenseType === "BROKERAGE_AGENT") {
                      recipientType = "agent";
                    }

                    const endUserContent = getInstallationOrderCanceledContent({
                      orderId: orderId,
                      supplierName: signageCompanyName,
                      recipientType: recipientType,
                    });
                    await createNotification(effectiveCouponCreatedById, endUserContent, token || "", recipientType);
                  }
                } catch (err) {
                  safeConsole.warn("Failed to send cancellation notification to end user:", err);
                }
              }
            } catch (notifError) {
              safeConsole.warn("Failed to send cancellation notifications:", notifError);
            }
          } else if (nextStatus === 300 || nextStatus === 500) {
            // Schedule (300): "Finalized & Scheduled". Complete (500): "Completed". No email on Confirm 200 / In Progress 400.
            const newStatus = nextStatus === 300 ? "Finalized & Scheduled" : "Completed";
            const updateTime = new Date().toLocaleString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true
            });
            const updatedBy = currentUserName || "Signage Team Member";

            const installationOrderIdForEmail = String(
              updatedOrder?._id || updatedOrder?.id || installationId || ""
            ).trim();
            // Backend sends schedule/complete status emails.
            // if (installationOrderIdForEmail) {
            //   await sendInstallationOrderTriggerEmail({
            //     triggerName: "Signage Installation Status change",
            //     installationOrderId: installationOrderIdForEmail,
            //     token: token || "",
            //     fromEmail: from,
            //     installationStatusCode: nextStatus,
            //   });
            // }
            void installationOrderIdForEmail;
            void newStatus;
            void updateTime;
            void updatedBy;

            // ✅ Trigger: Installation Status Change - Send notifications
            try {
              const { createNotification } = await import("../../services/notificationApi");
              const { getInstallationStatusChangeContent } = await import("../../services/notificationContent");
              const { fetchUserData } = await import("../../utils/userDataFetcher");

              // Send notification to single end user (effectiveCouponCreatedById) only
              if (effectiveCouponCreatedById && token) {
                try {
                  const endUserData = await fetchUserData(resolveInstallationPaymentMethodsMembershipId(installationOrder) || effectiveCouponCreatedById, token);
                  if (endUserData?.id) {
                    // Determine recipientType based on licenseType
                    let recipientType: "agent" | "brokerage_team" = "agent";
                    if (endUserData.licenseType === "BROKERAGE_FIRM" || endUserData.licenseType === "BROKERAGE_TEAM_MEMBER") {
                      recipientType = "brokerage_team";
                    } else if (endUserData.licenseType === "AGENT" || endUserData.licenseType === "BROKERAGE_AGENT") {
                      recipientType = "agent";
                    }

                    const endUserContent = getInstallationStatusChangeContent({
                      orderId: orderId,
                      newStatus: newStatus,
                      recipientType: recipientType,
                    });
                    await createNotification(effectiveCouponCreatedById, endUserContent, token || "", recipientType);
                  }
                } catch (err) {
                  safeConsole.warn("Failed to send status change notification to end user:", err);
                }
              }
            } catch (notifError) {
              safeConsole.warn("Failed to send status change notifications:", notifError);
            }
          }
        }
      } catch (emailError) {
        safeConsole.warn("Failed to send status change/cancellation emails:", emailError);
        // Don't block status update if email fails
      }

      safeNavigate(0); // Refresh the page to reflect changes
      return true;
    } catch (err: any) {
      safeConsole.error("Status update error:", err.message);
      showError(err.message || "Something went wrong");
      // Send error email notification
      let statusUpdatePayload: any = undefined;
      if (body) {
        statusUpdatePayload = body;
      }
      await handleApiError(err, {
        module: "installation",
        action: "Signage_Installation_Work_Order_handle_installation_status",
        userId: userId || undefined,
        licenseType: licenseType || undefined,
        userName: userName || undefined,
        url: url || "",
        method: "POST",
        requestBody: statusUpdatePayload,
        additionalInfo: {
          installationId: installationId || null,
          nextStatus: nextStatus || null
        }
      }, token);
      return false;
    } finally {
      setLoading(false);
    }
  };

  // geting the defult selectedAgent and installetion Addreess and getting the brokarageForms
  // useEffect(() => {
  //   if (installationOrder?.agent_id && agents.length > 0) {
  //     const matchedAgent = agents.find(agent => agent.id === installationOrder.agent_id);
  //     if (matchedAgent) {
  //       const option = {
  //         value: matchedAgent.id,
  //         label: `${matchedAgent.firstName} ${matchedAgent.lastName}`,
  //         firstName: matchedAgent.firstName,
  //         lastName: matchedAgent.lastName,
  //         email: matchedAgent.email,
  //         phone: matchedAgent.phone1,
  //       };
  //       setSelectedAgent(option);
  //       fetchLinkedProducts("agent", option.value);
  //     }
  //   }

  //   if (installationOrder?.installation_details?.installation_address) {
  //     setInstallationAddress(installationOrder.installation_details.installation_address);
  //   }

  //   if (installationOrder?.user_type) {
  //     fetchBrokerageFirms(installationOrder.user_type);
  //   }
  // }, [installationOrder, agents]);


  useEffect(() => {
    // ✅ Fetch agent by ID using Select2 endpoint for initialization
    const initializeAgent = async () => {
      if (installationOrder?.agent_id) {
        // First check officeAgents (already loaded)
        if (Array.isArray(officeAgents) && officeAgents.length > 0) {
          const matchedAgent = officeAgents.find(agent => agent.id === installationOrder.agent_id);
          if (matchedAgent) {
            const option = {
              value: matchedAgent.id,
              label: `${matchedAgent.firstName} ${matchedAgent.lastName}`,
              firstName: matchedAgent.firstName,
              lastName: matchedAgent.lastName,
              email: matchedAgent.email,
              phone: matchedAgent.phone1,
            };
            setSelectedOfficeAgent(option);
            // fetchLinkedProducts("agent", option.value);
            return;
          }
        }

        // If not found in officeAgents, fetch from Select2 endpoint
        const agentOption = await fetchAgentById(installationOrder.agent_id);
        if (agentOption) {
          setSelectedAgent(agentOption);
          // fetchLinkedProducts("agent", agentOption.value);
        }
      }
    };

    initializeAgent();

    if (installationOrder?.installation_details?.installation_address) {
      setInstallationAddress(installationOrder.installation_details.installation_address);
    }
  }, [installationOrder, officeAgents, fetchAgentById]);


  // Initialize brokerage firm from installation order
  useEffect(() => {
    if (installationOrder?.brokerage_firm_id && installationOrder?.brokerage_firm_name) {
      const brokerageFirmOption = {
        value: installationOrder.brokerage_firm_id,
        label: installationOrder.brokerage_firm_name,
        firstName: installationOrder.brokerage_firm_admin || installationOrder.brokerage_firm_name.split(' ')[0] || '',
        lastName: '',
        email: '',
        phone: '',
      };
      setSelectedBrokerageFirm(brokerageFirmOption);
    }
  }, [installationOrder?.brokerage_firm_id, installationOrder?.brokerage_firm_name]);

  // Initialize team member selection from installation order
  useEffect(() => {
    if (installationOrder?.team_member_id && installationOrder?.team_member_name) {
      const teamMemberOption: TeamMemberOption = {
        value: installationOrder.team_member_id,
        label: installationOrder.team_member_name,
        firstName: installationOrder.team_member_name.split(' ')[0] || '',
        lastName: installationOrder.team_member_name.split(' ')[1] || '',
        email: installationOrder.user_email || '',
        phone: installationOrder.user_phone || '',
        offices: installationOrder.office ? [installationOrder.office] : []
      };
      setSelectedTeamMemberOption(teamMemberOption);

      // Set offices from installation order
      if (installationOrder.office) {
        setOffices([installationOrder.office]);
      }
    }
  }, [installationOrder?.team_member_id, installationOrder?.team_member_name]);

  // Initialize office selection from installation order
  useEffect(() => {
    if (installationOrder?.office?._id && offices.length > 0) {
      const officeOption = {
        value: installationOrder.office._id,
        label: installationOrder.office.officeName,
        firstName: installationOrder.office.officeName,
        lastName: installationOrder.office.officeName,
        email: '',
        phone: installationOrder.office.officeAddress?.phone || ''
      };
      setSelectedOffice(officeOption);

      // Fetch agents for this office if agent_id exists
      if (installationOrder.agent_id) {
        fetchOfficeAgents(officeOption);
      }
    }
  }, [installationOrder?.office?._id, offices.length]);

  // Initialize installer selection from installation order
  useEffect(() => {
    const details = installationOrder?.installation_details as Record<string, unknown> | undefined;
    const restored = installationDetailsParticipantFromSaved(details, {
      sellerOrgId: effectiveSignageOrgId,
      sellerName: installationOrder?.signage_company_name,
    });
    if (restored?.value) {
      const installerOption: SignageTeamMemberOption = {
        value: String(restored.value),
        label: String(restored.label || restored.value),
        firstName: String(restored.label || "").split(" ")[0] || "",
        lastName: String(restored.label || "").split(" ").slice(1).join(" ") || "",
        email: "",
        phone: String(restored.phone ?? ""),
        membershipId: restored.membershipId ? String(restored.membershipId) : undefined,
        globalUserId: restored.globalUserId ? String(restored.globalUserId) : undefined,
        organizationId: String(restored.organizationId || effectiveSignageOrgId || "").trim() || undefined,
      };
      setSelectedInstaller(installerOption);
      setSelectedInstallerOption(installerOption);
    }
  }, [
    installationOrder?.installation_details?.installer_membership_id,
    installationOrder?.installation_details?.installer_org_id,
    installationOrder?.installation_details?.installer_id,
    installationOrder?.installation_details?.installer_name,
    effectiveSignageOrgId,
  ]);

  // Fetch addresses, set selected user, and fetch linked products based on the order's user type when order is loaded
  useEffect(() => {
    if (!installationOrder) return;

    // Determine which user to set and fetch addresses for
    // Priority: office agent > agent > team member
    let userIdForAddresses = null;
    let userTypeForProducts: "agent" | "office" | null = null;

    // Check if this is an office agent order (has both agent and office)
    if (
      (installationOrder.agent_membership_id || installationOrder.agent_id) &&
      installationOrder.office?._id
    ) {
      userIdForAddresses =
        installationOrder.agent_membership_id || installationOrder.agent_id;
      userTypeForProducts = "agent";

      // Set brokerage firm if available
      if (installationOrder.brokerage_firm_id && installationOrder.brokerage_firm_name) {
        const brokerageFirmOption = {
          value: installationOrder.brokerage_firm_id,
          label: installationOrder.brokerage_firm_name,
          firstName: installationOrder.brokerage_firm_admin?.split(' ')[0] || "",
          lastName: installationOrder.brokerage_firm_admin?.split(' ').slice(1).join(' ') || "",
          email: "",
          phone: "",
        };
        setSelectedBrokerageFirm(brokerageFirmOption);
      }

      // Set office agent option
      const agentOption = {
        value: installationOrder.agent_membership_id || installationOrder.agent_id,
        label: installationOrder.agent_name || "",
        firstName: installationOrder.agent_name?.split(' ')[0] || "",
        lastName: installationOrder.agent_name?.split(' ').slice(1).join(' ') || "",
        email: installationOrder.user_email || "",
        phone: installationOrder.user_phone || "",
        membershipId: installationOrder.agent_membership_id || installationOrder.agent_id,
      };
      setSelectedOfficeAgent(agentOption);

      // Also set the office
      const officeOption = {
        value: installationOrder.office._id,
        label: installationOrder.office.officeName || "",
        firstName: installationOrder.office.officeName || "",
        lastName: "",
        email: "",
        phone: "",
      };
      setSelectedOffice(officeOption);

      // Fetch linked products for office agent
      // fetchLinkedProducts("agent", installationOrder.agent_id);
    }
    // Check if this is a standalone agent order (has agent but no office)
    else if (
      (installationOrder.agent_membership_id || installationOrder.agent_id) &&
      !installationOrder.office?._id
    ) {
      userIdForAddresses =
        installationOrder.agent_membership_id || installationOrder.agent_id;
      userTypeForProducts = "agent";

      // Set agent option
      const agentOption = {
        value: installationOrder.agent_membership_id || installationOrder.agent_id,
        label: installationOrder.agent_name || "",
        firstName: installationOrder.agent_name?.split(' ')[0] || "",
        lastName: installationOrder.agent_name?.split(' ').slice(1).join(' ') || "",
        email: installationOrder.user_email || "",
        phone: installationOrder.user_phone || "",
        membershipId: installationOrder.agent_membership_id || installationOrder.agent_id,
      };
      setSelectedAgent(agentOption);

      // Fetch linked products for standalone agent
      // fetchLinkedProducts("agent", installationOrder.agent_id);
    }
    // Check if this is a team member/office order (has team_member_id)
    else if (
      installationOrder.team_member_membership_id ||
      installationOrder.team_member_id
    ) {
      const tmMembershipId =
        installationOrder.team_member_membership_id ||
        installationOrder.team_member_id;

      // If order has an office but no agent, it's an office order
      if (
        installationOrder.office?._id &&
        !(installationOrder.agent_membership_id || installationOrder.agent_id)
      ) {
        userIdForAddresses = tmMembershipId;
        userTypeForProducts = "office";

        // Fetch linked products for office
        if (installationOrder.office._id) {
          // fetchLinkedProducts("office", installationOrder.office._id);
        }
      } else {
        // Otherwise treat as team member managing agents
        userIdForAddresses = tmMembershipId;
      }

      // Set brokerage firm if available
      if (installationOrder.brokerage_firm_id && installationOrder.brokerage_firm_name) {
        const brokerageFirmOption = {
          value: installationOrder.brokerage_firm_id,
          label: installationOrder.brokerage_firm_name,
          firstName: installationOrder.brokerage_firm_admin?.split(' ')[0] || "",
          lastName: installationOrder.brokerage_firm_admin?.split(' ').slice(1).join(' ') || "",
          email: "",
          phone: "",
        };
        setSelectedBrokerageFirm(brokerageFirmOption);
      }

      // Set team member option
      const teamMemberOption: TeamMemberOption = {
        value: tmMembershipId,
        label: installationOrder.team_member_name || "",
        firstName: installationOrder.team_member_name?.split(' ')[0] || "",
        lastName: installationOrder.team_member_name?.split(' ').slice(1).join(' ') || "",
        email: installationOrder.user_email || "",
        phone: installationOrder.user_phone || "",
        membershipId: tmMembershipId,
        offices: installationOrder.office ? [installationOrder.office] : []
      };
      setSelectedTeamMemberOption(teamMemberOption);

      // If order has office, set it
      if (installationOrder.office?._id) {
        const officeOption = {
          value: installationOrder.office._id,
          label: installationOrder.office.officeName || "",
          firstName: installationOrder.office.officeName || "",
          lastName: "",
          email: "",
          phone: "",
        };
        setSelectedOffice(officeOption);
      }
    }

    // Fetch addresses: office (+ optional TM, no agent) → office; else membership
    const orderOfficeId = String(installationOrder.office?._id || "").trim();
    const orderHasAgent = !!(
      installationOrder.agent_membership_id || installationOrder.agent_id
    );
    const useOfficeAddrs = !!orderOfficeId && !orderHasAgent;
    const addrCacheKey = useOfficeAddrs
      ? `office:${orderOfficeId}`
      : userIdForAddresses;

    if (addrCacheKey && addressObjects.length === 0 && !addressesFetchedRef.current.has(addrCacheKey)) {
      (async () => {
        try {
          const data = useOfficeAddrs
            ? await fetchOfficeAddresses(token || "", orderOfficeId)
            : await fetchUserAddresses(token || "", String(userIdForAddresses));
          setAddressObjects(unwrapAddressListResponse(data));
          addressesFetchedRef.current.add(addrCacheKey);
        } catch (err) {
          safeConsole.error("Failed to fetch addresses for order user:", err);
        }
      })();
    }
  }, [
    installationOrder?.agent_id,
    installationOrder?.agent_membership_id,
    installationOrder?.office?._id,
    installationOrder?.team_member_id,
    installationOrder?.team_member_membership_id,
    installationOrder?.brokerage_firm_id,
    addressObjects.length,
    token
  ]);

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      const membershipId = resolveInstallationPaymentMethodsMembershipId(installationOrder);
      const sellerOrgId = String(
        organizationId ||
          resolveInstallationSellerOrganizationId(
            effectiveSignageOrgId || "",
            installationOrder
          )
      ).trim();
      if (!membershipId || !sellerOrgId || !token) {
        return;
      }
      try {
        const data = await fetchInstallationPaymentMethods(token, sellerOrgId, membershipId);
        setPaymentMethod(Array.isArray(data) ? data : []);
      } catch (err) {
        safeConsole.error("Error fetching payment methods:", err);
      } finally {
        setLoading(false);
      }
    };

    if (userId && installationOrder?.inventory_source) {
      fetchPaymentMethods();
    }
  }, [token, userId, installationOrder?.inventory_source, isSignageTeammember, effectiveSignageOrgId]);

  // setting defult selectedProducts
  useEffect(() => {
    if (installationOrder?.line_items?.length > 0) {
      const rotationalAllocationsMap: { [key: string]: number } = {};

      // Find all rotational products and their allocations - SUM them up for the same source
      installationOrder.line_items.forEach((item: any) => {
        if (item.inventory_source === "rotational" && item.source_product_id) {
          // Convert ObjectId to string if needed
          const sourceId = typeof item.source_product_id === 'object' ?
            item.source_product_id.$oid || item.source_product_id.toString() :
            item.source_product_id;

          // Sum up all rotational allocations for the same source product
          rotationalAllocationsMap[sourceId] = (rotationalAllocationsMap[sourceId] || 0) + (item.rotational_allocated || 0);
        }
      });

      const mapped = installationOrder.line_items?.map((item: any) => {
        // Get product ID in consistent string format
        const productId = typeof item.product_id === 'object' ?
          item.product_id.$oid || item.product_id.toString() :
          item.product_id;

        // For normal products, check if there are any rotational allocations
        const originalQuantity = item.quantity || 0;
        let alreadyAllocated = 0;

        if (item.inventory_source !== "rotational") {
          // For normal products, check rotational allocations
          alreadyAllocated = rotationalAllocationsMap[productId] || 0;
        } else {
          // For rotational products, use their own allocated count
          alreadyAllocated = item.rotational_allocated || 0;
        }

        return {
          product_id: productId,
          variant_id: item.variant_id || "",
          inventory_type: item.inventory_source || "",
          name: item.product_name || "",
          sku: item.sku || "",
          product_location_status: item.current_status || "",
          user_id: installationOrder?.inventory_source === "office" ?
            installationOrder?.office?._id :
            installationOrder?.agent_id,
          quantity: originalQuantity,
          updateStatus: "",
          productionStatus: item.production_status || "",
          is_production: item.is_production,
          is_rotational: item.is_rotational,
          allocatedCount: alreadyAllocated,
          remainingToAllocate: originalQuantity - alreadyAllocated,
          storage_locations: item.storage_locations || [],
          serial_allocations: item.serial_allocations || [],
          unit_price: item.unit_price || 0,
          unit_retail_price: item.unit_retail_price ?? item.unit_price ?? 0,
          changed_unit_price: item.changed_unit_price ?? item.unit_price ?? 0,
          discount_code: String(item.discount_code ?? ""),
          discount_on_unit_quantity: Number(item.discount_on_unit_quantity ?? 0),
          discount_on_total_quantity: Number(
            item.discount_on_total_quantity ?? item.discount ?? item.discount_amount ?? 0
          ),
          discount: Number(item.discount ?? item.discount_on_total_quantity ?? item.discount_amount ?? 0),
          total_price: item.total_price || 0,
          source_product_id: item.source_product_id || null, // Keep this for reference
          is_new_purchase: !!item.is_new_purchase,
          availableqty: 0, // Filled by fetchAvailableQuantities for agent/office only
          is_accessories: !!(item.is_accessories ?? item.is_accessory),
          slot_id: item.slot_id || "",
          images: item.images || [],
          image_url: item.images?.[0]?.url,
          design_id: item.design_id ? String(item.design_id).trim() : undefined,
          design_name: item.design_name ? String(item.design_name).trim() : undefined,
          preview_url: item.preview_url ? String(item.preview_url).trim() : undefined,
          customizations: item.customizations,
          custom_information: item.custom_information || "",
        };
      });

      // Fetch available quantities for existing products
      const loadProductsWithAvailableQuantities = async () => {
        const productsWithAvailableQty = await fetchAvailableQuantities(mapped);
        setSelectedProducts(productsWithAvailableQty);
        // console.log("Mapped Products with correct allocations and available quantities:", productsWithAvailableQty);
      };

      loadProductsWithAvailableQuantities();
    }
  }, [installationOrder]);

  useEffect(() => {
    const ip = installationOrder?.installation_post;
    if (ip?.post_type_id) {
      setInstallationPost(ip as InstallationPostPayload);
    }
  }, [installationOrder?.installation_post?.post_type_id]);

  useEffect(() => {
    if (!token) return;
    const url = `${process.env.REACT_APP_API_URL}/settings/general?permissions=false`;
    fetch(url, { method: "GET", headers: { Authorization: `Bearer ${token}` } })
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error("Failed to load settings"))))
      .then((data: { results?: { key: string; enabled: boolean }[] }) => {
        const list = Array.isArray(data?.results) ? data.results : [];
        const custom = list.find((s) => s.key === GENERAL_SETTINGS_KEYS.CUSTOM_PRODUCT);
        setCustomProductSettingEnabled(custom?.enabled ?? false);
      })
      .catch(() => setCustomProductSettingEnabled(false));
  }, [token]);


  // setting defult allocatedUnits
  // useEffect(() => {
  //   if (!installationOrder?.line_items?.length) return;

  //   type Prefilled = {
  //     [linkedProductId: string]: {
  //       rotationalProductId: string;
  //       warehouseId: string;
  //       serial_id: string;
  //       serial_number: string;
  //       product_name: string;
  //       sku: string;
  //       storage_location: {
  //         warehouse_id: string;
  //         warehouse: string;
  //         zone_id: string;
  //         zone: string;
  //         rack_id: string;
  //         rack: string;
  //         bin_id: string;
  //         bin: string;
  //         // allow passthrough of any extra fields present in alloc
  //         [k: string]: any;
  //       };
  //     }[];
  //   };

  //   const prefilledAllocations: Prefilled = {};

  //   const ZERO_ID = "000000000000000000000000";
  //   const isZeroId = (v?: string) => !v || v === ZERO_ID;

  //   const idToString = (val: any): string => {
  //     if (!val) return "";
  //     if (typeof val === "string") return val;
  //     if (typeof val === "object") {
  //       if ((val as any).$oid) return String((val as any).$oid);
  //       const s = (val as any).toString?.();
  //       if (s && s !== "[object Object]") return String(s);
  //     }
  //     return "";
  //   };

  //   const items = installationOrder.line_items;

  //   // 1) Index rotational items by their source_product_id
  //   const rotationalBySource = new Map<string, any>();
  //   for (const li of items) {
  //     if (li?.inventory_source === "rotational" && !isZeroId(li?.source_product_id)) {
  //       // There can be multiple rotational rows for the same source; merge arrays
  //       const existing = rotationalBySource.get(li.source_product_id);
  //       if (existing) {
  //         // merge serial_allocations if both exist
  //         existing.serial_allocations = [
  //           ...(existing.serial_allocations || []),
  //           ...(li.serial_allocations || []),
  //         ];
  //       } else {
  //         rotationalBySource.set(li.source_product_id, { ...li });
  //       }
  //     }
  //   }

  //   // 2) For each NORMAL product, find its rotational twin by source_product_id === normal.product_id
  //   for (const normal of items) {
  //     if (normal?.inventory_source === "rotational") continue; // skip rotational rows here

  //     const normalProductId: string | undefined = normal?.product_id;
  //     if (!normalProductId) continue;

  //     const rotational = rotationalBySource.get(normalProductId);
  //     if (!rotational || !Array.isArray(rotational.serial_allocations)) continue;

  //     // Build allocations for this normal product id (use ROTATIONAL product details)
  //     const allocations = rotational.serial_allocations.map((alloc: any) => ({
  //       rotationalProductId: idToString(rotational.product_id),
  //       warehouseId: idToString(alloc.warehouse_id) || "",
  //       serial_id: idToString(alloc.serial_id) || "",
  //       serial_number: alloc.serial_code || alloc.serial_number || "",
  //       product_name: rotational.product_name || "Unknown Product",
  //       sku: rotational.sku || normal.sku || "",
  //       storage_location: { ...alloc },
  //     }));

  //     if (allocations.length) {
  //       prefilledAllocations[normalProductId] = allocations;
  //     }
  //   }

  //   setAllocatedUnits(prefilledAllocations);
  //   console.log("Allocated Units (by normal product_id):", prefilledAllocations);
  // }, [installationOrder]);



  const [integrations, setIntegrations] = useState<PaymentGateway[]>([]);

  useEffect(() => {
    const fetchIntegrations = async () => {
      try {
        const sellerOrgId = String(
          organizationId ||
            resolveInstallationSellerOrganizationId(
              effectiveSignageOrgId || "",
              installationOrder
            )
        ).trim();
        const data = await fetchInstallationPaymentGateway(token, sellerOrgId);
        setIntegrations(Array.isArray(data) ? data : data ? [data] : []);
      } catch (err) {
        // showError("Failed to load integrations.");
        setError(err instanceof Error ? err.message : "An unknown error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchIntegrations();
  }, [token, isSignageTeammember, effectiveSignageOrgId, userId]);

  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null);


  useEffect(() => {
    const stripeInfo = integrations?.find((method) => method.gateway === "stripe");
    // console.log('Stripe info ', stripeInfo);
    if (stripeInfo && stripeInfo.publishable_key) {
      const promise = loadStripe(stripeInfo.publishable_key);
      setStripePromise(promise);
    }
  }, [integrations]);

  // Helper function to send payment applied emails for installation orders
  const normalizePaymentMethodName = (name: string): string =>
    String(name || "").trim().toLowerCase().replace(/\s+/g, "_");
  const shouldSkipPaymentAppliedEmail = (paymentMethodName: string, isDynamicMethod: boolean): boolean => {
    const methodKey = normalizePaymentMethodName(paymentMethodName);
    return methodKey === "store_paid" || isDynamicMethod;
  };

  const sendInstallationPaymentAppliedEmails = async (
    updatedOrder: any,
    paymentAmountValue: number,
    paymentMethodName: string,
    fromEmail: string,
    isDynamicMethod: boolean = false
  ) => {
    if (!fromEmail || !updatedOrder) {
      safeConsole.warn("sendInstallationPaymentAppliedEmails: Missing fromEmail or updatedOrder", { fromEmail: !!fromEmail, updatedOrder: !!updatedOrder });
      return;
    }
    if (shouldSkipPaymentAppliedEmail(paymentMethodName, isDynamicMethod)) {
      safeConsole.log("sendInstallationPaymentAppliedEmails: skipped for payment method", { paymentMethodName, isDynamicMethod });
      return;
    }

    try {
      safeConsole.log("sendInstallationPaymentAppliedEmails: Starting email send", {
        orderId: updatedOrder._id || updatedOrder.id,
        paymentAmountValue,
        paymentMethodName
      });

      // Import user data fetcher
      const { fetchUserData } = await import("utils/userDataFetcher");

      // Format order ID
      const orderId = `#${updatedOrder.order_number || updatedOrder._id || updatedOrder.id || "INST-XXXX"}`;

      // Get payment details from updated order
      const paymentInfoArray = Array.isArray(updatedOrder.payment_info) ? updatedOrder.payment_info : [];
      const latestPayment = paymentInfoArray.length > 0
        ? paymentInfoArray.reduce((latest: any, current: any) => {
            const latestDate = new Date(latest?.payment_date || 0).getTime();
            const currentDate = new Date(current?.payment_date || 0).getTime();
            return currentDate > latestDate ? current : latest;
          }, paymentInfoArray[0])
        : null;

      // Format payment amount - use latest payment if available, otherwise use the passed value
      const paymentAmount = latestPayment?.amount_paid
        ? `$${Number(latestPayment.amount_paid).toFixed(2)}`
        : `$${Number(paymentAmountValue).toFixed(2)}`;

      // Format payment date
      const paymentDate = latestPayment?.payment_date
        ? new Date(latestPayment.payment_date).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
        : new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });

      // Format payment method
      const formattedPaymentMethod = paymentMethodName === "online"
        ? "Credit Card"
        : paymentMethodName === "bank_transfer"
          ? "Bank Transfer"
          : paymentMethodName === "cheque"
            ? "Cheque"
            : paymentMethodName === "store_paid"
              ? "Store Paid"
              : paymentMethodName;

      // Calculate remaining balance from updated order
      const totalPaidAfter = paymentInfoArray.reduce(
        (acc: number, p: any) => acc + Number(p?.amount_paid || 0),
        0
      );
      const remainingBalance = Math.max(0, Number(updatedOrder.total_amount || 0) - totalPaidAfter);
      const currentBalance = remainingBalance > 0 ? `$${remainingBalance.toFixed(2)}` : "$0.00";

      let paymentPdfAttachment: Record<string, string> | undefined;
      try {
        const installationOrderId = String(updatedOrder?._id || updatedOrder?.id || "").trim();
        // After UI payment, the PDF route can 404/503 until the server finishes persisting the job.
        // Retry with backoff so we do not block/truncate the email send on a race with refresh/navigation.
        paymentPdfAttachment = await buildInstallationOrderPdfAttachment({
          installationOrderId,
          token: token || "",
          fileLabel: orderId,
          pdfFetch: {
            maxAttempts: 8,
            initialDelayMs: 600,
            retryDelayMs: 650,
            perFetchTimeoutMs: 18_000,
          },
        });
      } catch (pdfErr) {
        safeConsole.warn("Payment-applied installation order PDF attachment fetch failed:", pdfErr);
      }

      // Determine who applied the payment - current user from membership id
      const currentUserId = membershipId || globalUserId;
      let currentUserData = null;
      if (currentUserId) {
        currentUserData = await fetchUserData(currentUserId, token);
      }

      const currentUserLicenseType = currentUserData?.licenseType || getAuthCookie("licenseType") || "";
      const currentUserEmail = currentUserData?.email || "";
      const currentUserName = currentUserData?.firstName ? `${currentUserData.firstName} ${currentUserData.lastName || ""}`.trim() : userName || "";

      let userRoleName = "User";
      if (currentUserLicenseType === "SIGNAGE_FIRM") {
        userRoleName = "Signage Admin";
      } else if (currentUserLicenseType === "SIGNAGE_TEAM_MEMBER") {
        userRoleName = "Signage Team Member";
      } else if (currentUserLicenseType === "BROKERAGE_FIRM") {
        userRoleName = "Brokerage Firm Admin";
      } else if (currentUserLicenseType === "BROKERAGE_TEAM_MEMBER") {
        userRoleName = "Brokerage Team Member";
      } else if (currentUserLicenseType === "AGENT" || currentUserLicenseType === "BROKERAGE_AGENT") {
        userRoleName = "Agent";
      }

      const paidByUser = (latestPayment as any)?.paid_by?.name || currentUserName || "User";
      const paidByEmail = (latestPayment as any)?.paid_by?.email || currentUserEmail || "";
       const paymentAppliedBy = `(${paidByEmail})`;
      // const paymentAppliedBy = `${userRoleName} (${paidByEmail})`;

      // Get agent name and brokerage firm name
      const agentName = updatedOrder.agent_name || "N/A";
      const brokerageFirm = updatedOrder.brokerage_firm_name || "N/A";

      // Format property address
      const propertyAddr = updatedOrder.installation_details?.installation_address?.address_details
        ? `${updatedOrder.installation_details.installation_address.address_details.addressLine1 || ""}, ${updatedOrder.installation_details.installation_address.address_details.city || ""}, ${updatedOrder.installation_details.installation_address.address_details.state || ""} ${updatedOrder.installation_details.installation_address.address_details.zip || ""}`.trim().replace(/^,\s*|,\s*$/g, "")
        : "N/A";

      // Build base URL for order links
      const baseUrl = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
      const viewOrderUrl = `${baseUrl}${baseRoute}/jobs/installationWorkOrder/${updatedOrder._id || updatedOrder.id}`;

      // Determine recipients based on who applied the payment
      const isBrokerageUser = currentUserLicenseType === "BROKERAGE_FIRM" || currentUserLicenseType === "BROKERAGE_TEAM_MEMBER";
      const isAgentUser = currentUserLicenseType === "AGENT" || currentUserLicenseType === "BROKERAGE_AGENT";

      const installationOrderIdForEmail = String(
        updatedOrder?._id || updatedOrder?.id || installationId || ""
      ).trim();
      // if (installationOrderIdForEmail && token) {
      //   await sendInstallationOrderTriggerEmail({
      //     triggerName: "Signage Payment applied for Installation Job",
      //     installationOrderId: installationOrderIdForEmail,
      //     token: token || "",
      //     fromEmail,
      //     includeOrderPdfAttachment: true,
      //   });
      // }

      // ✅ Trigger: Installation Payment Applied - Send notifications
      try {
        const { createNotification } = await import("../../services/notificationApi");
        const { getInstallationPaymentAppliedContent } = await import("../../services/notificationContent");

        // If payment was applied by brokerage/agent, notify signage admin/team member (internal)
        if ((isBrokerageUser || isAgentUser) && updatedOrder.signage_id) {
          try {
            const { fetchUserData } = await import("../../utils/userDataFetcher");
            const signageData = await fetchUserData(resolveInstallationSellerMembershipId(updatedOrder), token);
            if (signageData?.id) {
              const signageContent = getInstallationPaymentAppliedContent({
                orderId: orderId,
                amount: paymentAmount,
                recipientType: signageData.licenseType === "SIGNAGE_TEAM_MEMBER" ? "team_member" : "signage_admin",
              });
              await createNotification(updatedOrder.signage_id, signageContent, token || "", signageData.licenseType === "SIGNAGE_TEAM_MEMBER" ? "team_member" : "signage_admin");
            }
          } catch (err) {
            safeConsole.warn("Failed to send payment notification to signage admin:", err);
          }
        }

        // Send notification to single end user (effectiveCouponCreatedById) only
        if (effectiveCouponCreatedById && token) {
          try {
            const { fetchUserData } = await import("../../utils/userDataFetcher");
            const endUserData = await fetchUserData(resolveInstallationPaymentMethodsMembershipId(installationOrder) || effectiveCouponCreatedById, token);
            if (endUserData?.id) {
              // Determine recipientType based on licenseType
              let recipientType: "agent" | "brokerage_team" = "agent";
              if (endUserData.licenseType === "BROKERAGE_FIRM" || endUserData.licenseType === "BROKERAGE_TEAM_MEMBER") {
                recipientType = "brokerage_team";
              } else if (endUserData.licenseType === "AGENT" || endUserData.licenseType === "BROKERAGE_AGENT") {
                recipientType = "agent";
              }

              const endUserContent = getInstallationPaymentAppliedContent({
                orderId: orderId,
                amount: paymentAmount,
                recipientType: recipientType,
              });
              await createNotification(effectiveCouponCreatedById, endUserContent, token || "", recipientType);
            }
          } catch (err) {
            safeConsole.warn("Failed to send payment notification to end user:", err);
          }
        }
      } catch (notifError) {
        safeConsole.warn("Failed to send payment applied notifications:", notifError);
      }
    } catch (emailError) {
      safeConsole.error("Failed to send payment applied emails:", emailError);
      // Don't block payment success if email fails, but log the error for debugging
    }
  };

  const completeOrder = async (method: { name: string; _id: string }) => {
    // console.log("method", method);

    setLoading(true);
    let paymentSucceeded = false;

    try {
      // Find the selected payment method to check is_credit
      const selectedPaymentMethod = paymentMethod.find(pm => pm._id === method._id);
      const isCreditPayment = selectedPaymentMethod?.is_credit || false;

      // console.log("Selected payment method:", selectedPaymentMethod);
      // console.log("Is credit payment:", isCreditPayment);

      // Credit Payment Logic:
      // - If is_credit: false → User pays immediately → amount_paid: total, amount_due: 0
      // - If is_credit: true → User pays later → amount_paid: 0, amount_due: total

      const offlineStaticMethods = ["cheque", "bank_transfer", "store_paid"];
      const isDynamicMethod = method._id !== method.name;
      let actualAmountPaid = 0;

      if (offlineStaticMethods.includes(method.name)) {
        // 🔁 Call Net30-style API
        if (!formik.values.transactionId || formik.values.transactionId.trim() === "") {
          showError("Transaction ID is required");
          setLoading(false);
          return;
        }

        const latestPayment = installationOrder?.payment_info.length > 0
          ? Number(remaingamount)
          : undefined;
        const lastAmountDue = latestPayment ?? installationOrder?.total_amount;

        // store_paid is always full payment; cheque/bank_transfer can use partial
        const isStorePaidMethod = method.name === "store_paid";
        actualAmountPaid = isStorePaidMethod
          ? Number(lastAmountDue)
          : formik.values.partial_amount > 0
            ? Number(formik.values.partial_amount)
            : Number(lastAmountDue);

        // console.log("Actual Amount Paid:", actualAmountPaid, "Last Amount Due:", lastAmountDue);

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/installation_orders/${installationOrder?._id}/net30_payment`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // use token from context
            },
            body: JSON.stringify({
              payment_id: formik.values.transactionId || "",
              method: method.name,
              amount_paid: Number(actualAmountPaid.toFixed(2)),
              total_amount: Number(lastAmountDue.toFixed(2)),
              // amount_due: Math.max(0, Number(lastAmountDue) - Number(actualAmountPaid)),
              amount_due: Number(
                Math.max(0, Number(lastAmountDue) - Number(actualAmountPaid)).toFixed(2)
              ),

              payment_date: new Date().toISOString(),
              paid_by: buildLoggedInPaymentPaidBy({
                name: userName,
                membership_id: membershipId || userId,
                global_user_id: globalUserId,
                organization_id: organizationId,
              }),
              payment_status: installationOrder?.payment_status ?? "",
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Cheque/Bank payment failed.");
        }

      } else {
        // 🔁 Default online payment API
        // Calculate payment amounts based on credit status
        const amountPaid = isCreditPayment ? 0 : remaingamount;
        const amountDue = isCreditPayment ? remaingamount : 0;

        // console.log("Online Payment - Amount Paid:", amountPaid, "Amount Due:", amountDue);

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/installation_orders/${installationOrder?._id}/payment`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              payment_id: "",
              total_amount: formik.values.total,
              amount_paid: Number(amountPaid.toFixed(2)),
              amount_due: Number(amountDue.toFixed(2)),
              payment_date: new Date().toISOString(),
              method: method.name,
              paid_by: buildLoggedInPaymentPaidBy({
                name: userName,
                membership_id: membershipId || userId,
                global_user_id: globalUserId,
                organization_id: organizationId,
              }),
              payment_status: installationOrder?.payment_status ?? "",
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Online payment failed.");
        }
      }

      showSuccess("Payment submitted successfully!");

      // Send "Payment applied for Installation Job" emails
      try {
        const from =
          process.env.REACT_APP_FROM_EMAIL2 ||
          process.env.REACT_APP_FROM_EMAIL ||
          "noreply@realesy.com";
        if (from && installationOrder) {
          // Wait a moment for backend to process payment before fetching updated order
          await new Promise(resolve => setTimeout(resolve, 1000));

          // Fetch updated order to get latest payment info (with retry)
          let updatedOrder = installationOrder;
          let retries = 3;
          while (retries > 0) {
            try {
              const orderRes = await fetch(`${process.env.REACT_APP_API_URL}/installation_orders/${installationOrder._id}`, {
                headers: { Authorization: `Bearer ${token}` },
              });
              if (orderRes.ok) {
                const fetchedOrder = await orderRes.json();
                // Check if payment_info has been updated (has at least one payment)
                if (Array.isArray(fetchedOrder.payment_info) && fetchedOrder.payment_info.length > 0) {
                  updatedOrder = fetchedOrder;
                  break;
                } else if (retries === 1) {
                  // Last retry, use fetched order even if payment_info is empty
                  updatedOrder = fetchedOrder;
                }
              }
            } catch (fetchErr) {
              safeConsole.warn(`Failed to fetch updated order (retries left: ${retries - 1}):`, fetchErr);
            }
            if (retries > 1) {
              await new Promise(resolve => setTimeout(resolve, 500));
            }
            retries--;
          }

          // Determine payment amount based on payment method
          const paymentAmount = offlineStaticMethods.includes(method.name)
            ? actualAmountPaid
            : (isCreditPayment ? 0 : remaingamount);

          await sendInstallationPaymentAppliedEmails(updatedOrder, paymentAmount, method.name, from, isDynamicMethod);
        }
      } catch (emailError) {
        safeConsole.warn("Failed to send payment applied emails:", emailError);
        // Don't block payment success if email fails
      }

      localStorage.removeItem("cart_id");
      paymentSucceeded = true;
    } catch (error) {
      const errMessage =
        (error as Error).message || "An unknown error occurred";
      safeConsole.error("Order Failed:", errMessage);
      showError(`Error: ${errMessage}`);
    } finally {
      setLoading(false);
      if (paymentSucceeded) {
        safeNavigate(0);
      }
    }
  };
  const totalPaidFixed = (installationOrder?.payment_info ?? []).reduce(
    (acc: number, payment: { amount_paid?: number | string }) =>
      acc + Number(payment.amount_paid || 0),
    0
  );

  const totalPaid = Number(totalPaidFixed.toFixed(2));


  // console.log("totalPaid", totalPaid);

  const maxAllowed = (installationOrder?.payment_info ?? []).length > 0 ? Number((Number(installationOrder?.total_amount || 0) - totalPaid).toFixed(2)) : Number(installationOrder?.total_amount || 0);

  const getResolvedLineItem = React.useCallback(
    (p: { product_id: string; variant_id?: string }) => {
      const key = orderLineKey(p.product_id, p.variant_id);
      const fromFormik = ((formik.values as { resolved_line_items?: ResolvedInstallationLineItem[] })
        .resolved_line_items || []) as ResolvedInstallationLineItem[];
      const fromFormikLine = fromFormik.find(
        (li) => orderLineKey(li.product_id, li.variant_id) === key
      );
      if (fromFormikLine) return fromFormikLine;
      const fromRef = (lastResolvedInstallationRef.current?.line_items || []).find(
        (li) => orderLineKey(li.product_id, li.variant_id) === key
      );
      if (fromRef) return fromRef;
      return mapInstallationOrderLinesToResolved(installationOrder?.line_items).find(
        (li) => orderLineKey(li.product_id, li.variant_id) === key
      );
    },
    [
      (formik.values as { resolved_line_items?: ResolvedInstallationLineItem[] }).resolved_line_items,
      installationOrder?.line_items,
    ]
  );

  const displayUnitsCost = React.useMemo(() => {
    const purchasedLines = (selectedProducts || []).filter((p) => isPurchasedInstallationLine(p));
    return computeInstallationUnitsCostFromChangedUnitPrice({
      products: purchasedLines.map((p) => ({
        product_id: p.product_id,
        variant_id: p.variant_id,
        quantity: p.quantity,
        unit_price: p.unit_price,
        changed_unit_price: p.changed_unit_price,
        inventory_type: p.inventory_type,
        inventory_source: (p as { inventory_source?: string }).inventory_source,
        Price: Number(p.changed_unit_price ?? p.unit_price ?? 0),
      })),
      manualUnitPriceMap,
      getResolvedLineItem,
      isCustomProduct: (product) =>
        String(product?.inventory_type || product?.inventory_source || "").toLowerCase() === "custom",
    });
  }, [selectedProducts, manualUnitPriceMap, getResolvedLineItem]);

  // Legacy unitsCost kept for any internal refs; UI uses displayUnitsCost.
  const unitsCost = displayUnitsCost;

  // Start manual installation cost editing from the current cost shown in the breakdown.
  const handleEditInstallationCost = () => {
    setManualInstallationCost(String(Number(installationCost || 0)));
    setIsEditingInstallationCost(true);
  };

  // Exit edit mode without changing the current installation cost.
  const handleCancelEditInstallationCost = () => {
    setManualInstallationCost("");
    setIsEditingInstallationCost(false);
  };

  // Save manual cost so the breakdown, tax recompute, and update payload use the same value.
  const handleSaveInstallationCost = () => {
    const nextCost = Number(manualInstallationCost);
    if (!Number.isFinite(nextCost) || nextCost < 0) {
      showError("Please enter a valid installation cost");
      return;
    }

    setInstallationCost(nextCost);
    installationCostRef.current = nextCost;
    formik.setFieldValue("installation_cost", nextCost, false);
    setManualInstallationCost("");
    setIsEditingInstallationCost(false);
    showSuccess("Installation cost updated.");
    triggerRecomputeWithRef.current?.({ installationCost: nextCost });
  };

  useEffect(() => {
    setDiscountUserTouched(false);
  }, [installationOrder?.order_number]);

  useEffect(() => {
    const nextCode = String(
      formik.values?.discount_code ??
      (installationOrder as any)?.discount_code ??
      (installationOrder as any)?.coupon_code ??
      ""
    ).trim();
    if (!nextCode && latestDiscountCodeRef.current) return;
    if (discountUserTouched && !nextCode) return;
    latestDiscountCodeRef.current = nextCode;
  }, [
    discountUserTouched,
    formik.values?.discount_code,
    installationOrder?.discount_code,
    (installationOrder as any)?.coupon_code,
  ]);

  const preferFormikDiscount = isEdit && discountUserTouched;

  const costBreakdownDiscount = React.useMemo(
    () =>
      getInstallationCostBreakdownDiscount({
        formikCode: formik.values?.discount_code,
        formikAmount: formik.values?.discount_amount,
        formikDiscount: formik.values?.discount,
        formikProductDiscountAmount: (formik.values as any)?.product_discount_amount,
        formikDiscountAppliesTo: (formik.values as any)?.discount_applies_to,
        order: installationOrder as any,
        preferFormikOnly: preferFormikDiscount,
      }),
    [
      installationOrder,
      preferFormikDiscount,
      installationOrder?.discount_amount,
      installationOrder?.discount_code,
      installationOrder?.line_items,
      (installationOrder as any)?.discount,
      (installationOrder as any)?.product_discount_amount,
      (installationOrder as any)?.order_charges,
      formik.values?.discount_amount,
      formik.values?.discount_code,
      formik.values?.discount,
      (formik.values as any)?.product_discount_amount,
      (formik.values as any)?.discount_applies_to,
    ]
  );

  const costBreakdownDiscountCode = React.useMemo(() => {
    if (preferFormikDiscount) {
      return String(formik.values?.discount_code ?? "").trim();
    }

    const rootCode = String(
      formik.values?.discount_code ??
      (installationOrder as any)?.discount_code ??
      (installationOrder as any)?.coupon_code ??
      ""
    ).trim();
    if (rootCode) return rootCode;

    const lineItems = Array.isArray(installationOrder?.line_items) ? installationOrder.line_items : [];
    const lineCode = lineItems.find(
      (li: any) =>
        li?.is_new_purchase === true &&
        Number(
          li?.discount ??
          li?.discount_amount ??
          li?.discount_on_total_quantity ??
          li?.discount_on_total_quantity_amount ??
          0
        ) > 0 &&
        String(li?.discount_code ?? "").trim()
    )?.discount_code;

    return String(lineCode ?? "").trim();
  }, [
    preferFormikDiscount,
    formik.values?.discount_code,
    installationOrder?.line_items,
    (installationOrder as any)?.discount_code,
    (installationOrder as any)?.coupon_code,
  ]);

  const effectiveDiscountAmount = costBreakdownDiscount.amount;
  const showCostBreakdownDiscount =
    Boolean(costBreakdownDiscountCode) && costBreakdownDiscount.amount > 0;

  const getEffectiveDiscountAmount = () => effectiveDiscountAmount;

  const markDiscountTouched = React.useCallback(() => setDiscountUserTouched(true), []);

  const resolvedTaxTotal = React.useMemo(
    () =>
      Number(formik.values?.tax || 0) > 0
        ? Number(formik.values.tax)
        : Number(formik.values?.totals?.installation_tax_amount || 0) +
          Number(formik.values?.totals?.specialfee_tax_amount || 0) +
          Number((formik.values?.totals as any)?.product_tax_amount || 0),
    [
      formik.values?.tax,
      formik.values?.totals?.installation_tax_amount,
      formik.values?.totals?.specialfee_tax_amount,
      (formik.values?.totals as any)?.product_tax_amount,
    ]
  );

  const totalAmountNum =
    Number(installationCost || 0) +
    Number(displayUnitsCost || 0) +
    Number(formik.values?.totals?.specialfee_subtotal || 0) +
    resolvedTaxTotal -
    Number(effectiveDiscountAmount);

  const TotalAmount = totalAmountNum.toFixed(2);              // string for UI
  console.log("TotalAmount", TotalAmount);

  const remaingamount = Number(TotalAmount) - totalPaid;
  console.log("remaingamount", remaingamount);


  const statusHistory: any[] = Array.isArray(installationOrder?.status_history)
    ? (installationOrder?.status_history as any[])
    : [];
  // console.log("statusHistory", statusHistory);
  const paymentInfo: PaymentInfoItem[] = [...(installationOrder?.payment_info || [])];

  const resolveOrderStatus = (status: number | undefined): string => {
    switch (status) {
      case 100: return "Draft";
      case 200: return "Finalized";
      case 300: return "Scheduled";
      case 400: return "In Progress";
      case 500: return "Completed";
      case 600: return "Canceled";
      default: return status !== undefined ? `Status ${status}` : "Unknown";
    }
  };


  const parseDate = (input: any): string => {
    try {
      return new Date(input).toLocaleString();
    } catch {
      return "Invalid Date";
    }
  };

  const approvedProofCards = useMemo(() => {
    const approvedRoot = (approvedMessageData as any) || {};
    const approvedFiles = Array.isArray(approvedRoot?.approved_files) ? approvedRoot.approved_files : [];
    if (approvedFiles.length === 0) return [];

    const grouped = new Map<number, any[]>();
    approvedFiles.forEach((f: any) => {
      const version = Number(f?.version);
      const key = Number.isFinite(version) && version > 0 ? Math.floor(version) : 1;
      if (!grouped.has(key)) grouped.set(key, []);
      grouped.get(key)!.push(f);
    });

    return Array.from(grouped.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([version, files]) => {
        const first = files[0] || {};
        const compactProofFiles = files.map((f: any, idx: number) => ({
          id: String(f?.id ?? f?._id ?? idx),
          name: String(f?.original_name ?? f?.file_name ?? f?.name ?? "File"),
          href:
            String(f?.preview_url ?? "").trim() ||
            String(f?.file_url ?? f?.url ?? "").trim(),
          previewUrl: String(f?.preview_url ?? f?.file_url ?? f?.url ?? "").trim(),
          fileId: String(f?.file_id ?? "").trim(),
          quantity: Number.isFinite(Number(f?.quantity)) ? Number(f?.quantity) : undefined,
          sizeLabel: Number.isFinite(Number(f?.file_size)) ? `${Math.round(Number(f?.file_size) / 1024)} KB` : "—",
        }));
        const approvedByName = String(
          first?.design_approved_by?.name ??
          first?.updated_by?.name ??
          approvedRoot?.design_approved_by?.name ??
          approvedRoot?.approved_by_name ??
          (installationOrder as any)?.design_approved_by?.name ??
          (installationOrder as any)?.project?.design_approved_by?.name ??
          ""
        ).trim();
        const approvedAtRaw =
          first?.design_approved_at ??
          first?.updated_at ??
          approvedRoot?.design_approved_at ??
          approvedRoot?.approved_at ??
          (installationOrder as any)?.design_approved_at ??
          (installationOrder as any)?.project?.design_approved_at;
        const approvedAtLabel = approvedAtRaw ? parseDate(approvedAtRaw) : "";
        const shippingName = String(
          first?.shipping_method?.name ??
          approvedRoot?.shipping_method?.name ??
          (installationOrder as any)?.shipping_method?.name ??
          ""
        ).trim();
        const shippingDesc = String(
          first?.shipping_method?.description ??
          approvedRoot?.shipping_method?.description ??
          (installationOrder as any)?.shipping_method?.description ??
          ""
        ).trim();
        const shippingAmountRaw = first?.shipping_amount ?? approvedRoot?.shipping_amount;
        const shippingAmountLabel = Number.isFinite(Number(shippingAmountRaw))
          ? `$${Number(shippingAmountRaw).toFixed(2)}`
          : "";
        const assignedToName = String(
          approvedRoot?.assigned_to_name ??
          (installationOrder as any)?.assigned_to_name ??
          (installationOrder as any)?.project?.assigned_to_name ??
          ""
        ).trim();
        const orderSummary = resolveApprovedProofVersionSummary(approvedRoot, version, first);
        const billingAddress =
          first?.billing_address ??
          approvedRoot?.billing_address ??
          (installationOrder as any)?.billing_address ??
          null;
        const installationAddress =
          (installationOrder as any)?.installation_details?.installation_address ??
          first?.shipping_address ??
          approvedRoot?.shipping_address ??
          null;
        return {
          version,
          files: compactProofFiles,
          approvedByName,
          approvedAtLabel,
          assignedToName,
          shippingName,
          shippingDesc,
          shippingAmountLabel,
          orderSummary,
          billingAddress,
          installationAddress,
        };
      });
  }, [approvedMessageData, installationOrder]);

  // Put this inside your component (above the return)
  type ViewAction = "finalize" | "schedule" | "start" | "complete";

  const renderViewModeActions = () => {
    const status = installationOrder?.status ?? 0;

    // base disable rules
    const baseDisabled = formSubmitting

    const hasPaymentInfo = (installationOrder?.payment_info?.length ?? 0) > 0;

    // refresh wrapper
    const withRefresh = (fn: () => Promise<boolean>) => async () => {
      const ok = await fn();
      if (ok) safeNavigate(0);
    };

    // ✅ Allocation now handled by "Save Allocation" button in popup
    // helper: attempt allocations PATCH only if there are any allocations prepared
    // const attemptBulkAllocationIfAny = async (): Promise<boolean> => {
    //   const hasAllocations =
    //     allocatedUnits &&
    //     Object.values(allocatedUnits).some(
    //       (units) => Array.isArray(units) && units.length > 0
    //     );
    //   if (hasAllocations) {
    //     return await patchRotationalAllocations();
    //   }
    //   return true;
    // };

    // finalize -> schedule (or only schedule if already 200)
    const runFinalizeFlow = async (): Promise<boolean> => {
      if (status === 200) {
        // ✅ Allocation now handled by "Save Allocation" button in popup
        // const okAlloc = await attemptBulkAllocationIfAny();
        // if (!okAlloc) return false;
        return await handleInstallationStatus(300);
      }
      const ok200 = await handleInstallationStatus(200);
      if (!ok200) return false;
      // ✅ Allocation now handled by "Save Allocation" button in popup
      // const okAlloc = await attemptBulkAllocationIfAny();
      // if (!okAlloc) return false;
      return await handleInstallationStatus(300);
    };

    const actions: Array<{
      key: ViewAction;
      label: string;
      show: boolean;
      onClick: () => Promise<void>;
      extraDisabled?: boolean;
    }> = [
        // {
        //   key: "finalize",
        //   label: "Confirm",
        //   show: status === 100,
        //   onClick: withRefresh(() => handleInstallationStatus(200)),
        //   // extraDisabled: status === 100 && !hasPaymentInfo,
        // },

        {
          key: "schedule",
          label: "Schedule",
          show: status === 200,
          onClick: withRefresh(() => handleInstallationStatus(300)),
        },

        //  ...(hasPaymentInfo ? [{
        //   key: "schedule" as ViewAction,
        //   label: "Schedule",
        //   show: status === 200,
        //   onClick: withRefresh(() => handleInstallationStatus(300)),
        // }] : []),
        {
          key: "start",
          label: "Start",
          show: status === 300,
          onClick: withRefresh(async () => {
            // ✅ Allocation now handled by "Save Allocation" button in popup
            // const okAlloc = await attemptBulkAllocationIfAny();
            // if (!okAlloc) return false;
            return await handleInstallationStatus(400);
          }),
        },
        {
          key: "complete",
          label: "Complete",
          show: status === 400,
          onClick: withRefresh(() => handleInstallationStatus(500)),
        },
      ];

    return actions
      .filter((a) => a.show)
      .map((a) => (
        <button
          key={a.key}
          type="button"
          onClick={a.onClick}
          className="btn btn-primary save-btn surface-btn fw-bold fs-16 w-100 actionbuttons"
          disabled={baseDisabled || !!a.extraDisabled}
        >
          {a.label}
        </button>
      ));
  };


  // const renderViewModeActions = () => {

  //   const status = installationOrder?.status ?? 0;
  //   const disabled = formSubmitting || !formik.values.localLawsChecked;

  //   // refresh wrapper
  //   const withRefresh = (fn: () => Promise<boolean>) => async () => {
  //     const ok = await fn();
  //     if (ok) navigate(0);          // soft page refresh (RRv6)
  //     // or: if (ok) window.location.reload(); // hard reload
  //   };

  //   // finalize → schedule (or only schedule if already at 200)
  //   const runFinalizeFlow = async (): Promise<boolean> => {
  //     if (status === 200) {
  //       return await handleInstallationStatus(300);
  //     }
  //     const ok200 = await handleInstallationStatus(200);
  //     if (!ok200) return false;
  //     return await handleInstallationStatus(300);
  //   };

  //   const actions: {
  //     key: ViewAction;
  //     label: string;
  //     show: boolean;
  //     onClick: () => Promise<void>;
  //   }[] = [
  //       { key: "finalize", label: "Finalize & Schedule", show: status === 100 || status === 200, onClick: withRefresh(runFinalizeFlow) },
  //       { key: "start", label: "Start", show: status === 300, onClick: withRefresh(() => handleInstallationStatus(400)) },
  //       { key: "complete", label: "Complete", show: status === 400, onClick: withRefresh(() => handleInstallationStatus(500)) },
  //     ];

  //   return actions
  //     .filter(a => a.show)
  //     .map(a => (
  //       <button
  //         key={a.key}
  //         type="button"
  //         onClick={a.onClick}
  //         className="btn btn-primary px-4 table-cells me-2 mb-2 actionbuttons"
  //         disabled={disabled}
  //       >
  //         {a.label}
  //       </button>
  //     ));
  // };



  const isFieldEditable = (status: number, field: string): boolean => {
    const editableMap: Record<number, string[]> = {
      100: [
        // Created (Draft)
        "Priority",
        "Instructions",
        "Installer",
        "InstallationDate",
        "userEmail",
        "userPhone",
        "billingAddressId",
        "installationAddressId"
      ],
      200: [
        // Finalized
        "InstallationDate", // if ≥ 48h
        "Installer",
        "Instructions",
        "allocation",
        "Priority",
        "billingAddressId",
        "installationAddressId"
      ],
      300: [
        // Scheduled or Re-scheduled
        "InstallationDate", // if ≥ 48h
        "Installer",
        "Instructions",
        "Priority",
        // "billingAddressId",
        // "installationAddressId"
      ],
      400: [
        // In Progress
        "Instructions",
      ],
      // 500 and 600: No edits allowed
    };

    const nonEditableStatuses = [500, 600]; // Completed, Cancelled

    if (nonEditableStatuses.includes(status)) return false;

    const editableFields = editableMap[status] || [];
    return editableFields.includes(field);
  };

  const fetchRotationalPoolProducts = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/signage/${organizationId}/rotational-products`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Failed to fetch");
      // console.log("Rotational Pool Products:", data);

      setRotationalPoolProducts(data); // ✅ store in state
    } catch (err: any) {
      safeConsole.error("Error fetching rotational products:", err.message);
      showError("Failed to fetch rotational pool products");
    }
  };

  const rotationalproductOptions = rotationalPoolProducts?.map((p) => ({
    value: p._id,
    label: p.rotational_product?.name || "Unnamed Product",
    sku: p.rotational_product?.sku,
    fullProduct: p,
  }));

  const handleProductSelect = (selected: any) => {
    setSelectedProduct(selected);
    // console.log("Selected Product:", selected);
    const warehouses = selected?.fullProduct?.warehouse_details || [];

    const options = warehouses?.map((w: any) => ({
      value: w.warehouse._id,
      label: `${w.warehouse.label}`,
    }));

    setWarehouseOptions(options);
  };

  const fetchSerializedUnits = async (rotationalId: string, warehouseId: string) => {
    if (!organizationId || !token) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/signage/${organizationId}/warehouses/rotational-pool/${rotationalId}/warehouse/${warehouseId}/available-serialized-units`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Failed to fetch serialized pool");
      // console.log("Serialized Units:", data);
      setAvailableSerializedUnits(data);
    } catch (err: any) {
      safeConsole.error("Fetch Serialized Units Error:", err.message);
      showError("Unable to fetch serialized units");
    }
  };

  useEffect(() => {
    if (installationOrder?.proof_of_installation) {
      setUploadedFileMeta(installationOrder.proof_of_installation);
      // console.log("Uploaded File Meta:", installationOrder.proof_of_installation);
    }
  }, [installationOrder]);

  // 📦 Allocate a single serial unit API call
  // const allocateSerialUnit = async ({
  //   rotationalProductId,
  //   warehouseId,
  //   serialId,
  // }: {
  //   rotationalProductId: string;
  //   warehouseId: string;
  //   serialId: string;
  // }) => {
  //   try {
  //     const res = await fetch(
  //       `${process.env.REACT_APP_API_URL}/signage/${userId}/rotational-products/${rotationalProductId}/allocate-serialized-unit`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Authorization": `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           warehouse_id: warehouseId,
  //           serial_id: serialId,
  //           order_id: installationOrder?._id,
  //           order_number: installationOrder?.order_number || "",
  //         }),
  //       }
  //     );

  //     if (!res.ok) {
  //       const error = await res.json();
  //       throw new Error(error.message || "Failed to allocate unit");
  //     }

  //     return true;
  //   } catch (err) {
  //     console.error("Allocation API error:", err);
  //     showError("Allocation failed");
  //     return false;
  //   }
  // };


  // Helper function to calculate rotational_allocated for a normal product
  const calculateRotationalAllocated = (productId: string): number => {
    const allocated = allocatedUnits[productId] || [];
    return allocated.length;
  };

  // Helper function to remove allocated unit
  const removeAllocatedUnit = (linkedProductId: string, serialId: string) => {
    setAllocatedUnits((prev) => {
      const existing = prev[linkedProductId] || [];
      const updated = existing.filter(unit => unit.serial_id !== serialId);

      if (updated.length === 0) {
        const newState = { ...prev };
        delete newState[linkedProductId];
        return newState;
      }

      return {
        ...prev,
        [linkedProductId]: updated
      };
    });
  };

  // Helper function to get current allocations summary
  const getCurrentAllocationsSummary = () => {
    const summary: { [key: string]: { count: number; units: any[]; productName: string } } = {};

    Object.entries(allocatedUnits).forEach(([linkedProductId, units]) => {
      if (units.length > 0) {
        const product = selectedProducts.find(p => p.product_id === linkedProductId);
        summary[linkedProductId] = {
          count: units.length,
          units: units,
          productName: product?.name || 'Unknown Product'
        };
      }
    });

    return summary;
  };

  // New: PATCH rotational allocations into installation order line_items
  const patchRotationalAllocations = async (): Promise<boolean> => {
    try {
      if (!installationOrder?._id || !installationOrder?.order_number || !effectiveSignageOrgId) {
        showError("Missing installation order or user info for allocations");
        return false;
      }

      const ZERO_ID = "000000000000000000000000";
      const isValidId = (id?: string) => !!id && id !== ZERO_ID;
      const resolveWarehouseId = (unit: any): string => {
        if (isValidId(unit?.warehouseId)) return unit.warehouseId;
        if (isValidId(unit?.storage_location?.warehouse_id)) return unit.storage_location.warehouse_id;
        // Fallback: try to resolve from rotational pool products
        const rp = (rotationalPoolProducts || []).find((p: any) => p?._id === unit?.rotationalProductId);
        const su = rp?.serialized_units?.find((s: any) => s?.serial_id === unit?.serial_id);
        const wid = su?.storage_location?.warehouse_id;
        return isValidId(wid) ? wid : "";
      };

      const toIdString = (val: any): string => {
        if (!val) return "";
        if (typeof val === "string") return val;
        if (typeof val === "object") {
          if ((val as any).$oid) return String((val as any).$oid);
          const s = (val as any).toString?.();
          if (s && s !== "[object Object]") return String(s);
        }
        return "";
      };

      // Create separate line items for each allocation batch
      const items: any[] = [];
      // console.log("allocatedUnits :", allocatedUnits)

      Object.entries(allocatedUnits || {}).forEach(([sourceProductId, units]) => {
        if (!units || units.length === 0) return;

        // Group units by rotational product and warehouse to create separate line items
        const groups: Record<string, any[]> = {};

        (units as any[]).forEach((unit) => {
          const resolvedWarehouseId = resolveWarehouseId(unit);
          const key = `${unit.rotationalProductId}_${resolvedWarehouseId}`;

          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(unit);
        });

        // Create separate line item for each group
        Object.entries(groups).forEach(([key, groupUnits]) => {
          const firstUnit = groupUnits[0];
          const resolvedWarehouseId = resolveWarehouseId(firstUnit);

          const serial_allocations = groupUnits.map((unit) => {
            const sl = unit?.storage_location || {};
            return {
              source_product_id: sourceProductId,
              serial_id: unit.serial_id,
              serial_code: unit.serial_number,
              warehouse_id: resolvedWarehouseId,
              // include full storage location breakdown
              warehouse_name: sl.warehouse_name || "",
              zone_name: sl.zone_name || "",
              rack_name: sl.rack_name || "",
              bin_name: sl.bin_name || "",
              zone_id: toIdString(sl.zone_id) || "",
              rack_id: toIdString(sl.rack_id) || "",
              bin_id: toIdString(sl.bin_id) || "",
            };
          });

          items.push({
            product_id: firstUnit.rotationalProductId,
            warehouse_id: resolvedWarehouseId,
            serial_ids: groupUnits.map(u => u.serial_id),
            serial_allocations: serial_allocations,
            product_name: firstUnit.product_name || "",
            source_product_id: sourceProductId,
            sku: firstUnit.sku || "",
            inventory_source: "rotational",
            rotational_allocated: groupUnits.length, // Current allocation count for this batch
            quantity: 0, // Rotational products have 0 quantity
            unit_price: 0,
            total_price: 0,
            inventory_deducted: false,
            fulfillment_type: "stock",
            production_status: null,
            is_rotational: true,
            current_status: "",
          });
        });
      });

      // Validate all items have a valid warehouse_id
      const invalid = items.find((it: any) => !isValidId(it.warehouse_id));
      if (invalid) {
        showError("One or more selected serials have no valid warehouse. Please reselect a warehouse and try again.");
        return false;
      }

      if (items.length === 0) return true; // nothing to patch

      const sellerOrgId = String(
        organizationId ||
          resolveInstallationSellerOrganizationId(
            effectiveSignageOrgId || "",
            installationOrder
          )
      ).trim();
      const payload = {
        order_number: installationOrder.order_number,
        items,
        is_new_allocation: true,
        allocation_timestamp: new Date().toISOString(),
        allocation_batch_id: `batch_${Date.now()}`,
      };

      await patchInstallationOrderLineItems(token, installationOrder._id, sellerOrgId, payload);

      showSuccess("Allocations updated successfully");

      setAllocatedUnits({});

      // Refresh installation order data to show updated allocations
      if (installationOrder?._id) {
        try {
          const incoming = await fetchInstallationOrderByIdUnwrapped(token, installationOrder._id);
          setInstallationOrder((prev: any) => {
            const base = { ...(prev || {}), ...(incoming || {}) };
            const incomingFiles = incoming?.uploaded_files;
            const prevFiles = prev?.uploaded_files;
            if (!Array.isArray(incomingFiles) || incomingFiles.length === 0) {
              if (Array.isArray(prevFiles) && prevFiles.length > 0) {
                base.uploaded_files = prevFiles;
              }
            }
            const incomingNotes = incoming?.additional_instructions;
            const prevNotes = prev?.additional_instructions;
            if (!Array.isArray(incomingNotes) || incomingNotes.length === 0) {
              if (Array.isArray(prevNotes) && prevNotes.length > 0) {
                base.additional_instructions = prevNotes;
              }
            }
            return base;
          });
        } catch (err) {
          safeConsole.error("Failed to refresh installation order:", err);
        }
      }

      return true;
    } catch (err: any) {
      const msg = err?.response?.data?.message || err?.message || "Failed to update allocations";
      safeConsole.error("Allocations PATCH error: ", err?.response?.data || err);
      showError(msg);
      return false;
    } finally {
      setShowAllocateModal(false);
      safeNavigate(0);
    }
  };

  // useEffect(() => {
  //   console.log("Allocated Units changed:", allocatedUnits);
  // }, [allocatedUnits]);


  useEffect(() => {
    const fetchPaymentIntent = async () => {
      // const amountToPay = (formik.values.partial_amount === 0
      //   ? (Number(order?.total_amount || 0) - totalPaid)
      //   : formik.values.partial_amount);

      // console.log("amountToPay", (formik.values.partial_amount === 0
      //   ? (Number(installationOrder?.total_amount || 0) - totalPaid)
      //   : formik.values.partial_amount));

      try {
        const sellerOrgId = String(
          organizationId ||
            resolveInstallationSellerOrganizationId(
              effectiveSignageOrgId || "",
              installationOrder
            )
        ).trim();
        const data = await createInstallationStripePaymentIntent(token, sellerOrgId, {
          amount: Math.round(
            Number(
              formik.values.partial_amount === 0
                ? Number(installationOrder?.total_amount || 0) - totalPaid
                : formik.values.partial_amount
            ) * 100
          ),
          currency: "usd",
          order_id: String(installationOrder?._id || installationOrder?.id || ""),
          order_number: String(installationOrder?.order_number || ""),
          customer_name: String(installationOrder?.user_name || ""),
          customer_email: String(installationOrder?.user_email || ""),
          customer_phone: String(installationOrder?.user_phone || ""),
          payment_method_types: ["card"],
        });
        setClientSecret(data.clientSecret || data.client_secret);
      } catch (err) {
        safeConsole.error("Failed to create PaymentIntent:", err);
      }
    };

    if (stripePromise) fetchPaymentIntent();
  }, [
    stripePromise,
    formik.values.partial_amount,
    installationOrder?.total_amount,
    installationOrder?._id,
    installationOrder?.id,
    installationOrder?.order_number,
    installationOrder?.user_name,
    installationOrder?.user_email,
    installationOrder?.user_phone,
    totalPaid,
    isSignageTeammember,
    effectiveSignageOrgId,
    userId,
  ]);

  const uploadProofOfInstallation = async (files: any[]) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/upload-proof`,
        {
          method: "PUT",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(files), // send array of files
        }
      );

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Failed to upload proof");
      showSuccess("Proof of installation uploaded successfully!");
    } catch (error: any) {
      showError(error.message || "Upload failed");
      throw error;
    }
  };

  const notifyCustomerProofAvailable = async () => {
    if (!installationId || !token) {
      throw new Error("Missing installation order or session token");
    }

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/proof-available-email`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data.message || data.error || "Failed to notify customer");
    }

    showSuccess("Customer notified successfully!");
  };

  // 1) Build a quick lookup: product_id -> source_order_id
  const sourceOrderIdByProduct = useMemo(() => {
    const map = new Map<string, string | null>();
    for (const p of productObjs ?? []) {
      // treat all-zero ID as "no source"
      const soid = p?.source_order_id && p.source_order_id !== "000000000000000000000000"
        ? p.source_order_id
        : null;
      map.set(p.product_id, soid);
    }
    return map;
  }, [productObjs]);

  // 2) Helper to fetch source_order_id for a selected product row
  const getSourceOrderIdForRow = (row: { product_id: string; variant_id?: string }) => {
    // If you ever need variant-level logic later, you can extend this.
    // console.log("getSourceOrderIdForRow called with row:", sourceOrderIdByProduct.get(row.product_id));
    return sourceOrderIdByProduct.get(row.product_id) ?? null;
  };
  const status = installationOrder?.status ?? 0;
  const Viewmode = !isEdit;
  const invoiceRef = useRef<HTMLDivElement>(null);

  const normalizeInstallationToSalesOrder = (inst: any) => {
    if (!inst) return null;
    const billing = inst?.billing_address || null;
    const shipping = inst?.installation_details?.installation_address || null;
    const items = Array.isArray(inst?.line_items)
      ? inst.line_items.map((li: any) => ({
        product_name: li.product_name,
        sku: li.sku,
        quantity: li.quantity,
        unit_retail_price: li.unit_price,
        total_price: li.total_price,
        customizations: li.customizations || null,
      }))
      : [];
    return {
      order_number: inst?.order_number,
      order_status: inst?.status, // OrderInvoice will just display label; mapping handled there
      payment_status: inst?.payment_status,
      customer_first_name: inst?.user_name || "",
      customer_last_name: "",
      customer_email: inst?.user_email,
      customer_phone: inst?.user_phone,
      created_at: inst?.created_at,
      billing_address: billing,
      shipping_address: shipping,
      items,
      payment_method: inst?.payment_method || "",
      total_amount: inst?.total_amount ?? inst?.installation_cost ?? 0,
      shipping_amount: 0,
      tax_amount: inst?.tax_amount ?? 0,
      discount_amount: inst?.discount_amount ?? 0,
    } as any;
  };


  useEffect(() => {
    // Assuming you want subtotal = installation cost + other charges
    const subtotal = Number(installationCost);

    // Example: 10% tax rate — adjust as needed
    // const taxRate = 0.1;
    // const tax = subtotal * taxRate;

    // const total = subtotal + tax;

    formik.setFieldValue("subtotal", subtotal);
    // formik.setFieldValue("tax", tax);
    formik.setFieldValue("total", subtotal);
  }, [installationCost]);

  // Sync discount into formik when order loads (skip after user changed coupon in edit)
  useEffect(() => {
    if (!installationOrder || discountUserTouched) return;
    const resolved = getInstallationCostBreakdownDiscount({
      formikCode: formik.values?.discount_code,
      formikAmount: formik.values?.discount_amount,
      formikDiscount: formik.values?.discount,
      formikProductDiscountAmount: (formik.values as any)?.product_discount_amount,
      formikDiscountAppliesTo: (formik.values as any)?.discount_applies_to,
      order: installationOrder as any,
      preferFormikOnly: false,
    });
    if (!(resolved.amount > 0) && !resolved.code) return;

    const current = Number(formik.values?.discount_amount ?? 0);
    if (current <= 0 && resolved.amount > 0) {
      formik.setFieldValue("discount_amount", resolved.amount, false);
    }
    if (resolved.code && !formik.values?.discount_code) {
      formik.setFieldValue("discount_code", resolved.code, false);
    }
    const productLevel = Number((installationOrder as any)?.product_discount_amount ?? 0);
    if (productLevel > 0 && !Number((formik.values as any)?.product_discount_amount ?? 0)) {
      formik.setFieldValue("product_discount_amount", productLevel, false);
    }
    const appliesTo = inferInstallationDiscountAppliesTo(installationOrder as any);
    if (appliesTo === "product" && (formik.values as any)?.discount_applies_to !== "product") {
      formik.setFieldValue("discount_applies_to", "product", false);
    }
  }, [
    installationOrder?.order_number,
    installationOrder?.discount_amount,
    installationOrder?.discount_code,
    installationOrder?.line_items,
    (installationOrder as any)?.order_charges,
    (installationOrder as any)?.product_discount_amount,
    discountUserTouched,
  ]);

  const installationLogEvents = React.useMemo(
    () => buildInstallationLogEventsFromOrder(installationOrder),
    [installationOrder]
  );


  const [sendInvoiceLoading, setSendInvoiceLoading] = useState(false);
  const [downloadInvoiceLoading, setDownloadInvoiceLoading] = useState(false);

  const fromInvoiceEmail =
    process.env.REACT_APP_FROM_EMAIL2?.trim() || "noreply@realesy.com";

  const handleSendInvoiceEmail = async (additionalEmails: string[] = []) => {
    if (!installationOrder || sendInvoiceLoading) return;
    if (!token) {
      showError("Session expired. Please sign in again.");
      return;
    }
    const recipientPlan = await buildInvoiceSendRecipientPlan(installationOrder, true, token);
    recipientPlan.customerRecipients = mergeAdditionalIntoInvoiceCustomerRecipients(
      recipientPlan.customerRecipients,
      additionalEmails
    );
    const hasRecipients =
      recipientPlan.customerRecipients.emails.length > 0 ||
      recipientPlan.accountEmails.length > 0;
    if (!hasRecipients) {
      showError("No brokerage, customer, or account email found for this job; cannot send the invoice.");
      return;
    }
    setSendInvoiceLoading(true);
    try {
      const installationOrderId = String(
        installationOrder?._id || installationOrder?.id || ""
      ).trim();
      if (!installationOrderId) {
        throw new Error("Missing installation order id.");
      }
      const safeNum = String(
        installationOrder?.order_number ??
          installationOrder?.job_number ??
          installationOrder?.id ??
          installationOrder?._id ??
          "order"
      ).replace(/[^\w.-]+/g, "_");
      const pdfAttachment = await buildInstallationOrderInvoicePdfAttachment({
        installationOrderId,
        token,
        fileLabel: safeNum,
        pdfFetch: {
          maxAttempts: 8,
          initialDelayMs: 400,
          retryDelayMs: 600,
          perFetchTimeoutMs: 20_000,
        },
      });
      if (!pdfAttachment) {
        throw new Error("Could not fetch invoice PDF from the server.");
      }
      const baseParams = await buildInvoiceEmailParamsForSend(installationOrder, token, "installation");
      await sendInvoiceTriggerEmails(
        baseParams,
        recipientPlan,
        fromInvoiceEmail,
        token,
        pdfAttachment
      );
      const sendLogOrderId = getInstallationSendLogOrderId(installationOrder);
      if (sendLogOrderId) {
        try {
          await createSendLogEntry({
            orderType: "installation_orders",
            orderId: sendLogOrderId,
            type: "invoice",
            token,
          });
        } catch (e) {
          safeConsole.warn("[SignageInstallationWorkOrder] send-log invoice failed:", e);
        }
      }
      showSuccess("Invoice email sent.");
    } catch (e) {
      showError(e instanceof Error ? e.message : "Failed to send invoice email.");
    } finally {
      setSendInvoiceLoading(false);
    }
  };

  const handleDownloadInvoice = async () => {
    if (!installationOrder || downloadInvoiceLoading) return;
    if (!token) {
      showError("Session expired. Please sign in again.");
      return;
    }
    setDownloadInvoiceLoading(true);
    try {
      const installationOrderId = String(installationOrder?._id || installationOrder?.id || "").trim();
      if (!installationOrderId) {
        throw new Error("Missing installation order id.");
      }
      const safeNum = String(
        installationOrder?.order_number ??
          installationOrder?.job_number ??
          installationOrder?.id ??
          installationOrder?._id ??
          "order"
      ).replace(/[^\w.-]+/g, "_");
      const att = await buildInstallationOrderInvoicePdfAttachment({
        installationOrderId,
        token,
        fileLabel: safeNum,
        pdfFetch: { maxAttempts: 6, initialDelayMs: 300, retryDelayMs: 500, perFetchTimeoutMs: 20_000 },
      });
      if (!att) {
        throw new Error("Could not fetch invoice PDF from the server.");
      }
      const [filename, b64] = Object.entries(att)[0];
      triggerBrowserDownload(base64PdfToBlob(b64), filename);
    } catch (e) {
      showError(e instanceof Error ? e.message : "Failed to download invoice.");
    } finally {
      setDownloadInvoiceLoading(false);
    }
  };

  const onPreviewInvoice = (t: InvoiceType) => {
    safeNavigate(`${baseRoute}/InvoiceDocument`, {
      state: {
        type: t,
        order: installationOrder, // pass the full order object used for the invoice
        imageUrlMap: undefined, // optional thumbs
        // logoUrl, serviceInfo, resolveImageSrc, ... if needed
        autoPrint: false, // set true if you want it to auto-open the print dialog
      },
    });
  };

  // ==== derived values from your order ====
  const supplierId = String(installationOrder?.signage_id || ""); // 68b77bd67ad...
  const installationCost1 = Number(installationOrder?.installation_cost || 0); // order-level
  const specialFeeAmount = Number(installationOrder?.special_fee_amount || 0); // order-level

  const destinationAddr = {
    addressLine1: installationOrder?.installation_details?.installation_address?.address_details?.addressLine1 || "",
    city: installationOrder?.installation_details?.installation_address?.address_details?.city || "",
    state: installationOrder?.installation_details?.installation_address?.address_details?.stateCode
      || installationOrder?.installation_details?.installation_address?.address_details?.state || "",
    zip: installationOrder?.installation_details?.installation_address?.address_details?.zip || "",
  };

  const productSkus =
    (installationOrder?.line_items || [])
      .map((li: any) => String(li?.sku || ""))
      .filter(Boolean);

  useEffect(() => {
    (async () => {
      try {
        if (!token || !organizationId) return;
        const t = await getActiveTaxType(token, organizationId);
        // normalize
        setTaxType(t === "taxcloud" ? "taxcloud" : t === "manual" ? "manual" : "unknown");
      } catch (e) {
        safeConsole.warn("[TAX] getActiveTaxType failed:", e);
        setTaxType("unknown");
      }
    })();
  }, [token, organizationId]);
  // Build destination for TaxCloud from the order's installation address
  // helper
  const pick = (v?: string | null) => (v ?? "").trim() || undefined;
  const zip5 = (z?: string | null) => ((z ?? "").trim() || "").slice(0, 5) || undefined;

  // destination stays the same
  const buildTaxCloudDestination = (): TaxCloudAddress => {
    const addr = installationOrder?.installation_details?.installation_address?.address_details;
    const destMaybe = toTaxCloudAddressFromObject({
      addressLine1: pick(addr?.addressLine1),
      city: pick(addr?.city),
      state: pick(addr?.stateCode) || "GA",
      zip: zip5(addr?.zip),
      country: pick(addr?.countryCode) || "US",
    });
    if (!destMaybe) throw new Error("Invalid destination address for TaxCloud");
    return destMaybe;
  };

  // read selected fees from order_charges.specialfee
  const getSelectedFeesForCart = () => {
    const arr = formik.values?.order_charges?.specialfee;
    const list = Array.isArray(arr) ? arr : [];
    return list
      .map((f: any) => ({
        id: String(f?.id ?? f?.specialfee_id ?? ""),
        name: String(f?.name ?? f?.specialfee_name ?? "Special Fee"),
        amount: Number(f?.amount ?? f?.specialfee_amount ?? 0),
        taxable: (f?.taxable ?? f?.specialfee_taxable) !== false,
        tax_percentage: f?.tax_percentage ?? f?.specialfee_tax_percentage ?? null,
      }))
      .filter((f) => f.id !== "" && f.amount > 0);
  };

  // ✅ NEW: single products array for TaxCloud cartItems - ONLY taxable items
  // discount_applies_to is NOT in GET response — infer from data:
  // - Product discount → installation full price; product unit price = changed_unit_price - per-unit line discount
  // - Root/job discount → installation = installationCost - discount_amount; products at changed_unit_price
  const buildProductsMerged = (fees?: any[]): TaxProduct[] => {
    const items: TaxProduct[] = [];

    const lineItems = Array.isArray(installationOrder?.line_items) ? installationOrder.line_items : [];
    const lineItemsDiscountTotal = sumInstallationLineItemDiscounts(lineItems);
    const discountAppliesTo = inferInstallationDiscountAppliesTo(
      {
        discount_applies_to:
          (formik.values as any)?.discount_applies_to ??
          (installationOrder as any)?.discount_applies_to,
        product_discount_amount:
          (formik.values as any)?.product_discount_amount ??
          (installationOrder as any)?.product_discount_amount,
        line_items: lineItems,
      },
      lineItemsDiscountTotal
    );
    const isProductDiscount = discountAppliesTo === "product";
    const orderDiscountAmount = Number((installationOrder as any)?.discount_amount ?? formik.values?.discount_amount ?? 0);

    // Root/job discount only — never reduce installation when discount is on products
    const installationDiscount =
      !isProductDiscount && orderDiscountAmount > 0 ? orderDiscountAmount : 0;

    if (dynamicTaxable) {
      const installPrice = Number(installationCost ?? 0);
      const discountedInstallPrice = Math.max(0, installPrice - installationDiscount);

      if (discountedInstallPrice > 0) {
        items.push({
          sku: "InstallationCost",
          price: discountedInstallPrice,
          quantity: 1,
          itemType: "service",
        });
      }
    }

    // ✅ Special fees: always pass actual price (discount applies to product OR installation only, never special fees)
    const feesToUse = fees ?? selectedSpecialFees;
    for (const fee of feesToUse) {
      const feeAmount = Number(fee?.amount || 0);
      if (feeAmount > 0 && fee?.taxable === true) {
        items.push({
          sku: fee?.name || "Special Fee",
          price: feeAmount,
          quantity: 1,
          itemType: "special_fee",
        });
      }
    }

    // ✅ Products: changed_unit_price base; per-unit discount only when coupon is product-scoped
    const EXCLUDED_SOURCE_ID = "000000000000000000000000";
    for (const li of lineItems) {
      // Existing post/slot inventory — never send to TaxCloud (only new purchases are taxable cart lines)
      if (li?.is_new_purchase !== true) continue;
      const invSource = String(li?.inventory_source ?? "");
      const sourceId = li?.source_product_id != null ? String(li.source_product_id) : "";
      // Skip: rotational inventory, missing source, or excluded placeholder source
      if (invSource === "rotational" || sourceId === EXCLUDED_SOURCE_ID) continue;
      if (!sourceId) continue;
      const qty = Math.max(0, Number(li?.quantity ?? 0));
      if (qty <= 0) continue;
      const changedUnitPrice = Number(li?.changed_unit_price ?? li?.unit_price ?? 0);
      if (changedUnitPrice <= 0) continue;

      let priceToUse = changedUnitPrice;
      if (isProductDiscount) {
        const lineDiscountTotal = Number(
          li?.discount_on_total_quantity ??
          li?.discount ??
          li?.discount_amount ??
          li?.discount_on_total_quantity_amount ??
          0
        ) || (
          li?.is_new_purchase === true
            ? getCurrentProductLineDiscountAmount(
                String(li?.product_id ?? ""),
                String(li?.variant_id ?? ""),
                li?.source_product_id
              )
            : 0
        );
        const perUnitDiscount =
          Number(li?.discount_on_unit_quantity ?? 0) > 0
            ? Number(li.discount_on_unit_quantity)
            : qty > 0
              ? lineDiscountTotal / qty
              : 0;
        priceToUse = Math.max(0, changedUnitPrice - perUnitDiscount);
      }
      if (priceToUse <= 0) continue;
      // console.log("Determining taxable for line item:test case", li);
      // 1) Taxable: prefer line_items[].item_tax_info.taxable from API response
      // const isTaxable =
      //   li?.item_tax_info && typeof (li.item_tax_info as any).taxable === "boolean"
      //     ? (li.item_tax_info as any).taxable
      //     : li?.is_new_purchase
      //       ? (li?.is_taxable !== false)
      //       : !!(li?.is_taxable);
      const isTaxable =
  typeof li?.item_tax_info?.taxable === "boolean"
    ? li.item_tax_info.taxable
    : false;
// console.log("line item taxable info:", { item_tax_info: li?.item_tax_info, isTaxable });
      if (!isTaxable) continue;
            // console.log(`Adding product line for TaxCloud cart: SKU=${li?.sku}, price=${priceToUse}, qty=${qty}, taxable=${isTaxable}`);
      items.push({
        sku: String(li?.sku || li?.product_id || ""),
        price: Math.round(priceToUse * 100) / 100,
        quantity: qty,
        itemType: "default",
        taxable: isTaxable,
      });
    }

    return items;
  };

  // Map line items -> buckets; feeNames = special fee names so product lines (SKU) are separated from fee lines
  const parseTaxCloudUpsert = (resp: any, feeNames: string[] = []) => {
    const item = resp?.items?.[0] || {};
    const cartId = item?.cartId;
    const lines: any[] = Array.isArray(item?.lineItems) ? item.lineItems : [];
    const feeNameSet = new Set(feeNames.map((n) => String(n || "").trim()).filter(Boolean));

    const installLine = lines.find(l => String(l?.itemId) === "InstallationCost");
    const feeLines = lines.filter(l => feeNameSet.has(String(l?.itemId || "")));
    const productLines = lines.filter(
      l => String(l?.itemId) !== "InstallationCost" && !feeNameSet.has(String(l?.itemId || ""))
    );

    const install = {
      sub: Number(installLine?.price || 0),
      tax: Number(installLine?.tax?.amount || 0),
      rate: Number(installLine?.tax?.rate || 0),
    };

    const fees = feeLines.map(l => ({
      name: String(l?.itemId || "Special Fee"),
      amount: Number(l?.price || 0),
      tax_amount: Number(l?.tax?.amount || 0),
      tax_percentage: Number(l?.tax?.rate || 0),
    }));

    const feeSub = fees.reduce((s, f) => s + Number(f.amount || 0), 0);
    const feeTax = fees.reduce((s, f) => s + Number(f.tax_amount || 0), 0);

    let productSub = 0;
    let productTax = 0;
    for (const ln of productLines) {
      productSub += Number(ln?.price || 0) * Number(ln?.quantity ?? 1);
      productTax += Number(ln?.tax?.amount ?? 0);
    }

    return { cartId, install, fees, feeSub, feeTax, productSub, productTax };
  };

  // merge TaxCloud fee rows back with current UI to reattach IDs/taxable flags; include BOTH taxable and non-taxable fees
  const mergeFeesWithUi = (tcFees: any[], uiFees: any[]) => {
    const byName = new Map(uiFees.map((u: any) => [String(u.name || "").toLowerCase(), u]));
    // 1) Merge taxable fees from TaxCloud (with UI ids/taxable flags)
    const mergedTaxable = tcFees.map((f) => {
      const key = String(f.name || "").toLowerCase();
      const match = byName.get(key);
      return {
        id: String(match?.id || match?.specialfee_id || ""),
        name: f.name,
        amount: Number(f.amount || 0),
        taxable: true,
        tax_percentage: Number.isFinite(f.tax_percentage) ? Number(f.tax_percentage) : null,
        tax_amount: Number(f.tax_amount || 0),
      };
    });
    const tcNames = new Set(mergedTaxable.map((f: any) => String(f.name || "").toLowerCase()));
    // 2) Add non-taxable fees from UI (not in TaxCloud response)
    const nonTaxable = uiFees.filter((u: any) => (u?.taxable ?? u?.specialfee_taxable) === false);
    for (const u of nonTaxable) {
      const key = String(u.name || "").toLowerCase();
      if (!tcNames.has(key)) {
        mergedTaxable.push({
          id: String(u?.id ?? u?.specialfee_id ?? ""),
          name: String(u?.name ?? u?.specialfee_name ?? "Special Fee"),
          amount: Number(u?.amount ?? u?.specialfee_amount ?? 0),
          taxable: false,
          tax_percentage: 0,
          tax_amount: 0,
        });
        tcNames.add(key);
      }
    }
    return mergedTaxable;
  };


  // if orderId contains "-", split and take the number after "-"
  let finalCartId = ""
  if (ordernumber && installationOrder?.cart_id) {
    const suffix = ordernumber.includes("-")
      ? ordernumber.split("-")[1]   // get part after "-"
      : "";                     // no suffix

    // append suffix to cart_id
    finalCartId = suffix ? `${installationOrder?.cart_id}-${suffix}` : installationOrder?.cart_id;
  }

  const callWorkOrderResolveDraft = React.useCallback(
    async (
      feesInput?: any[],
      discountCodeOverride?: string,
      action: OrderResolveAction = "draft",
      installationCostOverride?: number
    ) => {
      if (!dynamicCostId || !token) return null;

      const fees = (feesInput ?? selectedSpecialFees)
        .map((f: any) => ({
          id: String(f?.id ?? ""),
          name: String(f?.name ?? "Special Fee"),
          amount: Number(f?.amount ?? 0),
          taxable: f?.taxable !== false,
        }))
        .filter((f) => f.id !== "");

      let resolveSourceId = "";
      let resolveCustomerId = "";
      let resolveInventorySource = "agent";
      let resolveAgentId: string | null = null;
      let resolveAgentName: string | null = null;
      let resolveOfficeInfo: unknown = installationOrder?.office ?? null;
      let resolveBillingAddress: unknown = selectedBillingAddress;
      const effectiveTeamMemberId =
        selectedTeamMemberOption?.value || selectedTeamMember?.value || installationOrder?.team_member_id || "";

      if (selectedOfficeAgent) {
        resolveSourceId = selectedOfficeAgent.value;
        resolveCustomerId = selectedOfficeAgent.value;
        resolveAgentId = selectedOfficeAgent.value;
        resolveAgentName = selectedOfficeAgent.label;
        resolveInventorySource = "agent";
        const selectedOfficeData = offices?.find((office) => office._id === selectedOffice?.value);
        resolveOfficeInfo = {
          _id: selectedOffice?.value,
          officeName: selectedOffice?.label,
          officeType: selectedOffice?.label,
          officeAddress: selectedOfficeData?.officeAddress?.[0],
          status: true,
        };
        resolveBillingAddress = selectedOfficeBillingAddress;
      } else if (selectedAgent) {
        resolveSourceId = selectedAgent.value;
        resolveCustomerId = selectedAgent.value;
        resolveAgentId = selectedAgent.value;
        resolveAgentName = selectedAgent.label;
        resolveInventorySource = "agent";
      } else if (selectedOffice) {
        resolveSourceId = selectedOffice.value;
        resolveInventorySource = "office";
        resolveCustomerId = effectiveTeamMemberId || selectedBrokerageFirm?.value || "";
        const selectedOfficeData = offices?.find((office) => office._id === selectedOffice?.value);
        resolveOfficeInfo = {
          _id: selectedOffice?.value,
          officeName: selectedOffice?.label,
          officeType: selectedOffice?.label,
          officeAddress: selectedOfficeData?.officeAddress?.[0],
          status: true,
        };
        resolveBillingAddress = selectedOfficeBillingAddress;
      } else {
        resolveSourceId = String(
          installationOrder?.source_id ||
            installationOrder?.agent_id ||
            installationOrder?.office?._id ||
            ""
        );
        resolveCustomerId = String(
          installationOrder?.customer_id ||
            installationOrder?.agent_id ||
            effectiveTeamMemberId ||
            ""
        );
        resolveInventorySource = installationOrder?.agent_id ? "agent" : "office";
      }

      let cartId = String(installationOrder?.cart_id || "");
      if (ordernumber && installationOrder?.cart_id) {
        const suffix = ordernumber.includes("-") ? ordernumber.split("-")[1] : "";
        cartId = suffix ? `${installationOrder.cart_id}-${suffix}` : String(installationOrder.cart_id);
      }

      const resolveDiscountCode = getInstallationResolveRootDiscountCode({
        discountCodeOverride,
        formikDiscountCode: formik.values.discount_code,
        orderDiscountCode: (installationOrder as any)?.discount_code,
        orderCouponCode: (installationOrder as any)?.coupon_code,
        latestDiscountCodeRef: latestDiscountCodeRef.current,
        orderLineItems: installationOrder?.line_items,
      });

      const resolveLineItems = (() => {
        const editLines = buildInstallationEditResolveLineItems(
          installationOrder?.line_items,
          (selectedProducts || []).map((p) => ({
            product_id: String(p.product_id),
            variant_id: p.variant_id,
            quantity: p.quantity,
            name: p.name,
            sku: p.sku,
            unit_price: getUnitRetailPriceForPayload(p),
          })),
          manualUnitPriceMap
        );
        const coveredKeys = new Set(
          editLines.map((li) => orderLineKey(li.product_id, li.variant_id))
        );
        const newCatalogProducts = (selectedProducts || []).filter(
          (p) =>
            Boolean(p.is_new_catalog) &&
            p.product_id &&
            !coveredKeys.has(orderLineKey(String(p.product_id), String(p.variant_id ?? "")))
        );
        const newCustomProducts = (selectedProducts || [])
          .filter(
            (p) =>
              String(p.inventory_type || "").toLowerCase() === "custom" &&
              p.product_id &&
              !coveredKeys.has(orderLineKey(String(p.product_id), String(p.variant_id ?? "")))
          )
          .map((p) => ({
            product_id: String(p.product_id),
            variant_id: String(p.variant_id ?? ""),
            item_name: String(p.name ?? ""),
            quantity: p.quantity,
            Price: Number(p.unit_price ?? p.changed_unit_price ?? 0),
            is_taxable: Boolean(p.is_taxable),
          }));
        const addLines =
          newCatalogProducts.length || newCustomProducts.length
            ? buildInstallationAddResolveLineItems({
                catalogProducts: newCatalogProducts,
                customProducts: newCustomProducts,
                manualUnitPriceMap,
                defaultInventorySource: resolveInventorySource,
              })
            : [];
        return [...editLines, ...addLines];
      })();

      const resolvedInstallationCost = Number(
        installationCostOverride ??
          installationCostRef.current ??
          installationCost ??
          formik.values.installation_cost ??
          0
      );

      const resolvePayload = buildInstallationResolvePayload({
        orderNumber: String(installationOrder?.order_number || "").trim(),
        cartId,
        dynamicCostId,
        signageId: String(signageId),
        sourceId: resolveSourceId,
        customerId: resolveCustomerId,
        inventorySource: resolveInventorySource,
        installationCost: resolvedInstallationCost,
        installationTaxable: dynamicTaxable,
        discountCode: resolveDiscountCode,
        paymentMethod: formik.values.payment_method || "card",
        userType: formik.values.userType,
        userName: userName || "",
        userEmail: formik.values.userEmail,
        userPhone: formik.values.userPhone,
        customerFirstName: formik.values.userFirstName,
        customerLastName: formik.values.userLastName,
        customerEmail: formik.values.userEmail,
        customerPhone: formik.values.userPhone,
        brokerageFirmId: selectedBrokerageFirm?.value ?? installationOrder?.brokerage_firm_id ?? null,
        brokerageFirmName: selectedBrokerageFirm?.label ?? installationOrder?.brokerage_firm_name ?? null,
        teamMemberId: effectiveTeamMemberId || null,
        teamMemberName:
          selectedTeamMemberOption?.label ||
          selectedTeamMember?.label ||
          installationOrder?.team_member_name ||
          "",
        office: resolveOfficeInfo,
        agentId: resolveAgentId ?? installationOrder?.agent_id ?? null,
        agentName: resolveAgentName ?? installationOrder?.agent_name ?? null,
        billingAddress: resolveBillingAddress as InstallationResolveAddress | null,
        installationAddress: installationAddress as InstallationResolveAddress | null,
        lineItems: resolveLineItems,
        specialFees: fees.map((f) => mapInstallationSpecialFeeForResolve(f, allAvailableSpecialFees)),
      });

      const resolved = await postInstallationOrderResolve(token, {
        order_type: "installation",
        action,
        payload: resolvePayload,
      });

      return resolved && typeof resolved === "object" ? resolved : null;
    },
    [
      token,
      dynamicCostId,
      signageId,
      ordernumber,
      installationCost,
      dynamicTaxable,
      installationOrder,
      selectedProducts,
      selectedSpecialFees,
      selectedOfficeAgent,
      selectedAgent,
      selectedOffice,
      selectedBrokerageFirm,
      selectedTeamMember,
      selectedTeamMemberOption,
      selectedBillingAddress,
      selectedOfficeBillingAddress,
      offices,
      installationAddress,
      formik.values,
      userName,
      manualUnitPriceMap,
      getUnitRetailPriceForPayload,
    ]
  );

  const handleGetLiveTax = async () => {
    try {
      if (!token || !userId || !installationId || !finalCartId) {
        showError("Missing token/user/order for live tax");
        return;
      }
      setLiveTaxLoading(true);
      const selectedFees = getSelectedFees();
      const resolved = await callWorkOrderResolveDraft(selectedFees);
      if (!resolved) {
        showError("Pricing could not be calculated. Please try again.");
        setLiveTaxLoading(false);
        return;
      }

      lastResolvedInstallationRef.current = resolved;
      const applied = applyInstallationEditResolveResponse(
        resolved,
        formik,
        Number(installationCost) || 0,
        {
          requestedDiscountCode: getInstallationResolveRootDiscountCode({
            formikDiscountCode: formik.values.discount_code,
            orderDiscountCode: (installationOrder as any)?.discount_code,
            orderCouponCode: (installationOrder as any)?.coupon_code,
            latestDiscountCodeRef: latestDiscountCodeRef.current,
            orderLineItems: installationOrder?.line_items,
          }),
          feesFieldName: "specialfee",
          existingFeeRows: selectedFees,
          specialFeeCatalog: allAvailableSpecialFees,
        }
      );
      setSelectedSpecialFees(applied.mergedFees);

      const orderLineItems = Array.isArray(installationOrder?.line_items) ? installationOrder.line_items : [];
      const patchBody = buildInstallationPatchFromResolved(resolved, {
        version: installationOrder?.version,
        installationCost: Number(installationCost) || 0,
        existingLineItems: orderLineItems,
        taxStatus: "draft",
      });

      // ✅ Enable PATCH call to save live tax data
      const patchRes = await fetch(
        `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
        {
          method: "PATCH",
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          body: JSON.stringify(patchBody),
        }
      );
      if (!patchRes.ok) {
        const msg = await patchRes.text().catch(() => "");
        throw new Error(msg || "Failed to update installation order with live tax");
      }

      setInstallationOrder((prev: any) => ({
        ...prev,
        cart_id: resolved.cart_id || prev?.cart_id,
        installation_cost: patchBody.installation_cost,
        installation_tax_amount: patchBody.installation_tax_amount,
        installation_tax_percentage: patchBody.installation_tax_percentage,
        over_all_tax_percentage: patchBody.over_all_tax_percentage,
        over_all_tax_amount: patchBody.over_all_tax_amount,
        subtotal_amount: patchBody.subtotal_amount,
        total_amount: patchBody.total_amount,
        line_items: patchBody.line_items,
        specialfee: patchBody.specialfee,
        tax_status: "draft",
      }));

      setTaxCartId(resolved.cart_id || finalCartId);
      setLiveTaxReady(true);
      showSuccess("Live tax saved to order. Click Next to finalize.");
      // if (!skipLiveTaxNavigateRef.current) {
      //   navigate(0);
      // }
    } catch (e: any) {
      safeConsole.error("[GetLiveTax] failed", e);
      // const rawMsg = String(e?.message || "Get Live Tax failed");
      // const normalizedMsg = /cartitems\s*\(non-empty array\)\s*is required/i.test(rawMsg)
      //   ? "Selected product is not taxable: Review product configuration"
      //   : rawMsg;
      // showError(normalizedMsg);
      setLiveTaxReady(false);
    } finally {
      fetchOrderDetails();
      setLiveTaxLoading(false);
    }
  };


  const handleLiveTaxNext = async (): Promise<boolean> => {
    try {
      if (!token || !userId || !installationId) {
        showError("Missing token/user/order for live tax");
        return false;
      }

      const selectedFees = getSelectedFees();
      const resolved = await callWorkOrderResolveDraft(selectedFees, undefined, "complete");
      if (!resolved) {
        showError("Pricing could not be calculated. Please try again.");
        return false;
      }

      lastResolvedInstallationRef.current = resolved;
      showSuccess("TaxCloud order finalized.");

      const patchBody = {
        version: installationOrder?.version,
        tax_status: "complete",
      };

      const patchRes = await fetch(
        `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
        {
          method: "PATCH",
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          body: JSON.stringify(patchBody),
        }
      );
      if (!patchRes.ok) {
        const msg = await patchRes.text().catch(() => "");
        throw new Error(msg || "Failed to update installation order with live tax");
      }

      setInstallationOrder((prev: any) => ({
        ...prev,
        tax_status: "complete",
      }));
      return true;
    } catch (e: any) {
      safeConsole.error("[LiveTax Next] failed", e);
      showError(e?.message || "Finalize failed");
      return false;
    } finally {
      fetchOrderDetails();
    }
  };

  useEffect(() => {
    (async () => {
      if (!token || !installationOrder) return;

      const orderdata = (await GetVersionOrdernumber(
        token,
        installationOrder.order_number,
        installationOrder?.order_type || "installation"
      )) || null;
      const orderId = (orderdata as any)?.full_number || (orderdata as any)?.order_number || "";
      setOrderNumber(orderId);
    })();
  }, [token, installationOrder]);




  // tax related edit fileopen time logic write this file inside 

  const coalesceDestination = (): Addresstax => {
    const a = installationAddress?.address_details as Addresstax | undefined;
    const f = (formik.values?.installation_address?.address_details) as Addresstax | undefined;
    return {
      addressLine1: a?.addressLine1 ?? f?.addressLine1 ?? "",
      city: a?.city ?? f?.city ?? "",
      state: a?.stateCode ?? a?.state ?? f?.state ?? f?.stateCode ?? "",
      zip: a?.zip ?? f?.zip ?? "",
      // country: a?.country ?? f?.country ?? "US",
      stateCode: a?.stateCode ?? f?.stateCode ?? "",
      latitude: a?.latitude ?? f?.latitude,
      longitude: a?.longitude ?? f?.longitude,
      // countryCode: a?.countryCode ?? f?.countryCode ?? "US",
    };
  };

  // ✅ Use state directly (more reliable than Formik)
  const getSelectedFees = () => {
    return selectedSpecialFees
      .map((f) => normalizeInstallationSelectedFee(f, allAvailableSpecialFees))
      .filter((f) => f.id !== "");
  };


  // --- Allow recompute to accept overrides so it never reads stale state ---
  type RecomputeOverride = {
    fees?: any[];
    destination?: any;
    discountCode?: string;
    installationCost?: number;
  };

  const debounceRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  const pendingOverrideRef = React.useRef<RecomputeOverride | null>(null);

  // ✅ Add ref to prevent overlapping recompute calls
  const isRecomputingRef = React.useRef(false);

  const recompute = React.useCallback(async (override?: RecomputeOverride) => {
    if (!dynamicCostId) return false;

    // ✅ Prevent overlapping recompute calls
    if (isRecomputingRef.current) {
      safeConsole.log("⏭️ Skipping recompute - already in progress");
      return false;
    }

    // ✅ Clear any pending debounced calls
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
      debounceRef.current = null;
      pendingOverrideRef.current = null;
    }

    try {
      isRecomputingRef.current = true;
      setIsRecomputing(true);
      setCouponResolveError("");
      const fees = override?.fees ?? getSelectedFees();
      const discountCode =
        override?.discountCode !== undefined
          ? String(override.discountCode)
          : String(
              formik.values.discount_code || (installationOrder as any)?.discount_code || ""
            );
      const effectiveInstallationCost = Number(
        override?.installationCost ??
          installationCostRef.current ??
          installationCost ??
          formik.values.installation_cost ??
          0
      );
      const resolved = await callWorkOrderResolveDraft(
        fees,
        discountCode,
        "draft",
        effectiveInstallationCost
      );
      if (!resolved || typeof resolved !== "object") {
        const allFeesSubtotal = fees.reduce((sum, f) => sum + Number(f.amount || 0), 0);
        formik.setFieldValue("totals.installation_subtotal", effectiveInstallationCost, false);
        formik.setFieldValue("totals.installation_tax_amount", 0, false);
        formik.setFieldValue("totals.specialfee_subtotal", allFeesSubtotal, false);
        formik.setFieldValue("totals.specialfee_tax_amount", 0, false);
        formik.setFieldValue("totals.grand_total", effectiveInstallationCost + allFeesSubtotal, false);
        formik.setFieldValue("specialfee", fees, false);
        return false;
      }

      lastResolvedInstallationRef.current = resolved;
      const applied = applyInstallationEditResolveResponse(
        resolved,
        formik,
        effectiveInstallationCost,
        {
          requestedDiscountCode: discountCode,
          feesFieldName: "specialfee",
          existingFeeRows: fees,
          specialFeeCatalog: allAvailableSpecialFees,
        }
      );
      setSelectedSpecialFees(applied.mergedFees);
      return true;
    } catch (e) {
      safeConsole.error("[OrderResolve] failed:", e);
      setCouponResolveError(
        String((e as { message?: string })?.message ?? "Failed to calculate pricing")
      );
      return false;
    } finally {
      // ✅ Always reset loading state when recompute completes (both state and ref)
      isRecomputingRef.current = false;
      setIsRecomputing(false);
    }
    // Keep deps minimal to avoid noisy re-renders
  }, [
    token,
    userId,
    installationOrder?.signage_id,
    dynamicCostId,
    installationCost,
    dynamicTaxable,
    formik.values.installation_cost,
    formik.values.install_taxable,
    formik.values.install_tax_percentage,
    formik.values.discount_amount,
    installationAddress?.address_details?.addressLine1,
    installationAddress?.address_details?.city,
    installationAddress?.address_details?.state,
    installationAddress?.address_details?.stateCode,
    installationAddress?.address_details?.zip,
    selectedOfficeAgent?.value,  // ✅ For currentOwner.id
    selectedAgent?.value,  // ✅ For currentOwner.id
    selectedOffice?.value,  // ✅ For currentOwner.id
    installationOrder?.cart_id,  // ✅ Needed for cartId
    isEdit,  // ✅ Needed for mode
    callWorkOrderResolveDraft,
  ]);


  const ready = React.useMemo(
    () =>
      Boolean(
        isEdit &&
        (installationOrder?.signage_id || selectedInstaller?.value) &&
        installationAddress?.address_details &&
        Number.isFinite(Number(installationCost))
      ),
    [isEdit, installationOrder?.signage_id, selectedInstaller?.value, installationAddress?.address_details, installationCost]
  );

  const recomputeRef = React.useRef(recompute);
  recomputeRef.current = recompute;

  const waitForRecomputeIdle = React.useCallback((maxMs = 10000) => {
    return new Promise<void>((resolve) => {
      const started = Date.now();
      const tick = () => {
        if (!isRecomputingRef.current || Date.now() - started > maxMs) {
          resolve();
          return;
        }
        window.setTimeout(tick, 50);
      };
      tick();
    });
  }, []);

  const applyDiscountCode = React.useCallback(
    async (rawCode: string) => {
      const code = String(rawCode || "").trim();
      if (!code) return;
      if (!dynamicCostId) {
        showError("Installation pricing is still loading. Please wait and try again.");
        return;
      }

      markDiscountTouched();
      setCouponResolveError("");
      setCouponInput(code);
      latestDiscountCodeRef.current = code;
      formik.setFieldValue("discount_code", code, false);

      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
        debounceRef.current = null;
      }

      await waitForRecomputeIdle();

      const ok = await recomputeRef.current?.({ discountCode: code });
      const display = getResolvedDiscountDisplay(lastResolvedInstallationRef.current, code);

      if (display.code && display.amount > 0) {
        setCouponInput(display.code);
        latestDiscountCodeRef.current = display.code;
        formik.setFieldValue("discount_code", display.code, false);
        formik.setFieldValue("discount_amount", display.amount, false);
        setZeroOrNegativeMsg("");
        setCouponResolveError("");
        return;
      }

      if (!ok) {
        setCouponResolveError((prev) => prev || "Discount could not be applied. Please try again.");
      } else {
        setCouponResolveError("This discount code could not be applied.");
      }
    },
    [dynamicCostId, formik, waitForRecomputeIdle, markDiscountTouched]
  );

  const clearDiscountCode = React.useCallback(async () => {
    markDiscountTouched();
    setCouponResolveError("");
    setCouponInput("");
    latestDiscountCodeRef.current = "";
    formik.setFieldValue("discount_code", "", false);
    formik.setFieldValue("discount_amount", 0, false);
    formik.setFieldValue("product_discount_amount", 0, false);
    formik.setFieldValue("discount_applies_to", "installation", false);
    setProductPerItemDiscountMap({});
    setZeroOrNegativeMsg("");

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
      debounceRef.current = null;
    }

    await waitForRecomputeIdle();
    await recomputeRef.current?.({ discountCode: "" });
  }, [formik, waitForRecomputeIdle, markDiscountTouched]);

  const discountDisplay = React.useMemo(() => {
    const formikCode = discountUserTouched
      ? String(formik.values.discount_code || "").trim()
      : String(formik.values.discount_code || costBreakdownDiscountCode || "").trim();
    const formikAmount = discountUserTouched
      ? Number(formik.values.discount_amount || 0)
      : Number(formik.values.discount_amount || effectiveDiscountAmount || 0);

    return getOrderDiscountFieldDisplay({
      formikCode,
      formikAmount,
      couponInput,
      resolved: lastResolvedInstallationRef.current,
    });
  }, [
    discountUserTouched,
    formik.values.discount_code,
    formik.values.discount_amount,
    costBreakdownDiscountCode,
    effectiveDiscountAmount,
    couponInput,
  ]);

  const triggerRecomputeWith = React.useCallback((override?: RecomputeOverride) => {
    // ✅ Don't schedule if recompute is already running
    if (isRecomputingRef.current) {
      safeConsole.log("⏸️ Recompute in progress, skipping debounced call");
      return;
    }

    pendingOverrideRef.current = override || null;
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      // ✅ Double-check before calling (in case state changed during debounce)
      if (!isRecomputingRef.current) {
        const ov = pendingOverrideRef.current;
        pendingOverrideRef.current = null;
        recompute(ov || undefined);
      }
    }, 300);
  }, [recompute]);

  triggerRecomputeWithRef.current = triggerRecomputeWith;

  const installationAddressSig = React.useMemo(() => {
    const d = installationAddress?.address_details;
    if (!d) return "";
    return [
      d.addressLine1,
      d.city,
      d.state,
      d.stateCode,
      d.zip,
      d.latitude,
      d.longitude,
    ].join("|");
  }, [installationAddress?.address_details]);

  const prevInstallationAddressSigRef = React.useRef<string | null>(null);
  const lastRecomputeWatchSigRef = React.useRef<string>("");
  const isInitialRecomputeWatchRef = React.useRef(true);

  const recomputeWatchSig = React.useMemo(() => {
    if (!isEdit) return "";
    return JSON.stringify({
      installationCost: Number(installationCost) || 0,
      purchased: (selectedProducts || [])
        .filter((p) => isPurchasedInstallationLine(p))
        .map((p) => {
          const key = keyForInstallationProduct(p);
          const price =
            manualUnitPriceMap[key] !== undefined
              ? Number(manualUnitPriceMap[key])
              : getUnitRetailPriceForPayload(p);
          return `${p.product_id}:${p.variant_id ?? ""}:${p.quantity}:${price}`;
        })
        .join("|"),
      manualPrices: manualUnitPriceMap,
    });
  }, [isEdit, installationCost, selectedProducts, manualUnitPriceMap, getUnitRetailPriceForPayload]);

  React.useEffect(() => {
    if (!isEdit || !ready || !installationAddressSig) return;

    if (prevInstallationAddressSigRef.current === null) {
      prevInstallationAddressSigRef.current = installationAddressSig;
      return;
    }

    if (prevInstallationAddressSigRef.current === installationAddressSig) return;

    prevInstallationAddressSigRef.current = installationAddressSig;
    triggerRecomputeWith();
  }, [installationAddressSig, isEdit, ready, triggerRecomputeWith]);

  React.useEffect(() => {
    if (!isEdit || !ready) return;
    if (!recomputeWatchSig) return;
    if (isRecomputingRef.current) return;

    if (isInitialRecomputeWatchRef.current) {
      isInitialRecomputeWatchRef.current = false;
      lastRecomputeWatchSigRef.current = recomputeWatchSig;
      return;
    }

    if (lastRecomputeWatchSigRef.current === recomputeWatchSig) return;
    lastRecomputeWatchSigRef.current = recomputeWatchSig;
    triggerRecomputeWith();
  }, [isEdit, ready, recomputeWatchSig, triggerRecomputeWith]);

  const recalcInstallationTaxes = React.useCallback(
    async (forceType?: "manual" | "taxcloud", options?: { allowRefund?: boolean }) => {
      try {
        await recompute();
      } catch (err) {
        safeConsole.error("[INSTALL:TAX] recompute before refund failed", err);
      }

      if (!options?.allowRefund) return false;
      if (!token || !installationOrder?.order_number) return false;
      if (installationOrder?.tax_status !== "complete") return false;
      if (forceType !== "taxcloud") return false;

      try {
        const orderdata = (await GetVersionOrdernumber(
          token,
          installationOrder.order_number,
          installationOrder?.order_type || "installation"
        )) || null;
        const order_number = (orderdata as any)?.full_number || (orderdata as any)?.order_number || "";
        if (!order_number) throw new Error("Missing order number for refund");
        const success = await requestInstallationTaxRefund(token, order_number || "");
        if (!success) throw new Error("TaxCloud refund failed");
        try {
          await recompute();
        } catch (recomputeErr) {
          safeConsole.error("[INSTALL:TAX] recompute after refund failed", recomputeErr);
        }
        return true;
      } catch (err) {
        safeConsole.error("[INSTALL:TAX] refund failed:", err);
        showError("Failed to request TaxCloud refund.");
        return false;
      }
    },
    [installationOrder?.order_number, installationOrder?.tax_status, recompute, token]
  );

  React.useEffect(() => {
    installationTaxRef.current = { recalculate: recalcInstallationTaxes };
  }, [recalcInstallationTaxes]);

  const currentOwner =
    selectedOfficeAgent
      ? { id: selectedOfficeAgent.value, name: selectedOfficeAgent.label, type: "agent" as const }
      : selectedAgent
        ? { id: selectedAgent.value, name: selectedAgent.label, type: "agent" as const }
        : selectedOffice
          ? { id: selectedOffice.value, name: selectedOffice.label, type: "office" as const }
          : null;

  // ✅ Separate logic for CouponDiscount customerId (different from currentOwner)
  const effectiveCouponCreatedById = React.useMemo(() => {
    let id = "";
    let source = "";

    // Priority: Office Agent > Team Member (for office path) > Direct Agent > InstallationOrder data > Fallback
    if (selectedOfficeAgent?.value) {
      // Office Agent path: use agent ID
      id = selectedOfficeAgent.value;
      source = "Office Agent";
    } else if (selectedOffice?.value && selectedTeamMemberOption?.value) {
      // Office selected (without agent): use team member ID (NOT office ID)
      id = selectedTeamMemberOption.value;
      source = "Team Member (via Office)";
    } else if (selectedAgent?.value) {
      // Direct agent path: use agent ID
      id = selectedAgent.value;
      source = "Direct Agent";
    } else if (installationOrder?.agent_id) {
      // Fallback to installationOrder agent ID
      id = installationOrder.agent_id;
      source = "InstallationOrder Agent";
    } else if (installationOrder?.inventory_source === "office" && installationOrder?.team_member_id) {
      // Office path from installationOrder: use team member ID
      id = installationOrder.team_member_id;
      source = "InstallationOrder Team Member";
    } else if (installationOrder?.brokerage_firm_id) {
      // Last fallback: brokerage firm ID
      id = installationOrder.brokerage_firm_id;
      source = "InstallationOrder Brokerage Firm";
    } else {
      id = "";
      source = "User (Fallback)";
    }

    // console.log(`🎟️ [Installation] Coupon customerId: ${id} (from ${source})`);
    return id;
  }, [selectedOfficeAgent, selectedAgent, selectedOffice, selectedTeamMemberOption, installationOrder?.agent_id, installationOrder?.team_member_id, installationOrder?.brokerage_firm_id, installationOrder?.inventory_source, userId]);

  React.useEffect(() => () => { if (debounceRef.current) clearTimeout(debounceRef.current); }, []);
  React.useEffect(() => {
    const current = Array.isArray((formik.values as any)?.specialfee)
      ? (formik.values as any).specialfee
      : [];

    // ✅ In VIEW mode, always sync from backend
    if (mode === "view") {
      formik.setFieldValue("specialfee", preselectedSpecialFees, false);
      setSelectedSpecialFees(preselectedSpecialFees);
      return;
    }

    // ✅ In EDIT/CREATE, seed only if empty (don’t override user edits)
    if (current.length === 0 && preselectedSpecialFees.length > 0) {
      formik.setFieldValue("specialfee", preselectedSpecialFees, false);
      setSelectedSpecialFees(preselectedSpecialFees);
    }
  }, [mode, preselectedSpecialFees]);


  // // Seed preselected special fees once on load
  // const seededRef = React.useRef(false);
  // React.useEffect(() => {
  //   if (seededRef.current) return;

  //   const values = formik.values as any;
  //   const cur = values?.specialfee;
  //   const hasAny = Array.isArray(cur) && cur.length > 0;

  //   if (!hasAny && preselectedSpecialFees.length > 0) {
  //     // console.log("Seeding special fees from backend:", preselectedSpecialFees);

  //     // ✅ Update both Formik AND state (root-level)
  //     formik.setFieldValue("specialfee", preselectedSpecialFees, false);
  //     formik.setFieldValue("totals", initialTotals, false);
  //     setSelectedSpecialFees(preselectedSpecialFees);

  //     seededRef.current = true;
  //   }
  // }, [preselectedSpecialFees, initialTotals, formik]);



  if (!isLoaded) return <div>Loading...</div>;
  const headerProjectId = String(
    linkedProjectId ||
    projectIdFromQuery ||
    (installationOrder as any)?.project_id?._id ||
    (installationOrder as any)?.project_id?.id ||
    (installationOrder as any)?.project_id ||
    ""
  ).trim();

  return (
    <div className="content container">
      <SendOrderEmailRecipientsModal
        show={emailRecipientsModal != null}
        title={emailRecipientsModal === "invoice" ? "Send Invoice" : "Send Quote"}
        token={token || ""}
        primaryEmailHint={
          String(
            installationOrder?.customer_email || installationOrder?.user_email || ""
          ).trim() || undefined
        }
        confirming={
          emailRecipientsModal === "invoice" ? sendInvoiceLoading : orderSummarySending
        }
        onCancel={() => setEmailRecipientsModal(null)}
        onConfirm={async (additionalEmails) => {
          const mode = emailRecipientsModal;
          try {
            if (mode === "invoice") {
              await handleSendInvoiceEmail(additionalEmails);
            } else if (mode === "quote") {
              await handleInstallationSendQuoteClick(additionalEmails);
            }
          } finally {
            setEmailRecipientsModal(null);
          }
        }}
      />
      {
        <style>{`
        
        .custom-btn {
              font-size: 14px;
              font-weight: 600;
          }
          .custom-btn:hover {
              background-color: #155dfc;
              color: #fff;
              font-size: 14px;
              font-weight: 600;
          }
        `}</style>
      }
      <div className="page-container ps-0">
        <h3 className="m-0 text-center fw-bold addheaders ps-1 d-flex align-items-center justify-content-center flex-wrap gap-2">
          <span>
            Installation Job &nbsp; {type}&nbsp; #{installationOrder?.order_number}
            {installationOrder?.project_number ? (
              <>
                {" "}
                Project{" "}
                {headerProjectId ? (
                  <Link to={`${baseRoute}/projects/view/${headerProjectId}`} className=" order-link-1">
                    #{installationOrder?.project_number}
                  </Link>
                ) : (
                  <span className=" order-link-1">#{installationOrder?.project_number}</span>
                )}
              </>
            ) : null}
          </span>
          {Viewmode ? <BrokerageAssociationStatusBadge source={installationOrder} /> : null}
        </h3>
      </div>
      <div className="mb-4">
        <div className="align-items-center col-lg-12 d-flex flex-wrap justify-content-end justify-content-lg-between os-card">
          {Viewmode && (
            <div className="dropdown p-2 d-flex d-lg-none">
              <button
                className="btn btn-outline-secondary dropdown-toggle btn-sm br-8 table-cells custom-btn px-3"
                type="button"
                id="orderActionsDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Actions
              </button>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="orderActionsDropdown">
                {
                  status <= 300 && (
                    <Link
                      to={`${baseRoute}/jobs/installationWorkOrder/${installationId}`}
                      state={{ type: "Edit" }}
                      className="dropdown-item text-primary table-cells"
                    >
                      <i className="ri-pencil-fill me-2"></i>Edit
                    </Link>
                  )
                }
                {/* <Link to={""} className="dropdown-item text-primary table-cells">
                  <i className="ri-mail-send-line me-2"></i>Email
                </Link> */}

                {/* {quoteModeEnabled && (
                  <li>
                    <button
                      type="button"
                      className="dropdown-item"
                      disabled={orderSummarySending}
                      onClick={() => {
                        if (!requireGetLiveTaxBeforeProceed()) return;
                        void handleInstallationSendQuoteClick();
                      }}
                    >
                      <i className="bi bi-file-earmark-text me-2" />
                      {orderSummarySending ? "Sending…" : "Send Quote"}
                    </button>
                  </li>
                )}

                <li>
                  <button
                    type="button"
                    className="dropdown-item"
                    onClick={() => handleInstallationOrderSummaryPreviewClick()}
                  >
                    <i className="bi bi-eye me-2" />
                    View/Order Summary
                  </button>
                </li> */}

                {status >= 100 && status <= 400 && (
                  <button className="dropdown-item text-danger table-cells" style={{ paddingLeft: 12 }} onClick={() => handleInstallationStatus(600)}>
                    <i className="mdi mdi-archive-remove-outline me-2"></i>Cancel Job
                  </button>
                )}
                {/* {(installationOrder?.status === 300 && installationOrder?.payment_info?.length > 0) && (
                  <button className="dropdown-item text-primary table-cells" onClick={() => handleInstallationStatus(400)}>
                    <i className="mdi mdi-truck-fast-outline me-2"></i>In Progress
                  </button>
                )}

                {installationOrder?.status === 400 && (
                  <button className="dropdown-item text-info table-cells" onClick={() => handleInstallationStatus(500)}>
                    <i className="mdi mdi-truck-check-outline me-2"></i> Complete
                  </button>
                )}
                {installationOrder?.status === 100 && (
                  <button className="dropdown-item text-success table-cells" onClick={() => handleInstallationStatus(200)}>
                    <i className="mdi mdi-check-bold me-2"></i> Finalize
                  </button>
                )} */}

                {/* {installationOrder?.status === 200 && (
                <button className="btn btn-primary" onClick={() => handleInstallationStatus(300)}>
                  Click to Schedule
                </button>
              )}

              {installationOrder?.status === 300 && (
                <button className="btn btn-primary" onClick={() => handleInstallationStatus(300)}>
                  Click to Re-Schedule
                </button>
              )} */}
              </ul>
            </div>
          )}
          <div className="d-flex flex-grow-1 tracker-wrapper">
            <InstallationStatusTracker
              type="installation"
              status={installationOrder?.status}
              paymentStatus={installationOrder?.payment_status}
              quoteModeEnabled={quoteModeEnabled}
              organizationId={organizationId || ""}
              className="mb-3 mb-lg-2 w-100"
            />
          </div>
          {Viewmode && (
            <div className="dropdown p-4 d-none d-lg-block">
              <button
                className="btn btn-outline-secondary dropdown-toggle btn-sm br-8 table-cells custom-btn px-3"
                type="button"
                id="orderActionsDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Actions
              </button>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="orderActionsDropdown">
                {
                  status <= 300 && (
                    <Link
                      to={`${baseRoute}/jobs/installationWorkOrder/${installationId}`}
                      state={{ type: "Edit" }}
                      className="dropdown-item text-primary table-cells"
                    >
                      <i className="ri-pencil-fill me-2"></i>Edit
                    </Link>
                  )
                }
                {/* <Link to={""} className="dropdown-item text-primary table-cells">
                  <i className="ri-mail-send-line me-2"></i>Email
                </Link> */}

                {(baseRoute === "/signage" || baseRoute === "/signageteammember") &&
                  quoteModeEnabled &&
                  Number(installationOrder?.status ?? 0) !== INSTALLATION_ORDER_CANCELLED_STATUS_CODE &&
                  // hasProjectIdForSendQuote &&
                   (
                    <li>
                      <button
                        type="button"
                        className="dropdown-item"
                        disabled={orderSummarySending}
                        onClick={() => setEmailRecipientsModal("quote")}
                      >
                        <i className="bi bi-file-earmark-text me-2" />
                        {orderSummarySending ? "Sending…" : "Send Quote"}
                      </button>
                    </li>
                  )}

                <li>
                  <button
                    type="button"
                    className="dropdown-item"
                    onClick={() => handleInstallationOrderSummaryPreviewClick()}
                  >
                    <i className="bi bi-file-earmark-text me-2" />
                    View/Order Summary
                  </button>
                </li>

                {(baseRoute === "/signage" || baseRoute === "/signageteammember") &&
                   installationOrder?.invoice_date && (

                    <li>
                      <button className="dropdown-item" onClick={() => onPreviewInvoice("installation")}>
                        <i className="bi bi-eye me-2" /> View/Download Invoice
                      </button>
                    </li>
                  )}

{/* <li>
                      <button
                        type="button"
                        className="dropdown-item"
                        disabled={downloadInvoiceLoading}
                        onClick={() => void handleDownloadInvoice()}
                      >
                        <i className="bi bi-download me-2" />
                        {downloadInvoiceLoading ? "Downloading…" : "Download Invoice"}
                      </button>
                    </li> */}

{(baseRoute === "/signage" || baseRoute === "/signageteammember")
                  // Number(installationOrder?.status ?? 0) >= 300
                   && !!installationOrder?.invoice_date
                   && Number(installationOrder?.status ?? 0) !== INSTALLATION_ORDER_CANCELLED_STATUS_CODE && (
                  <>
                    <li>
                      <button
                        type="button"
                        className="dropdown-item"
                        disabled={sendInvoiceLoading}
                        onClick={() => setEmailRecipientsModal("invoice")}
                      >
                        <i className="bi bi-send me-2" />
                        {sendInvoiceLoading ? "Sending…" : "Send Invoice"}
                      </button>
                    </li>
                  </>
                  )}

                {/* <button type="button" onClick={handleDownloadInvoice} className="dropdown-item text-primary table-cells">
                  <i className="ri-file-download-line me-2"></i>Download Invoice
                </button> */}
                {/* <li>
                  <button className="dropdown-item" onClick={() => onPreviewInvoice("installation")}>
                    <i className="bi bi-eye me-2" /> Preview Invoice
                  </button>
                </li> */}


                {status >= 100 && status <= 400 && (
                  <button className="dropdown-item text-danger table-cells" style={{ paddingLeft: 12 }} onClick={() => handleInstallationStatus(600)}>
                    <i className="mdi mdi-archive-remove-outline me-2"></i>Cancel Job
                  </button>
                )}
                {/* {(installationOrder?.status === 300 && installationOrder?.payment_info?.length > 0) && (
                  <button className="dropdown-item text-primary table-cells" onClick={() => handleInstallationStatus(400)}>
                    <i className="mdi mdi-truck-fast-outline me-2"></i>In Progress
                  </button>
                )}

                {installationOrder?.status === 400 && (
                  <button className="dropdown-item text-info table-cells" onClick={() => handleInstallationStatus(500)}>
                    <i className="mdi mdi-truck-check-outline me-2"></i> Complete
                  </button>
                )}
                {installationOrder?.status === 100 && (
                  <button className="dropdown-item text-success table-cells" onClick={() => handleInstallationStatus(200)}>
                    <i className="mdi mdi-check-bold me-2"></i> Finalize
                  </button>
                )} */}

                {/* {installationOrder?.status === 200 && (
                <button className="btn btn-primary" onClick={() => handleInstallationStatus(300)}>
                  Click to Schedule
                </button>
              )}

              {installationOrder?.status === 300 && (
                <button className="btn btn-primary" onClick={() => handleInstallationStatus(300)}>
                  Click to Re-Schedule
                </button>
              )} */}
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Hidden render target for PDF capture */}
      {/* <div style={{ position: "absolute", left: -99999, top: 0 }}>
            <div ref={invoiceRef}>
              <OrderInvoice
                order={normalizeInstallationToSalesOrder(installationOrder)}
                customer={null as any}
                leftAddressLabel="Bill to:"
                rightAddressLabel="Install to:"
              />
            </div>
          </div> */}
      <form onSubmit={formik.handleSubmit} className="me-2 me-lg-0">
        <div className="row col-lg-12 card-body shadow-lg pb-4 mb-4 ms-0 p-3">
          <div className="mb-3 d-flex align-items-center justify-content-between gap-3">
            <SectionHeader title="Customer Information" icon="ri-user-3-line" color="#155dfc" size="md" divider />
            {Viewmode ? (
              <RefreshIconButton
                ariaLabel="Refresh customer information"
                title="Refresh customer information"
                onClick={async () => {
                  const documentId = String(installationOrder?._id || installationOrder?.id || "").trim();
                  const membershipId = pickSyncMembershipId(
                    (installationOrder as any)?.customer_membership_id,
                    (installationOrder as any)?.source_membership_id,
                    (installationOrder as any)?.buyer_membership_id
                  );
                  if (token && documentId && membershipId) {
                    try {
                      await syncUserEmailToDocument(token, {
                        membership_id: membershipId,
                        id: documentId,
                        collection_name: "installation",
                      });
                    } catch (syncErr) {
                      safeConsole.warn("sync-user-email-to-document failed:", syncErr);
                    }
                  }
                  await fetchOrderDetails();
                }}
              />
            ) : null}
          </div>
          {/* <div className="col-lg-3 mb-3">
            <label htmlFor="userType" className="form-label table-cells">
              Buyer Type
            </label>
            <input
              type="text"
              className="form-control"
              id="userType"
              name="userType"
              value={formik.values.userType}
              disabled
              readOnly
            />
          </div> */}

          {/* Brokerage Firm Name - Don't show for standalone agent orders (NEW FLOW: comes first) */}
          {formik.values.brokerageFirmName && (
            <div className="col-lg-3 mb-3">
              <label className="table-cells">
                Brokerage Firm
              </label>
              <input
                type="text"
                className="form-control"
                value={formik.values.brokerageFirmName}
                disabled
                readOnly
              />
            </div>
          )}

          {/* Office Name (NEW FLOW: comes after brokerage) */}
          {formik.values.officeName && (
            <div className="col-lg-3 mb-3">
              <label className="table-cells">
                Office
              </label>
              <input
                type="text"
                className="form-control"
                value={formik.values.officeName}
                disabled
                readOnly
              />
            </div>
          )}

          {/* Team Member Name (NEW FLOW: comes after office) */}
          {formik.values.teamMemberName && (
            <div className="col-lg-3 mb-3">
              <label className="table-cells">
                Team Member
              </label>
              <input
                type="text"
                className="form-control"
                value={formik.values.teamMemberName}
                disabled
                readOnly
              />
            </div>
          )}

          {/* Agent Name (NEW FLOW: comes after team member) */}
          {formik.values.agentName && (
            <div className="col-lg-3 mb-3">
              <label className="table-cells">
                Agent
              </label>
              <input
                type="text"
                className="form-control"
                value={formik.values.agentName}
                disabled
                readOnly
              />
            </div>
          )}

          <div className="col-lg-3 mb-3">
            <label htmlFor="userEmail" className="form-label table-cells">
              Email <span className="text-danger">*</span>
            </label>
            <input
              type="email"
              className="form-control"
              id="userEmail"
              name="userEmail"
              placeholder="Enter email"
              value={formik.values.userEmail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              readOnly={Viewmode || !isFieldEditable(installationOrder?.status ?? 0, "userEmail")}
              disabled={Viewmode}
            />
            {formik.touched.userEmail && typeof formik.errors.userEmail === "string" && (
              <div className="text-danger">{formik.errors.userEmail}</div>
            )}
          </div>

          <div className="col-lg-3 mb-3">
            <label htmlFor="userPhone" className="form-label table-cells">
              Phone <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="userPhone"
              name="userPhone"
              placeholder="Enter phone"
              value={formik.values.userPhone}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              readOnly={Viewmode || !isFieldEditable(installationOrder?.status ?? 0, "userPhone")}
              disabled={Viewmode}
            />
            {formik.touched.userPhone && typeof formik.errors.userPhone === "string" && (
              <div className="text-danger">{formik.errors.userPhone}</div>
            )}
          </div>
        </div>
        <div className="d-block d-lg-flex gap-3">
          <div className="col-lg-8">
            <div className="row col-lg-12 card-body shadow-lg mb-4 ms-0 p-3">
              <div className="mb-3">
                <SectionHeader title="Schedule & Assignment" icon="ri-calendar-line" color="#00a63e" size="md" divider />
              </div>
              <div className="col-lg-4 mb-3">
                <label className="form-label table-cells">
                  Scheduled Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="scheduled_date"
                  name="scheduled_date"
                  placeholder="mm/dd/yyyy"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  onFocus={() => {
                    if (!isFieldEditable(installationOrder?.status ?? 0, "InstallationDate")) return;
                    if (toScheduledDateInput(formik.values.scheduled_date)) return;
                    formik.setFieldValue("scheduled_date", new Date().toISOString().split("T")[0]);
                  }}
                  value={toScheduledDateInput(formik.values.scheduled_date)}
                  readOnly={!isFieldEditable(installationOrder?.status ?? 0, "InstallationDate")}
                />
                {formik.submitCount > 0 &&
                  typeof formik.errors.scheduled_date === "string" && (
                    <div className="text-danger d-block">{formik.errors.scheduled_date}</div>
                  )}
              </div>

              {/* Assigned To - Only show when effectiveSignageOrgId is loaded for team members */}
              {(!isSignageTeammember || effectiveSignageOrgId) ? (
                <div className="col-lg-4 mb-3">
                  <label className="form-label table-cells">
                    Assigned To <span className="text-danger">*</span>
                  </label>
                  <AsyncPaginate
                    classNamePrefix="rs"
                    placeholder="Search Assigned To..."
                    loadOptions={loadSignageTeamMemberOptions}
                    value={selectedInstallerOption ? {
                      value: selectedInstallerOption.value,
                      label: selectedInstallerOption.label,
                      firstName: selectedInstallerOption.firstName,
                      lastName: selectedInstallerOption.lastName,
                      email: selectedInstallerOption.email,
                      phone: selectedInstallerOption.phone,
                      membershipId: selectedInstallerOption.membershipId,
                      globalUserId: selectedInstallerOption.globalUserId,
                      organizationId: selectedInstallerOption.organizationId,
                    } : null}
                    onChange={(selected) => {
                      if (selected) {
                        const next = {
                          ...selected,
                          membershipId: selected.membershipId || selected.value,
                          globalUserId: selected.globalUserId,
                          organizationId: selected.organizationId || effectiveSignageOrgId,
                        };
                        setSelectedInstaller(next);
                        setSelectedInstallerOption(next);
                        formik.setFieldValue("installeId", selected.value || "");
                      } else {
                        setSelectedInstaller(null);
                        setSelectedInstallerOption(null);
                        formik.setFieldValue("installeId", "");
                      }
                    }}
                    onBlur={() => formik.setFieldTouched("installeId", true)}
                    additional={{ page: 1 }}
                    defaultOptions
                    debounceTimeout={300}
                    isClearable
                    components={{ DropdownIndicator }}
                    styles={customSelectStyles}
                    isDisabled={!isFieldEditable(installationOrder?.status ?? 0, "Installer")}
                  />
                  {formik.touched.installeId &&
                    typeof formik.errors.installeId === "string" && (
                      <div className="text-danger">{formik.errors.installeId}</div>
                    )}
                </div>
              ) : (
                <div className="col-lg-4 mb-3">
                  <label className="form-label table-cells">
                    Assigned To <span className="text-danger">*</span>
                  </label>
                  <div className="form-control" style={{ display: 'flex', alignItems: 'center', color: '#888' }}>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Loading...
                  </div>
                </div>
              )}

              {/* Jobs Today */}
              <div className="col-lg-4 mb-3">
                <label className="form-label table-headers">Jobs Today</label>
                <input
                  type="number"
                  className="form-control"
                  id="jobs_today"
                  name="jobs_today"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={scheduledJobsCount || formik.values.jobs_today}
                  disabled
                />
                {formik.touched.jobs_today && formik.errors.jobs_today && (
                  <div className="invalid-feedback d-block">{formik.errors.jobs_today}</div>
                )}
              </div>

              {/* Priority */}
              <div className="col-lg-4 mb-3">
                <label className="form-label table-cells">
                  Priority <span className="text-danger">*</span>
                </label>
                <Select
                  id="priority"
                  name="priority"
                  options={priorityOptions}
                  value={
                    priorityOptions.find(
                      (option) => option.value === formik.values.priority
                    ) || null
                  }
                  onChange={(option) => formik.setFieldValue("priority", option?.value || "")}
                  onBlur={() => formik.setFieldTouched("priority", true)}
                  components={{ DropdownIndicator }}
                  styles={customSelectStyles}
                  classNamePrefix="rs"
                  isDisabled={!isFieldEditable(installationOrder?.status ?? 0, "Priority")}
                />
                {formik.touched.priority && typeof formik.errors.priority === "string" && (
                  <div className="text-danger">{formik.errors.priority}</div>
                )}
              </div>
            </div>
            {String(linkedProjectId || "").trim() && hasApprovedMessage ? (
              <div className="row col-lg-12 mb-3 ms-0 p-0">
                {approvedProofCards.map((card) => (
                  <CompactApprovedProofCard
                    key={`approved-proof-v-${card.version}`}
                    version={card.version}
                    files={card.files}
                    approvedBy={card.approvedByName}
                    approvedAt={card.approvedAtLabel}
                    footerBy={card.assignedToName}
                    variant="installation"
                    billingAddress={card.billingAddress}
                    installationAddress={card.installationAddress}
                    shippingName={card.shippingName}
                    shippingDesc={card.shippingDesc}
                    shippingAmountLabel={card.shippingAmountLabel}
                    showOrderSummary={isSignagePortalRoute(location.pathname, baseRoute)}
                    orderSummary={card.orderSummary}
                    onDownloadByFileId={(fileId, fileName) => {
                      void downloadWorkDriveFile(fileId, fileName);
                    }}
                  />
                ))}
              </div>
            ) : null}
            <div className="row col-lg-12 mb-4 card-body shadow-lg mb-4 ms-0 pb-3 p-3">
              <div className="align-items-center d-block d-lg-flex justify-content-between mb-3">
                {/* Left side: Address Information with purple icon */}
                <SectionHeader title="Address Information" icon="ri-map-pin-line" color="#e7000b" size="md" divider className="mb-3 mb-lg-0" />

                {/* Right side: Gate Code with functionality */}
                <div className="d-flex align-items-center gap-3">
                  <label className="table-cells mb-0">Gate Code</label>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="text"
                      id="gatecode"
                      name="gatecode"
                      className="form-control"
                      style={{
                        width: '140px',
                        backgroundColor: formik.values.gateCodeEnabled && (installationOrder?.status ?? 0) < 500 ? '#ffffff' : '#f8f9fa',
                        color: formik.values.gateCodeEnabled && (installationOrder?.status ?? 0) < 500 ? '#495057' : '#6c757d',
                        cursor: formik.values.gateCodeEnabled && (installationOrder?.status ?? 0) < 500 ? 'text' : 'pointer'
                      }}
                      value={formik.values.gatecode}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Enter Gate Code"
                      readOnly={!formik.values.gateCodeEnabled || (installationOrder?.status ?? 0) >= 500}
                      disabled={(installationOrder?.status ?? 0) >= 500}
                      onClick={() => {
                        if (!formik.values.gateCodeEnabled && (installationOrder?.status ?? 0) < 500) {
                          formik.setFieldValue("gateCodeEnabled", true);
                        }
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-primary table-addbutton btn-sm br-8"
                      disabled={!formik.values.gateCodeEnabled || (installationOrder?.status ?? 0) >= 500}
                      onClick={async () => {
                        // Save gate code and disable the field again
                        await handleSaveGateCode();
                        formik.setFieldValue("gateCodeEnabled", false);
                      }}
                    >
                      <i className="ri-save-fill fs-16"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label
                        htmlFor="billingAddressId"
                        className="form-label table-headers"
                      >
                        Billing Address <span className="text-danger">*</span>
                      </label>
                      {isEdit && isFieldEditable(installationOrder?.status ?? 0, "billingAddressId") ? (
                        <Select
                          id="billingAddress"
                          name="billingAddress"
                          options={addressOptions}
                          value={
                            addressOptions?.find(
                              (option) =>
                                String(option.value) ===
                                String(formik.values.billingAddressId || "")
                            ) || null
                          }
                          onChange={(selected: any) => {
                            // console.log("Selected Billing Address:", selected);
                            formik.setFieldValue("billingAddressId", selected?.value);
                            const isOffice = !selectedOfficeAgent && !selectedAgent && selectedOffice;
                            const selectedId = String(selected?.value || "");
                            const selectedAddress =
                              addressOptions?.find(
                                (addr) => String(addr.value) === selectedId
                              ) ||
                              addressObjects?.find(
                                (addr) =>
                                  resolveSalesOrderAddressId(addr) === selectedId
                              );
                            // console.log("OfficeBillingAddress In Select:", selectedAddress);

                            if (isOffice) {
                              setSelectedOfficeBillingAddress(selectedAddress || null);
                            } else {
                              setSelectedBillingAddress(selectedAddress || null);
                            }

                            // If billing address is changed in edit mode, set isSameAsBilling to false
                            if (isEdit && selected) {
                              formik.setFieldValue("isSameAsBilling", false);
                            }
                          }}
                          components={{ DropdownIndicator }}
                          styles={customSelectStyles}
                          classNamePrefix="rs"
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control"
                          value={(() => {
                            const addr = installationOrder?.billing_address?.address_details;
                            if (!addr) return '';
                            const parts = [
                              addr.addressLine1,
                              addr.addressLine2,
                              addr.city,
                              addr.state,
                              addr.zip
                            ].filter(Boolean);
                            return parts.join(', ');
                          })()}
                          readOnly
                        />
                      )}
                      {formik.touched.billingAddressId &&
                        typeof formik.errors.billingAddressId === "string" && (
                          <div className="text-danger">{formik.errors.billingAddressId}</div>
                        )}
                    </div>
                  </div>

                  {/* {formik.values.isSameAsBilling === true ? null : ( */}
                  <div className="col-lg-6 mb-3">
                    <div className="">
                      <label
                        htmlFor="installationAddressId"
                        className="form-label table-headers"
                      >
                        Installation Address <span className="text-danger">*</span>
                      </label>
                      {isEdit && isFieldEditable(installationOrder?.status ?? 0, "installationAddressId") ? (
                        <AddressAutocomplete
                          id="installationAddressId"
                          name="installationAddressId"
                          value={formik.values.installationAddressId}
                          onChange={(v) => formik.setFieldValue("installationAddressId", v)}
                          onSelect={(picked) => {
                            const installation_address = `${picked.addressLine1}, ${picked.city}, ${picked.state}, ${picked.zipcode}`;

                            const addressDetails: Address = {
                              _id: "",
                              label: installation_address,
                              addressLine1: picked.addressLine1,
                              addressLine2: "",
                              country: picked.country,
                              county: picked.city,
                              city: picked.city,
                              state: picked.state,
                              zip: picked.zipcode,
                              cityCode: picked.cityCode,
                              stateCode: picked.stateCode,
                              countryCode: picked.countryCode,
                              latitude: picked.latitude,
                              longitude: picked.longitude,
                              phone: "",
                            };

                            const newAddresses: Addresses = {
                              _id: "",
                              user_id: "",
                              user_type: "",
                              label: installation_address,
                              first_name: "",
                              last_name: "",
                              company: "",
                              default_address: false,
                              address_details: addressDetails,
                              created_by: {
                                id: userId || "",
                                name: userName || "",
                              },
                              updated_by: {
                                id: userId || "",
                                name: userName || "",
                              },
                            };

                            setInstallationAddress(newAddresses);
                            formik.setFieldValue('installationAddressId', installation_address);
                            formik.setFieldValue("isSameAsBilling", false);
                            formik.setFieldValue("installation_cost", installationCostRef.current ?? installationCost ?? 0, false);
                            formik.setFieldTouched("installationAddressId", true, false);
                            triggerRecomputeWithRef.current?.();
                          }}
                          className={`form-control table-cells ${formik.touched.installationAddressId && formik.errors.installationAddressId ? "is-invalid" : ""}`}
                          placeholder="Enter installation address"
                          error={formik.touched.installationAddressId && formik.errors.installationAddressId ? (formik.errors.installationAddressId as string) : undefined}
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control"
                          id="installationAddressId"
                          name="installationAddressId"
                          value={(() => {
                            const addr = installationOrder?.installation_details?.installation_address?.address_details;
                            if (!addr) return '';
                            const parts = [
                              addr.addressLine1,
                              addr.addressLine2,
                              addr.city,
                              addr.state,
                              addr.zip
                            ].filter(Boolean);
                            return parts.join(', ');
                          })()}
                          readOnly
                        />
                      )}
                    </div>
                  </div>
                  {/* )} */}

                  {/* <div className="col-lg-2">
                        <p>&nbsp;</p>
                        <i
                          className="ri-search-line fs-3 text-bg-info"
                          style={{ cursor: "pointer" }}
                          title={`${isMarkerDraggable ? "Disable Marker Drag" : "Enable Marker Drag"}`}
                          onClick={() => {
                            const newValue = !isMarkerDraggable;
                            setIsMarkerDraggable(newValue);
                            showError(
                              newValue
                                ? "You can now move the marker on the map."
                                : "Marker dragging disabled."
                            );
                          }}


                        ></i>
                      </div> */}
                </div>
              </div>
              <div className="col-lg-12">
                <div style={mapContainerStyle}>
                  <div style={mapContainerStyle}>
                    <GoogleMap
                      mapContainerStyle={mapContainerStyle}
                      zoom={10}
                      center={selectedLocation || center}
                    // onClick={handleMapClick}
                    >
                      {selectedLocation && <Marker
                        position={selectedLocation}
                        draggable={isEdit && isFieldEditable(installationOrder?.status ?? 0, "installationAddressId")}
                        onDragEnd={handleMarkerDragEnd}
                      />}
                    </GoogleMap>
                  </div>
                  {formik.touched.location && formik.errors.location && (
                    <div className="text-danger">{formik.errors.location}</div>
                  )}
                </div>
              </div>
            </div>
            {/* Post Type & Sign Configuration — view: filled slots only; edit: all slots like Add Installation */}
            {installationOrder?.installation_post?.post_type_id ? (
              Viewmode ? (
                <PostTypeSignConfiguration
                  type="view"
                  vendorId={pickerSignageCompanyId}
                  token={token || ""}
                  viewModePostTypeId={installationOrder?.installation_post?.post_type_id}
                  viewModeVendorId={pickerSignageCompanyId}
                  viewModeInstallationPost={installationOrder?.installation_post ?? undefined}
                  viewModeLineItems={viewModeLineItemsForPost}
                />
              ) : (
                <PostTypeSignConfiguration
                  type="edit"
                  vendorId={pickerSignageCompanyId}
                  token={token || ""}
                  postTypeOrderContext={postTypeOrderContext}
                  pickerUserType={pickerUserType}
                  pickerUserId={pickerUserId}
                  pickerEndUserId={pickerEndUserId}
                  pickerSignageCompanyId={pickerSignageCompanyId}
                  viewModePostTypeId={installationOrder?.installation_post?.post_type_id}
                  viewModeVendorId={pickerSignageCompanyId}
                  viewModeInstallationPost={installationOrder?.installation_post ?? undefined}
                  editModeHydrationProducts={editModeHydrationProducts}
                  selectedProductIds={selectedProducts.map((p) => String(p.product_id ?? "")).filter(Boolean)}
                  selectedStockLines={selectedStockLines}
                  baselineStockLines={baselineStockLines}
                  accessoryCount={selectedProducts
                    .filter((p) => p.is_accessory || p.is_accessories)
                    .reduce((sum, p) => sum + (Number(p.quantity) || 0), 0)}
                  onClearSlotReady={(api) => { postTypeConfigRef.current = api; }}
                  onInstallationPostChange={setInstallationPost}
                  onSlotDuplicateProduct={() =>
                    showError("This product is already selected. You cannot assign the same product to multiple slots.")
                  }
                  onSlotRemoved={(slotKey, slotId) => {
                    setSelectedProducts((prev) =>
                      prev.filter(
                        (p) =>
                          p.slotKey !== slotKey &&
                          String(p.slot_id || "").trim() !== String(slotId || "").trim()
                      )
                    );
                  }}
                  onSlotProductSelect={handleSlotProductSelect}
                  onCustomItemAdd={
                    customProductSettingEnabled ? handleCustomItemAdd : undefined
                  }
                />
              )
            ) : null}
            <div className="row col-lg-12 mb-lg-3 card-body shadow-lg mb-1 ms-0 p-3">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex">
                  <span
                    aria-hidden="true"
                    className="image-icons"
                    style={{
                      backgroundColor: "#9810fa",
                      WebkitMaskImage: `url(${ProductSelection})`,
                      maskImage: `url(${ProductSelection})`,
                    }}
                  />
                  <SectionHeader title="Product Selection" icon="" variant="success" size="md" divider />
                </div>
                {!Viewmode && !isEdit && (
                  <button type="button" className="btn btn-primary table-addbutton br-8" onClick={() => setPickerOpen(true)} disabled={(installationOrder?.status ?? 0) > 200}>
                    <i className="ri-add-line me-1"></i> Add Product
                  </button>
                )}
              </div>
              <div className="col-lg-12">
                {/* Replace table with card-based inputs like Add Installation */}
                {(() => {
                  const visibleProducts = selectedProducts
                    ?.map((item, index) => ({ item, index }))
                    ?.filter(({ item }) => item.inventory_type !== "rotational" && item.inventory_type !== "") || [];
                  const inventoryProducts = visibleProducts.filter(({ item }) => !isPurchasedInstallationLine(item));
                  const purchasedProducts = visibleProducts.filter(({ item }) => isPurchasedInstallationLine(item));
                  const regularPurchasedProducts = purchasedProducts.filter(({ item }) => {
                    const inventorySource = String(item?.inventory_type || item?.inventory_source || "")
                      .trim()
                      .toLowerCase();
                    return inventorySource !== "custom";
                  });
                  const customPurchasedProducts = purchasedProducts.filter(({ item }) => {
                    const inventorySource = String(item?.inventory_type || item?.inventory_source || "")
                      .trim()
                      .toLowerCase();
                    return inventorySource === "custom";
                  });
                  const renderProductCard = (item: any, index: number, displayIndex: number, isPurchasedLine: boolean) => {
                    const currentAlloc = (allocatedUnits[item.product_id] || []).length;
                    const persistedAlloc = Number(item.allocatedCount || 0);
                    const totalAllocatedForRow = Math.max(currentAlloc, persistedAlloc);
                    const remaining = Math.max(item.quantity - totalAllocatedForRow, 0);
                    const qtyNum = Math.max(1, Number(item.quantity) || 0);
                    const priceKey = keyForInstallationProduct(item);
                    const resolvedLine = isPurchasedLine ? getResolvedLineItem(item) : undefined;
                    const displayUnitCost = isPurchasedLine
                      ? getInstallationLineUnitCostDisplay(
                          priceKey,
                          item,
                          manualUnitPriceMap,
                          resolvedLine
                        )
                      : 0;
                    const rowDiscount = isPurchasedLine
                      ? getInstallationLineDiscountDisplay(
                          priceKey,
                          item,
                          manualUnitPriceMap,
                          resolvedLine
                        )
                      : 0;
                    const isCustomLine =
                      String(item?.inventory_type || item?.inventory_source || "")
                        .trim()
                        .toLowerCase() === "custom";
                    const canRemoveProduct = !Viewmode && (!isEdit || isCustomLine);
                    return (
                      <div key={item.product_id} className="mb-3 p-3 rounded-3 border shadow-sm bg-gray-50">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h5 className="mb-0">Product #{displayIndex}</h5>
                          <div className="d-flex align-items-center gap-2">
                          {canRemoveProduct && (
                            <button
                              type="button"
                              className="btn btn-link text-danger p-0"
                              title="Remove"
                              onClick={() =>
                                isCustomLine
                                  ? removeCustomProduct(item)
                                  : removeRow(item.product_id)
                              }
                              disabled={(installationOrder?.status ?? 0) > 200}
                            >
                              <i className="ri-delete-bin-line fs-5"></i>
                            </button>
                          )}
                          </div>
                        </div>
                        <div className="row g-3">
                          {/* Top Row */}
                          <div className="col-lg-12 pt-3 row">
                            <div className="col-lg-6 mb-3 mb-lg-0">
                              <label className="table-cells">Product Name</label>
                              <input type="text" className="form-control" value={item.name || ""} readOnly disabled />
                            </div>
                            <div className="col-lg-3 mb-3 mb-lg-0">
                              <label className="table-cells">SKU/Product Code</label>
                              <input
                                type="text"
                                className="form-control"
                                value={displayInstallationLineItemSku(item)}
                                readOnly
                                disabled
                              />
                            </div>
                            {isEdit && shouldShowAvailableQty(item) && (
                              <div className="col-lg-3 mb-3 mb-lg-0">
                                <label className="table-cells">Available Qty</label>
                                <input type="number" className="form-control" value={Number(item.availableqty ?? 0)} readOnly disabled />
                              </div>
                            )}
                            <div className={`col-lg-3 mb-3 mb-lg-0 ${isEdit ? "mt-3" : ""}`}>
                              <label className="table-cells">QTY</label>
                              <input
                                type="number"
                                className="form-control"
                                min={0}
                                placeholder="0"
                                value={item.quantity || ''}
                                onChange={(e) => {
                                  if (Viewmode) return;
                                  const rawValue = e.target.value;
                                  const qty = rawValue === '' ? '' : Number(rawValue);
                                  const updated = [...selectedProducts];
                                  updated[index].quantity = qty;
                                  setSelectedProducts(updated);
                                }}
                                onBlur={(e) => {
                                  if (Viewmode) return;
                                  const currentValue = e.target.value;
                                  if (currentValue === '' || Number(currentValue) <= 0) {
                                    const updated = [...selectedProducts];
                                    updated[index].quantity = 1;
                                    setSelectedProducts(updated);
                                  }
                                }}
                                onWheel={(e) => e.currentTarget.blur()}
                                disabled={Viewmode}
                                readOnly={Viewmode}
                              />
                            </div>

                            <div className={`col-lg-3 mb-3 mb-lg-0 ${isEdit ? "mt-3" : "mt-3"}`}>
                              <label className="table-cells">Unit Cost</label>
                              {isPurchasedLine && !Viewmode ? (
                                <input
                                  type="number"
                                  className="form-control text-center"
                                  placeholder="0"
                                  value={(() => {
                                    const price = displayUnitCost;
                                    return price === 0 ? "" : price;
                                  })()}
                                  onChange={(e) => {
                                    const key = keyForInstallationProduct(item);
                                    const raw = e.target.value;
                                    const price = raw === "" ? 0 : Number(raw);
                                    setManualUnitPriceMap((prev) => ({
                                      ...prev,
                                      [key]: Number.isFinite(price) ? price : 0,
                                    }));
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "-" || e.key === "e" || e.key === "E") e.preventDefault();
                                  }}
                                  disabled
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control text-center"
                                  value={isPurchasedLine ? displayUnitCost.toFixed(2) : "-"}
                                  readOnly
                                  disabled
                                />
                              )}
                            </div>

                            {isPurchasedLine && (
                              <div className={`col-lg-3 mb-3 mt-3 mb-lg-0 ${isEdit ? "mt-3" : ""}`}>
                                <label className="table-cells">Discount</label>
                                <div className="d-flex align-items-center flex-wrap gap-2 py-1">
                                  <DiscountAmountDisplay amount={rowDiscount} />
                                </div>
                              </div>
                            )}

                            <div className="col-lg-6 mb-3 mb-lg-0 mt-3">
                              <label className="table-cells">Production Status</label>
                              <div className="d-flex align-items-center gap-2 col-12">
                                <Select
                                  id={`product_status_${index}`}
                                  name={`product_status_${index}`}
                                  options={[
                                    { value: "not_started", label: "Not Started" },
                                    { value: "in_queue", label: "In Queue" },
                                    { value: "in_production", label: "In Production" },
                                    { value: "quality_check", label: "Quality Check" },
                                    { value: "ready_for_pickup", label: "Ready For Pickup" },
                                    { value: "ready_for_installation", label: "Ready For Installation" },
                                  ]}
                                  value={item.productionStatus ? { value: item.productionStatus, label: item.productionStatus.replace(/_/g, " ") } : null}
                                  onChange={(option) => {
                                    const updated = [...selectedProducts];
                                    updated[index].productionStatus = option?.value || "";
                                    setSelectedProducts(updated);
                                  }}
                                  isDisabled={installationOrder.status === 400 || installationOrder.status === 500}
                                  components={{ DropdownIndicator }}
                                  styles={customSelectStyles}
                                  classNamePrefix="rs"
                                  className="col-9"
                                />
                                {item.is_production !== true && (
                                  <button className="btn btn-primary table-addbutton p-2 br-8" onClick={() => updateProductionStatus(selectedProducts[index].product_id, selectedProducts[index].variant_id, selectedProducts[index].productionStatus)} disabled={installationOrder.status === 400 || installationOrder.status === 500}>Update</button>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-3 mb-3 mb-lg-0 mt-3">
                              <label className="table-cells">Product Location</label>
                              <div className="d-flex align-items-center gap-2 col-12">
                                <StatusBadge status={(item.product_location_status || item.product_current_status)?.replace(/_/g, " ") || "-"} />
                              </div>
                            </div>

                            <div className={`mb-3 mb-lg-0 mt-3 ${isEdit ? "col-lg-9" : "col-lg-9"}`}>
                              <label className="table-cells">Bin Location</label>
                              <Select
                                id={`bin_location_${index}`}
                                name={`bin_location_${index}`}
                                options={(() => {
                                  const binOptions: Array<{ value: string; label: string }> = [];

                                  // First try to get locations from storage_locations (existing products)
                                  const storageLocation = item.storage_locations?.[0];
                                  if (storageLocation?.location && Array.isArray(storageLocation.location) && storageLocation.location.length > 0) {
                                    storageLocation.location.forEach((loc: any, locIndex: number) => {
                                      const warehouseName = loc.warehouse_name || '';
                                      const zoneName = loc.zone_name || '';
                                      const rackName = loc.rack_name || '';
                                      const binName = loc.bin_name || '';
                                      const qty = loc.quantity || 0;

                                      binOptions.push({
                                        value: `${loc.bin_id || locIndex}`,
                                        label: `${warehouseName} > ${zoneName} > ${rackName} > ${binName}  - (Deduct Qty: ${qty})`
                                      });
                                    });
                                  }
                                  // Then try to get locations from direct location array (newly added products)
                                  else if (item.location && Array.isArray(item.location) && item.location.length > 0) {
                                    item.location.forEach((loc: any, locIndex: number) => {
                                      const warehouseName = loc.warehouse_name || '';
                                      const zoneName = loc.zone_name || '';
                                      const rackName = loc.rack_name || '';
                                      const binName = loc.bin_name || '';
                                      const qty = loc.quantity || 0;

                                      binOptions.push({
                                        value: `${loc.bin_id || locIndex}`,
                                        label: `${warehouseName} > ${zoneName} > ${rackName} > ${binName}  - (Deduct Qty: ${qty})`
                                      });
                                    });
                                  }

                                  // If no locations found, add a "No location assigned" option
                                  if (binOptions.length === 0) {
                                    binOptions.push({
                                      value: 'no_location',
                                      label: 'No location assigned'
                                    });
                                  }

                                  return binOptions;
                                })()}
                                value={(() => {
                                  const storageLocation = item.storage_locations?.[0];
                                  if (storageLocation?.location?.[0]) {
                                    const loc = storageLocation.location[0];
                                    const qty = loc.quantity || 0;
                                    return {
                                      value: loc.bin_id || '0',
                                      label: `${loc.warehouse_name || ''} > ${loc.zone_name || ''} > ${loc.rack_name || ''} > ${loc.bin_name || ''}  - (Deduct Qty: ${qty})`
                                    };
                                  }

                                  if (item.location && item.location.length > 0) {
                                    const loc = item.location[0];
                                    const qty = loc.quantity || 0;
                                    return {
                                      value: loc.bin_id || '0',
                                      label: `${loc.warehouse_name || ''} > ${loc.zone_name || ''} > ${loc.rack_name || ''} > ${loc.bin_name || ''}  - (Deduct Qty: ${qty})`
                                    };
                                  }

                                  return {
                                    value: 'no_location',
                                    label: 'No location assigned'
                                  };
                                })()}
                                isDisabled={Viewmode}
                                components={{ DropdownIndicator }}
                                styles={customSelectStyles}
                                classNamePrefix="rs"
                                placeholder="Select bin location"
                              />
                            </div>
                          </div>

                          {(() => {
                            const rowData = resolveSelectedLineItemForDisplay(item, selectedProducts);
                            const custBlock = getCustomizationsBlockFromLineItem(rowData);
                            const custRows = getVisibleCustomizationFieldsForDisplay(custBlock);
                            if (custRows.length === 0) return null;
                            return (
                              <div className="col-lg-12 mt-2">
                                <div className="fw-medium table-cells small mb-2 mt-1">
                                  customizations:
                                </div>
                                <div className="row g-2 g-lg-3">
                                  {custRows.map((field, idx) => (
                                    <div
                                      className="col-12 col-sm-6 col-lg-6"
                                      key={`${String(rowData.product_id)}-${String(rowData.slot_id ?? "")}-cust-${String(field.field_name || idx)}`}
                                    >
                                      <div className="px-3 py-2 small text-break">
                                        <span className="fs-14 fw-medium">{field.field_name || "Field"}</span>
                                        <span className="text-muted"> : </span>
                                        {(() => {
                                          const v = String(field.value ?? "").trim();
                                          const ft = String(field.field_type || "").toLowerCase();
                                          const isFile = ft === "file" || ft === "image";
                                          const m = (customizationImageUrlMap as Record<string, string>) || {};
                                          const src =
                                            isFile && /^[a-f0-9]{24}$/i.test(v)
                                              ? m[v] || getImageSrc(v, m) || ""
                                              : "";
                                          if (src) {
                                            return (
                                              <img
                                                src={src}
                                                alt=""
                                                style={{
                                                  maxHeight: 120,
                                                  maxWidth: "100%",
                                                  borderRadius: 8,
                                                  border: "1px solid #dee2e6",
                                                  display: "block",
                                                  marginTop: 4,
                                                }}
                                              />
                                            );
                                          }
                                          return <span className="fs-14">{String(field.value ?? "")}</span>;
                                        })()}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            );
                          })()}

                          {(() => {
                            const rowData = resolveSelectedLineItemForDisplay(item, selectedProducts);
                            const infoRows = getVisibleCustomInformationRowsForDisplay(rowData);
                            if (infoRows.length === 0) return null;
                            return (
                              <div className="col-lg-12 mt-2">
                                <div className="row g-2 g-lg-3">
                                  {infoRows.map(({ key, value }, idx) => (
                                    <div
                                      className="col-12 col-sm-6 col-lg-6"
                                      key={`${String(rowData.product_id)}-${String(rowData.slot_id ?? "")}-ci-${key || idx}`}
                                    >
                                      <div className="px-3 py-2 small text-break">
                                        <span className="fs-14 fw-medium">{key || "Field"}</span>
                                        <span className="text-muted"> : </span>
                                        <span className="fs-14">{value}</span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            );
                          })()}

                          {/* Allocate Button Row */}
                          <div className="col-lg-12 pt-3 row">
                            <div className="col-lg-12 d-flex mb-3 mb-lg-0">
                              {Viewmode && (installationOrder?.status === 200 || installationOrder?.status === 300) && (
                                <button type="button" className="btn btn-primary table-addbutton br-8" disabled={remaining <= 0} onClick={() => {
                                  setLinkedProductIdContext(item.product_id);
                                  setSelectedProduct(null);
                                  setSelectedWarehouse(null);
                                  setAvailableSerializedUnits([]);
                                  // Clear previous allocations for this specific linked product
                                  setAllocatedUnits((prev) => {
                                    const newState = { ...prev };
                                    delete newState[item.product_id];
                                    return newState;
                                  });
                                  fetchRotationalPoolProducts();
                                  setShowAllocateModal(true);
                                }}>Allocate</button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  };

                  if (visibleProducts.length === 0) {
                    return (
                      <div className="text-center text-muted py-4 border rounded-3">
                        No products added yet.
                      </div>
                    );
                  }

                  return (
                    <>
                      {inventoryProducts.length > 0 && (
                        <>
                          <div className="d-flex align-items-center gap-2 mb-3">
                            <span className="fw-semibold table-cells">Inventory Products</span>
                          </div>
                          {inventoryProducts.map(({ item, index }, i) =>
                            renderProductCard(item, index, i + 1, false)
                          )}
                        </>
                      )}
                      {purchasedProducts.length > 0 && (
                        <>
                          {inventoryProducts.length > 0 && <hr className="my-4" />}
                          <div className="d-flex align-items-center gap-2 mb-3">
                            <span className="fw-semibold table-cells">Purchased Products</span>
                          </div>
                          {regularPurchasedProducts.map(({ item, index }, i) =>
                            renderProductCard(item, index, inventoryProducts.length + i + 1, true)
                          )}
                          {customPurchasedProducts.length > 0 && (
                            <div className={`d-flex align-items-center gap-2 mb-3 ${regularPurchasedProducts.length > 0 ? "mt-4" : ""}`}>
                              <span className="fw-semibold table-cells">Custom Products</span>
                            </div>
                          )}
                          {customPurchasedProducts.map(({ item, index }, i) =>
                            renderProductCard(
                              item,
                              index,
                              inventoryProducts.length + regularPurchasedProducts.length + i + 1,
                              true
                            )
                          )}
                        </>
                      )}
                    </>
                  );
                })()}
              </div>
            </div>
            {pickerOpen && pickerUserType && pickerUserId && token ? (
              <RealtorProductPicker
                open={pickerOpen}
                onClose={() => setPickerOpen(false)}
                userType={pickerUserType}
                userId={pickerUserId}
                signageCompanyId={pickerSignageCompanyId}
                token={token}
                onAdd={handleAddFromPicker}
              />
            ) : null}
            {showAddressForm && (

              <AddressFormModal
                isOpen={true}
                onClose={() => {
                  setShowAddressForm(false);
                }}
                token={token || ""}
                owner={
                  selectedOfficeAgent ||
                  selectedAgent ||
                  selectedTeamMemberOption ||
                  (sessionMembershipId ? { value: sessionMembershipId, label: userName || "" } : null)
                }
                membershipId={resolveMembershipAddressesRouteId({
                  selectedOfficeAgent,
                  selectedAgent,
                  selectedTeamMember: selectedTeamMemberOption,
                  sessionMembershipId,
                })}
                officeId={selectedOffice?.value || null}
                createOnOffice={
                  !!selectedOffice &&
                  !selectedOfficeAgent &&
                  !selectedAgent
                }
                useType="billing"
                prefill={{
                  label_of_address: formik?.values?.label_of_address || "",
                  firstName: formik?.values?.firstName || "",
                  lastName: formik?.values?.lastName || "",
                  company: formik?.values?.company || "",
                  phone: formik?.values?.phone || "",
                  addressLine1: formik?.values?.addressLine1 || "",
                  addressLine2: formik?.values?.addressLine2 || "",
                  city: formik?.values?.city || "",
                  state: formik?.values?.state || "",
                  zipcode: formik?.values?.zipcode || "",
                  country: formik?.values?.country || "",
                }}
                onCreated={(createdRaw, option, useType) => {
                  // setAddressObjects((prev) => [createdRaw, ...(prev || [])]);
                  setAddressObjects((prev) => [createdRaw, ...(prev || [])]);  // correct

                  formik.setFieldValue(
                    useType === "billing" ? "billingAddressId" : "shippingAddressId",
                    option.value
                  );
                  const isOffice =
                    !!selectedOffice &&
                    !selectedOfficeAgent &&
                    !selectedAgent;


                  if (useType === "billing") {
                    if (isOffice) {
                      setSelectedOfficeBillingAddress(createdRaw);
                    } else {
                      setSelectedBillingAddress(createdRaw?.address_details || null);
                    }
                  } else {
                    if (isOffice) {
                      setInstallationAddress(createdRaw);
                    } else {
                      setInstallationAddress(createdRaw?.address_details || null);
                    }
                  }

                  // 4) Mirror to shipping if same-as-billing is checked
                  if (useType === "billing" && formik.values.isSameAsBilling) {
                    formik.setFieldValue("shippingAddressId", option.value);
                    if (isOffice) {
                      setInstallationAddress(createdRaw);
                    } else {
                      setInstallationAddress(createdRaw?.address_details || null);
                    }
                  }
                }}
                afterCreateRefresh={async () => {
                  await fetchAddresses();
                }}
              />
            )}
            <div className="row col-lg-12 mb-3">
              <div className="col-lg-6 mb-3 mb-lg-0 pe-0">
                <Instructions
                  title="Instructions"
                  mode="instructions_files"
                  loginType="signage"
                  instructions={instructions}
                  attachments={instructionAttachments}
                  orderDocumentId={String(
                    installationOrder?._id || installationOrder?.id || installationId || ""
                  )}
                  collectionName="installation"
                  placeholder="Add instructions here"
                  rows={4}
                  onSave={handleSaveInstructionsOnly}
                  onAfterFilesUploaded={fetchOrderDetails}
                  className="mb-3"
                  iconColor="#f54a00"
                  iconBackground="#EAF7F1"
                />
              </div>
              <div className="align-items-center card-body col-lg-5 justify-content-end ms-0 ms-2 ms-lg-0 ms-lg-5 offset-1 p-4 shadow-lg">
                <div className="align-items-center d-flex mb-3">
                  <span
                    aria-hidden="true"
                    className="image-icons"
                    style={{
                      backgroundColor: "#00a63e",
                      WebkitMaskImage: `url(${Doller})`,
                      maskImage: `url(${Doller})`,
                    }}
                  />
                  <SectionHeader title="Cost Breakdown" icon="" color="" size="lg" divider />
                </div>

                {!Viewmode && (Number(installationOrder?.status ?? 0) <= 200) && (
                  <OrderDiscountCodeField
                    className="mb-2"
                    value={couponInput}
                    appliedCode={discountDisplay.code}
                    discountAmount={discountDisplay.amount}
                    voucherApplied={
                      discountDisplay.amount > 0 && Boolean(discountDisplay.code.trim())
                    }
                    disabled={isRecomputing}
                    error={couponResolveError}
                    onChange={setCouponInput}
                    onApply={(code) => {
                      void applyDiscountCode(code);
                    }}
                    onClear={() => {
                      void clearDiscountCode();
                    }}
                  />
                )}
                {zeroOrNegativeMsg && <div className="text-danger mt-2">{zeroOrNegativeMsg}</div>}


                <div className="d-flex justify-content-between align-items-center py-2">
                  <span className="fw-medium">Units Purchased:</span>
                  <span className="fw-semibold">{unitsPurchased}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center py-2">
                  <span className="fw-medium">Total Units:</span>
                  <span className="fw-semibold">{totalUnits}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center py-2">
                  <span className="fw-medium">Installation Cost:</span>
                  {isEditingInstallationCost ? (
                    <div className="d-flex align-items-center gap-2 flex-shrink-0">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        style={{ width: "100px" }}
                        value={manualInstallationCost}
                        onChange={(e) => setManualInstallationCost(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleSaveInstallationCost();
                          if (e.key === "Escape") handleCancelEditInstallationCost();
                        }}
                        autoFocus
                      />
                      <button
                        type="button"
                        className="btn btn-sm export-button br-8"
                        onClick={handleSaveInstallationCost}
                        title="Save installation cost"
                      >
                        <i className="ri-check-line fs-14" />
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm table-addbutton br-8"
                        onClick={handleCancelEditInstallationCost}
                        title="Cancel"
                      >
                        <i className="ri-close-line fs-14" />
                      </button>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center gap-2 flex-shrink-0">
                      <span className="fw-semibold">${Number(installationCost || 0).toFixed(2)}</span>
                      {isEdit && (
                        <button
                          type="button"
                          className="btn btn-sm table-addbutton br-8"
                          onClick={handleEditInstallationCost}
                          title="Edit installation cost"
                          style={{ lineHeight: 1 }}
                        >
                          <i className="ri-edit-line" />
                        </button>
                      )}
                    </div>
                  )}
                </div>
                <div className="d-flex justify-content-between align-items-center py-2">
                  <span className="fw-medium">Units Cost:</span>
                  <span className="fw-semibold">
                    ${Number(displayUnitsCost || 0).toFixed(2)}
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center py-2">
                  <span className="fw-medium">Sub-total:</span>
                  <span className="fw-semibold">
                    ${(Number(installationCost || 0) + Number(displayUnitsCost || 0)).toFixed(2)}
                  </span>
                </div>

                {showCostBreakdownDiscount && (
                  <div className="d-flex justify-content-between align-items-center py-2">
                    <span className="fw-medium" style={{ color: "#00a63e" }}>
                      Discount ({costBreakdownDiscountCode || "—"}):
                    </span>
                    <span className="fw-semibold text-success" style={{ color: "#00a63e" }}>
                      -${costBreakdownDiscount.amount.toFixed(2)}
                    </span>
                  </div>
                )}

                <div className="d-flex justify-content-between align-items-center py-2">
                  {(() => {
                    const { labelText, tooltip } = buildSpecialFeeCostBreakdownDisplay(selectedSpecialFees);
                    return (
                      <>
                        <span className="fw-medium me-2" style={{ minWidth: 0 }} title={tooltip}>
                          {labelText}:
                        </span>
                        <span className="fw-semibold flex-shrink-0">
                          ${Number(formik.values.totals.specialfee_subtotal || 0).toFixed(2)}
                        </span>
                      </>
                    );
                  })()}
                </div>

                <div className="py-1">
                  <div className="d-flex justify-content-between align-items-center">
                    <button
                      type="button"
                      onClick={() => setShowTaxDetails(v => !v)}
                      className="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center"
                      aria-expanded={showTaxDetails}
                      aria-controls="tax-breakdown"
                    >
                      {/* <i className={`bi ${showTaxDetails ? "bi-chevron-down" : "bi-chevron-right"} me-1`} /> */}
                      <span className="order-card-title">Tax :</span>
                    </button>
                    <span className="order-card-cells">
                      <span>${resolvedTaxTotal.toFixed(2)}</span>
                    </span>
                  </div>

                  {/* {showTaxDetails && (
                    <div id="tax-breakdown" className="border rounded-3 p-2 bg-light mt-1">
                      <div className="d-flex justify-content-between small mb-1">
                        <span>Installation Tax</span>
                        <span className="order-card-cells">
                          ${Number(formik.values.totals.installation_tax_amount || 0).toFixed(2)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between small">
                        <span>Special Fee Tax</span>
                        <span className="order-card-cells">
                          ${Number(formik.values.totals.specialfee_tax_amount || 0).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  )} */}
                </div>


                <hr className="my-3" />

                <div className="d-flex justify-content-between align-items-center py-2">
                  <span className="fw-bold fs-5">Total Amount:</span>
                  <span className="fw-bold fs-5">${Number(TotalAmount).toFixed(2)}</span>
                </div>

                <hr className="my-3" />

                <div className="d-flex justify-content-between align-items-center py-2">
                  <span className="fw-medium">Already Paid:</span>
                  <span className="fw-semibold">${totalPaid.toFixed(2)}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center py-2">
                  <span className="fw-medium">Remaining Balance:</span>
                  <span className="fw-semibold">
                    {installationOrder?.payment_status === "Overpaid"
                      ? `+$${Math.abs(remaingamount).toFixed(2)}`
                      : `$${remaingamount.toFixed(2)}`
                    }
                  </span>
                </div>

              </div>
              {/* { installationOrder?.status !== 600 && (
                mode === "view" &&
                taxType === "taxcloud" &&
                installationOrder?.tax_status !== "complete" && (
                  <div className="mt-3 d-flex gap-2">
                    <Button
                      onClick={handleGetLiveTax}
                      disabled={liveTaxLoading}
                      className="btn btn-primary table-addbutton br-8"
                    >
                      {liveTaxLoading ? "Getting Live Tax…" : "Get Live Tax"}
                    </Button>

                    {installationOrder?.tax_status === "draft" && (
                      <Button className="export-button border-0" onClick={handleLiveTaxNext}>
                        Report Live Taxes
                      </Button>
                    )}
                  </div>
                )
              )} */}


              {/* <TaxCloudButtonsV2
  kind="installation"
  token={token!}
  supplierId={supplierId}                                       // ✅ V2 name (was userId)
  orderNumber={String(installationOrder?.order_number || "")}   // ✅ V2 name (was orderId)
  destination={destinationAddr}

  // Not used for install/removal but OK to keep:
  products={[]}

  // ✅ let install/removal upsert use your SKU as the product itemId
  productSkus={productSkus}

  // Optional: you can omit fees for install/removal (the helper creates one "Special Fee" line)
  // fees={[]}

  manualRatePct={0}

  // ✅ bases for percentages + upsert
  productSubtotal={Number(installationCost1 || 0)}              // installation_cost
  shippingAmount={0}
  specialFeeBase={Number(specialFeeAmount || 0)}                // ✅ V2 name (was specialFeeAmount)

  onTaxCalculated={async (b) => {
    setLastTaxes(b);
    formik.setFieldValue("tax", b.totalTaxAmount);
    formik.setFieldValue("total", Number(formik.values.subtotal || 0) + Number(b.totalTaxAmount || 0));

    await axios.patch(
      `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
      {
        version: installationOrder?.version,

        // base amounts
        special_fee_amount: Number(specialFeeAmount || 0),

        // ✅ persist the live-tax numbers (no zeros!)
        special_fee_tax_amount: b.specialFeeTaxAmount,
        special_fee_tax_percentage: b.specialFeeTaxPercentage,
        product_tax_amount: b.productTaxAmount,
        product_tax_percentage: b.productTaxPercentage,
        shipping_tax_amount: b.shippingTaxAmount,
        shipping_tax_percentage: b.shippingTaxPercentage,
        tax_amount: b.totalTaxAmount,

        tax_details: {
          product_tax_amount: b.productTaxAmount,
          product_tax_percentage: b.productTaxPercentage,
          shipping_tax_amount: b.shippingTaxAmount,
          shipping_tax_percentage: b.shippingTaxPercentage,
          special_fee_tax_amount: b.specialFeeTaxAmount,
          special_fee_tax_percentage: b.specialFeeTaxPercentage,
          total_tax_amount: b.totalTaxAmount,
        },
      },
      { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
    );

    showSuccess("Live taxes applied.");
  }}
  onReported={() => showSuccess("Installation tax reported to TaxCloud.")}
/> */}



              {/* <div className="align-items-center card-body col-lg-4 justify-content-end offset-2 ps-2 pt-2 shadow-lg">
                    <div className="col-lg-6 text-end">
                      <table
                        className=" mb-3"
                        style={{
                          // border: "1px solid #dee2e6",
                          borderRadius: "6px",
                          padding: "10px",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td className="py-2 ps-3 fw-medium text-center table-cells">Total Units:</td>
                            <td className="py-2 pe-4 table-cells " style={{ paddingRight: "20px" }}>
                              {totalUnits}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-2 ps-3 fw-medium text-center table-cells">Installation Cost:</td>
                            <td className="py-2 pe-4 table-cells " style={{ paddingRight: "20px" }}>
                              ${Number(installationCost).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-2 ps-3 fw-medium text-center table-cells">Subtotal</td>
                            <td className="py-2 pe-4 table-cells" style={{ paddingRight: "20px" }}>
                              ${Number(formik.values.subtotal).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-2 ps-3 fw-medium text-center table-cells">Tax</td>
                            <td className="py-2 pe-4 table-cells" style={{ paddingRight: "20px" }}>
                              ${Number(formik.values.tax).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-2 ps-3 fw-medium text-center table-cells">Total</td>
                            <td className="py-2 pe-4 table-cells" style={{ paddingRight: "20px" }}>
                              ${Number(formik.values.total).toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div> */}
            </div>

            <div className="mb-3">
              {(status === 400 || status === 500 || status === 600) && (
                // <div className="col-lg-4 mt-5">
                //   <label htmlFor="">Proof of Installation</label>
                //   <input
                //     type="file"
                //     className="form-control"
                //     id="image"
                //     name="image"
                //     multiple
                //     onChange={(e) => {
                //       const files = Array.from(e.target.files || []);
                //       const newPreviews = files?.map((file) => ({
                //         file,
                //         url: URL.createObjectURL(file),
                //       }));
                //       setPreviewFiles((prev) => [...prev, ...newPreviews]);
                //     }}
                //   />
                //   {previewFiles?.length > 0 && (
                //     <button
                //       type="button"
                //       className="btn btn-success mt-3"
                //       onClick={async () => {
                //         try {
                //           const uploads = await Promise.all(
                //             previewFiles?.map(async ({ file }) => {
                //               const path = await uploadFile(file); // ✅ Reuse function
                //               return {
                //                 file_name: file.name,
                //                 file_url: path,
                //                 content_type: file.type,
                //                 uploaded_date: new Date().toISOString(),
                //               };
                //             })
                //           );

                //           const allFiles = [...uploadedFileMeta, ...uploads];
                //           const uniqueByName = allFiles.filter(
                //             (file, index, self) =>
                //               index === self.findIndex((f) => f.file_name === file.file_name)
                //           );

                //           setUploadedFileMeta(uniqueByName);
                //           setPreviewFiles([]); // clear previews after upload

                //           // 4. Call Proof API with final files
                //           // 🚀 Only send the NEW ones
                //           await uploadProofOfInstallation(uploads);
                //           showSuccess("Files uploaded successfully!");
                //         } catch (err) {
                //           console.error("Upload error:", err);
                //           showError("Failed to upload files.");
                //         }
                //       }}
                //     >
                //       Update Info
                //     </button>
                //   )}

                //   <div className="row mt-3">
                //     {uploadedFileMeta?.map((file, index) => (
                //       <div key={index} className="col-lg-3 position-relative mb-3">
                //         {/* <div
                //                                                   className="position-absolute top-0 end-0 bg-danger text-white rounded-circle"
                //                                                   style={{
                //                                                       width: "20px",
                //                                                       height: "20px",
                //                                                       textAlign: "center",
                //                                                       cursor: "pointer",
                //                                                       zIndex: 2,
                //                                                   }}
                //                                                   onClick={() => {
                //                                                       setUploadedFileMeta((prev) => prev.filter((_, i) => i !== index));
                //                                                   }}
                //                                               >
                //                                                   &times;
                //                                               </div> */}
                //         <div className="border p-2">
                //           <img
                //             src={`${process.env.REACT_APP_BASE_URL}${file.file_url}`}
                //             alt={file.file_name}
                //             className="img-fluid"
                //             style={{ height: "150px", objectFit: "cover", width: "100%" }}
                //           />
                //           <div className="small text-center mt-1 text-muted">{file.file_name}</div>
                //         </div>
                //       </div>
                //     ))}

                //     {previewFiles?.map((item, index) => (
                //       <div key={`preview-${index}`} className="col-lg-3 position-relative mb-3">
                //         <div
                //           className="position-absolute top-0 end-0 bg-danger text-white rounded-circle"
                //           style={{
                //             width: "20px",
                //             height: "20px",
                //             textAlign: "center",
                //             cursor: "pointer",
                //             zIndex: 2,
                //           }}
                //           onClick={() => {
                //             URL.revokeObjectURL(item.url);
                //             setPreviewFiles(previewFiles.filter((_, i) => i !== index));
                //           }}
                //         >
                //           &times;
                //         </div>
                //         <div className="border p-2">
                //           <img
                //             src={item.url}
                //             alt={`preview-${index}`}
                //             className="img-fluid"
                //             style={{ height: "150px", objectFit: "cover", width: "100%" }}
                //           />
                //           <div className="small text-center mt-1 text-muted">{item.file.name}</div>
                //         </div>
                //       </div>
                //     ))}
                //   </div>
                // </div>
                <ProofSection
                  title="Proof of Installation"
                  canEdit={!!canEditProof}
                  existing={uploadedFileMeta}
                  setExisting={setUploadedFileMeta}
                  showNotifyCustomer={status === 500}
                  onNotifyCustomer={notifyCustomerProofAvailable}
                  onRegisterUploadHandler={(uploadFn) => {
                    proofUploadHandlerRef.current = uploadFn;
                  }}
                  // uploadFile={uploadFile}
                  onSubmitProof={async (newFiles) => {
                    // send only the new ones to your API
                    await uploadProofOfInstallation(newFiles);
                  }}
                />
              )}
            </div>

            {/* for desktop view back and submit buttom */}
            <div className="row mb-3 col-lg-12 rcust-margin-4 d-none d-lg-block" style={{ marginTop: "27px" }}>
              <div className="col-lg-12 d-block d-lg-flex justify-content-between">
                <div className="col-lg-2 mb-3">
                  <button
                    type="button"
                    onClick={() => safeNavigate(`${baseRoute}/jobs/installations`)}
                    className="btn back-btn surface-btn fw-bold fs-16 w-100"
                  >
                    <i className="bi bi-chevron-left me-2" />
                    Back
                  </button>
                </div>

                <div className="align-items-baseline col-lg-3 d-lg-flex justify-content-end">
                  {/* {status !== 500 && status !== 600 && (
                        <div className="col-lg-6 mt-3">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              id="localLaws"
                              name="localLawsChecked"
                              className="form-check-input"
                              checked={formik.values.localLawsChecked}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            <label htmlFor="localLaws" className="form-check-label ms-2">
                              I Acknowledge to local laws
                            </label>
                          </div>
                        </div>
                      )} */}
                  {Viewmode && (
                    renderViewModeActions()
                  )}
                  {!Viewmode && (
                    <button
                      type="submit"
                      // className="btn btn-primary px-4 table-cells removal-installation"
                      className="btn btn-primary save-btn surface-btn fw-bold fs-16 w-100 removal-installation"
                      disabled={formSubmitting || isRecomputing}
                    >
                      {isRecomputing ? "Calculating..." : "Save"}
                    </button>
                  )}

                </div>
              </div>
            </div>

          </div>

          <div className="col-lg-4">
          <PONumber
                  title="PO Number"
                  value={String((installationOrder as any)?.po_number ?? (installationOrder as any)?.poNumber ?? "")}
                  placeholder="e.g. PO-2026-00124"
                  className="mb-3"
                  orderId={String(installationOrder?._id || installationOrder?.id || installationId || "")}
                  orderType="installation"
                  onSaved={async () => {
                    await fetchOrderDetails();
                  }}
                />

            <SpecialFeeui
              token={token!}
              personId={installationOrder?.agent_id || installationOrder?.team_member_id || ""}
              supplierId={String(organizationId || "").trim()}
              order={installationOrder}
              orderId={String(installationOrder?._id || installationOrder?.id || installationId || "").trim()}
              orderType="installation"
              formik={formik}
              name="specialfee"
              value={selectedSpecialFees}
              apiBase={process.env.REACT_APP_API_URL || ""}
              readOnly={mode === "view"}
              disabled={isRecomputing}  // ✅ Disable special fee selection when recompute is running
              title="Special Fees"
              onOptionsLoaded={(allOptions) => {
                // ✅ Receive all available fees (including required field) from component
                setAllAvailableSpecialFees(allOptions);
                // console.log("All available special fees from component:", allOptions);
              }}
              onUserChange={(nextFees) => {
                // console.log("SpecialFee changed - received from child:", nextFees);

                // ✅ Don't process if recompute is running (prevents duplicate calls)
                if (isRecomputingRef.current) {
                  safeConsole.log("⏸️ Recompute in progress, skipping special fee change");
                  return;
                }

                // ✅ Only trigger recompute if fees actually changed (IDs or count)
                const currentIds = selectedSpecialFees.map(f => f.id).sort().join(',');
                const nextIds = nextFees.map(f => f.id).sort().join(',');

                // 1️⃣ Update local state immediately (for UI responsiveness)
                setSelectedSpecialFees(nextFees);

                // 2️⃣ ⚠️ Don't update Formik here - let recompute handle it to avoid race conditions
                // The child component already updated its internal Formik field, and recompute
                // will update the parent's Formik with the enriched data from the tax engine

                // 3️⃣ Trigger tax recalculation only in edit mode and if selection changed
                if (mode === "edit" && currentIds !== nextIds) {
                  // console.log("🔄 Fee selection changed, triggering recompute");
                  recompute({ fees: nextFees });  // ✅ Pass updated fees to avoid stale reads!
                }
              }}
            />

            {isEdit && (
              <ProjectGetCard
                token={token!}
                signageId={String(organizationId || "").trim()}
                initialProjectId={
                  userClearedProjectRef.current
                    ? undefined
                    : linkedProjectId ||
                    projectIdFromQuery ||
                    String((installationOrder as any)?.project_id || "") ||
                    undefined
                }
                onSelectionChange={(sel) => {
                  if (!sel) userClearedProjectRef.current = true;
                  else userClearedProjectRef.current = false;
                  setLinkedProjectId(sel?.projectId ?? null);
                  setLinkedProjectNumber(sel?.projectNumber ?? null);
                }}
              />
            )}

            {
              installationOrder?.payment_status === "Paid" ? <></> :
                <div className="col-lg-12 mb-3">
                  {/* <div className="bg-primary-subtle d-flex align-items-center justify-content-center gap-2 py-3">
                        <SectionHeader title="Payments" icon="ri-bank-card-line" color="#10b981" size="md" divider />
                      </div> */}
                  {/* <div className="no-scrollbar" style={{ height: 580, overflowY: "auto" }}> */}
                  {/* {status !== 600 && status !== 100 && Viewmode && installationOrder?.tax_status !== "" && ( */}
                  {Viewmode && (

                    <PaymentPanel
                      variant="signage"   // or brokerage/agent depending on type
                      remainingAmount={Number(remaingamount)}
                      orderStatus={installationOrder?.status ?? 0}
                      paymentStatus={installationOrder?.payment_status ?? ""}
                      selectedPaymentMethod={selectedPaymentMethod}
                      setSelectedPaymentMethod={handlePaymentMethodSelect}
                      formik={formik}
                      maxAllowed={maxAllowed}
                      paymentInfo={installationOrder?.payment_info ?? []}
                      dynamicMethods={paymentMethod} // [{ _id, name }]
                      onSubmitOffline={(key) => completeOrder(key)}
                      orderType="installationOrder"
                      onlinePaymentNode={
                        stripePromise && clientSecret ? (
                          <Elements key={clientSecret} stripe={stripePromise} options={{ clientSecret }}>
                            <PaymentFormManualOrder
                              url="installation_orders"
                              method="POST"
                              supplierId={
                                resolveInstallationSellerOrganizationId(
                                  effectiveSignageOrgId,
                                  installationOrder
                                ) ||
                                String(effectiveSignageOrgId || "").trim()
                              }
                              totalAmount={
                                Math.max(0, Number(remaingamount ? remaingamount : installationOrder?.total_amount))
                              }
                              paidAmount={
                                formik.values.enable_partial_payment && Number(formik.values.partial_amount) > 0
                                  ? Number(formik.values.partial_amount)
                                  : Math.max(0, Number(remaingamount))
                              }
                              orderId={String(installationOrder?._id || installationOrder?.id || "")}
                              orderNumber={String(installationOrder?.order_number || "")}
                              customerName={String(installationOrder?.user_name || "")}
                              customerPhone={String(installationOrder?.user_phone || "")}
                              selectedPaymentMethod={selectedPaymentMethod?.name || "online"}
                              skipRedirectOnSuccess
                              onPaymentSuccess={async (paymentIntentId, updatedOrderFromResponse?: any) => {
                                // console.log("Payment successful:", paymentIntentId);
                                // Don't automatically submit the form - let user decide when to proceed
                                // formik?.handleSubmit?.();

                                // Send "Payment applied for Installation Job" emails after successful online payment
                                // Note: updatedOrderFromResponse may be provided by PaymentFormManualOrder if API returns it
                                try {
                                  const from =
                                    process.env.REACT_APP_FROM_EMAIL2 ||
                                    process.env.REACT_APP_FROM_EMAIL ||
                                    "noreply@realesy.com";
                                  if (from && installationOrder) {
                                    safeConsole.log("onPaymentSuccess: Starting email send process for installation payment:", paymentIntentId);

                                    // Use updated order from response if available, otherwise fetch it
                                    let updatedOrder = updatedOrderFromResponse || installationOrder;

                                    // If we don't have updated order from response, fetch it with retry
                                    if (!updatedOrderFromResponse) {
                                      safeConsole.log("No updated order from response, fetching from API...");
                                      // Wait a moment for backend to process payment before fetching updated order
                                      await new Promise(resolve => setTimeout(resolve, 1000));

                                      let retries = 3;
                                      while (retries > 0) {
                                        try {
                                          const updatedOrderRes = await fetch(`${process.env.REACT_APP_API_URL}/installation_orders/${installationOrder._id}`, {
                                            headers: { Authorization: `Bearer ${token}` },
                                          });
                                          if (updatedOrderRes.ok) {
                                            const fetchedOrder = await updatedOrderRes.json();
                                            safeConsole.log("Fetched updated installation order, payment_info length:", fetchedOrder.payment_info?.length || 0);
                                            // Check if payment_info has been updated (has at least one payment)
                                            if (Array.isArray(fetchedOrder.payment_info) && fetchedOrder.payment_info.length > 0) {
                                              updatedOrder = fetchedOrder;
                                              safeConsole.log("Payment info found, using updated order");
                                              break;
                                            } else if (retries === 1) {
                                              // Last retry, use fetched order even if payment_info is empty
                                              updatedOrder = fetchedOrder;
                                              safeConsole.warn("Using fetched order even though payment_info is empty");
                                            }
                                          }
                                        } catch (fetchErr) {
                                          safeConsole.warn(`Failed to fetch updated installation order (retries left: ${retries - 1}):`, fetchErr);
                                        }
                                        if (retries > 1) {
                                          await new Promise(resolve => setTimeout(resolve, 500));
                                        }
                                        retries--;
                                      }
                                    }

                                    // Get payment amount from the updated order
                                    const paymentInfoArray = Array.isArray(updatedOrder.payment_info) ? updatedOrder.payment_info : [];
                                    const latestPayment = paymentInfoArray.length > 0
                                      ? paymentInfoArray.reduce((latest: any, current: any) => {
                                          const latestDate = new Date(latest?.payment_date || 0).getTime();
                                          const currentDate = new Date(current?.payment_date || 0).getTime();
                                          return currentDate > latestDate ? current : latest;
                                        }, paymentInfoArray[0])
                                      : null;
                                    const paymentAmount = latestPayment?.amount_paid
                                      ? Number(latestPayment.amount_paid)
                                      : (formik.values.enable_partial_payment && formik.values.partial_amount > 0
                                        ? Number(formik.values.partial_amount)
                                        : Number(remaingamount));

                                    await sendInstallationPaymentAppliedEmails(
                                      updatedOrder,
                                      paymentAmount,
                                      selectedPaymentMethod?.name || "online",
                                      from,
                                      !!selectedPaymentMethod && selectedPaymentMethod._id !== selectedPaymentMethod.name
                                    );

                                    safeConsole.log("onPaymentSuccess: Email send process completed");
                                  } else {
                                    safeConsole.warn("onPaymentSuccess: Missing from email or installation order", { from: !!from, installationOrder: !!installationOrder });
                                  }
                                } catch (emailError) {
                                  safeConsole.error("Failed to send payment applied emails:", emailError);
                                  // Don't block payment success if email fails, but log the error
                                }
                                localStorage.removeItem("cart_id");
                                safeNavigate(0);
                              }}
                              userId={
                                resolveInstallationPaymentMethodsMembershipId(installationOrder) || ""
                              }
                              userEmail={installationOrder?.user_email ?? ""}
                              paidBy_id={userId?.toString() ?? ""}
                              paidBy_name={userName ?? ""}
                              payments_status={installationOrder?.payment_status ?? ""}
                            />
                          </Elements>
                        ) : null
                      }
                    />
                  )}
                </div>
            }

            <div className="col-lg-12 rounded-3 mb-3">
              {/* <div className="no-scrollbar" style={{ height: 550, overflowY: "auto" }}>
                    {status !== 600 && Viewmode && (
                      <div className="p-3 mb-2">
                        <ul className="list-unstyled vstack gap-3 ">
                          {
                            <strong className="table-cells">Order Created on {parseDate(installationOrder?.created_at)}</strong>
                          }
                         
                          {paymentInfo.slice().reverse()?.map((payment, idx) => {
                            const status =
                              payment.amount_due === 0
                                ? "Paid"
                                : payment.amount_paid > 0
                                  ? "Partial Payment"
                                  : "Pending";

                            const badgeClass =
                              status === "Paid"
                                ? "bg-success-subtle text-success"
                                : status === "Partial Payment"
                                  ? "bg-warning-subtle text-warning"
                                  : "bg-danger-subtle text-danger";

                            return (
                              <li key={`payment-${idx}`}>
                                <div>
                                  <strong className="table-cells">💰 Payment:</strong>{" "}
                                  <span className="badge bg-success-subtle text-success">
                                    ${payment.amount_paid?.toFixed(2)} {payment.method && `via ${payment.method}`}
                                  </span>

                                  <strong className="ms-3 table-cells">💳 Payment Status:</strong>{" "}
                                  <span className={`badge ${badgeClass}`}>{status}</span>

                                  
                                  {payment.paid_by?.name && (
                                    <span className="ms-3 table-cells">
                                      <i className="ri-user-line align-middle me-1"></i>
                                      Paid by: <strong>{payment?.paid_by.name}</strong>
                                    </span>
                                  )}

                                  <div className="text-muted small">On {parseDate(payment.payment_date)}</div>
                                </div>
                              </li>
                            );
                          })}

                         
                          {statusHistory?.map((log, idx) => (
                            <li key={`status-${idx}`}>
                              <div>
                                <strong className="table-cells">📦 Installation Status:</strong>{" "}
                                <span className="badge bg-secondary-subtle text-dark table-cells">
                                  {resolveOrderStatus(log.from)} → {resolveOrderStatus(log.to)}
                                </span>
                                <div className="text-muted small">On {parseDate(log.timestamp)}</div>
                                {log.note && <div className="small mt-1">📝 {log.reason}</div>}
                              </div>
                            </li>
                          ))}

                        </ul>
                      </div>
                    )}
                  </div> */}
              <OrderLog
                title="Installation Log"
                orderKind="installation"
                events={installationLogEvents}
              />
            </div>
          </div>
          {/* for mobile and tab view back and submit button */}
          <div className="row mb-3 col-lg-12 rcust-margin-4 d-block d-lg-none">
            <div className="col-lg-12 d-block d-lg-flex justify-content-between">
              <div className="col-lg-2 mb-3">
                <button
                  type="button"
                  onClick={() => safeNavigate(-1)}
                  className="btn back-btn surface-btn fw-bold fs-16 w-100"
                >
                  <i className="bi bi-chevron-left me-2" />
                  Back
                </button>
              </div>

              <div className="align-items-baseline col-lg-3 d-lg-flex justify-content-end">
                {/* {status !== 500 && status !== 600 && (
                        <div className="col-lg-6 mt-3">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              id="localLaws"
                              name="localLawsChecked"
                              className="form-check-input"
                              checked={formik.values.localLawsChecked}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            <label htmlFor="localLaws" className="form-check-label ms-2">
                              I Acknowledge to local laws
                            </label>
                          </div>
                        </div>
                      )} */}
                {Viewmode && (
                  renderViewModeActions()
                )}
                {!Viewmode && (
                  <button
                    type="submit"
                    // className="btn btn-primary px-4 table-cells removal-installation"
                    className="btn btn-primary save-btn surface-btn fw-bold fs-16 w-100 removal-installation"
                    disabled={formSubmitting || isRecomputing}
                  >
                    {isRecomputing ? "Calculating..." : "Save"}
                  </button>
                )}

              </div>
            </div>
          </div>
        </div>
      </form>
      {(showAllocateModal || showViewInventoryModal) && (
        <div className="modal-backdrop show"></div>
      )}

      {/* Allocate Rotational Product – improved, scrollable & responsive */}
      {/* Allocate Rotational Product — namespaced + scrollable */}
      <div
        className={`modal fade ${showAllocateModal ? "show d-block" : ""}`}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        style={{ backgroundColor: "rgba(0,0,0,.35)" }}
      >
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
          <div className="modal-content re-alloc" id="allocModalV2">
            {/* Sticky header */}
            <div className="modal-header re-alloc__header">
              <h5 className="modal-title table-headers">Allocate Assets</h5>
              <button type="button" className="btn-close" onClick={() => setShowAllocateModal(false)} />
            </div>

            {/* Body = vertical scroller */}
            <div className="modal-body re-alloc__body">
              <div className="container-fluid">
                <div className="row g-3">
                  {/* Select Product */}
                  <div className="col-12 col-md-6">
                    <label className="form-label table-cells">Select Product:</label>
                    <select
                      name="productId"
                      id="productId"
                      className="form-select form-control br-8"
                      value={selectedProduct?.value ?? ""}
                      onChange={(e) => {
                        const productId = e.target.value;
                        if (!productId) {
                          setSelectedProduct(null);
                          setWarehouseOptions([]);
                          setSelectedWarehouse(null);
                          setAvailableSerializedUnits([]);
                          return;
                        }
                        const selected =
                          rotationalproductOptions?.find((o) => o.value === productId) ?? null;
                        handleProductSelect(selected);
                        setSelectedWarehouse(null);
                        setAvailableSerializedUnits([]);
                      }}
                    >
                      <option value="">Select...</option>
                      {(rotationalproductOptions ?? []).map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Select Warehouse */}
                  <div className="col-12 col-md-6">
                    <label className="form-label table-cells">Select Warehouse:</label>
                    <select
                      name="warehouseId"
                      id="warehouseId"
                      className="form-select form-control br-8"
                      value={selectedWarehouse?.value ?? ""}
                      disabled={!selectedProduct}
                      onChange={(e) => {
                        const warehouseId = e.target.value;
                        if (!warehouseId) {
                          setSelectedWarehouse(null);
                          setAvailableSerializedUnits([]);
                          return;
                        }
                        const selected =
                          warehouseOptions.find((o) => o.value === warehouseId) ?? null;
                        setSelectedWarehouse(selected);
                        if (selectedProduct?.fullProduct && selected?.value) {
                          fetchSerializedUnits(selectedProduct.value, selected.value);
                        }
                      }}
                    >
                      <option value="">Select...</option>
                      {warehouseOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Quantity / Remaining */}
                  <div className="col-12 col-md-6">
                    <label className="form-label table-cells">Quantity Required:</label>
                    <input className="form-control br-8" readOnly
                      value={linkedProductIdContext ? (selectedProducts.find(p => p.product_id === linkedProductIdContext)?.quantity ?? 0) : ""} />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label table-cells">Remaining:</label>
                    <input className="form-control br-8" readOnly
                      value={(() => {
                        const linked = linkedProductIdContext ? selectedProducts.find(p => p.product_id === linkedProductIdContext) : null;
                        const req = Number(linked?.quantity || 0);
                        const allocatedCount = Number(linked?.allocatedCount || 0);
                        const newly = (allocatedUnits[linkedProductIdContext || ""] || []).length;
                        return Math.max(req - (allocatedCount + newly), 0);
                      })()} />
                  </div>
                </div>
              </div>

              {/* Table wrapper — H-scroll; V-scroll is on body */}
              <div className="re-alloc__tableWrap mt-3">
                <table className="table align-middle mb-0 re-alloc__table">
                  <thead className="table-active sticky-top" style={{ top: 0 }}>
                    <tr>
                      <th className="table-cells">Serial No.</th>
                      <th className="table-cells">Warehouse</th>
                      <th className="table-cells text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {linkedProductIdContext ? (
                      (() => {
                        const linked = selectedProducts.find(p => p.product_id === linkedProductIdContext);
                        const req = Number(linked?.quantity || 0);
                        const allocatedFor = allocatedUnits[linkedProductIdContext] || [];
                        const newly = allocatedFor.length;

                        if (!availableSerializedUnits || availableSerializedUnits.length === 0) {
                          return (
                            <tr><td colSpan={3} className="text-center table-cells py-4">No units available</td></tr>
                          );
                        }

                        return availableSerializedUnits.map((unit: any, idx: number) => {
                          const already = allocatedFor.some(u => u.serial_id === unit.serial_id);
                          const remaining = Math.max(req - (Number(linked?.allocatedCount || 0) + newly), 0);
                          const disabled = already || remaining <= 0;

                          return (
                            <tr key={unit.serial_id || idx}>
                              <td className="table-cells">{unit.serial_number || "N/A"}</td>
                              <td className="table-cells">{selectedWarehouse?.label || unit.warehouse_name || "-"}</td>
                              <td className="table-cells text-center">
                                <button
                                  className="btn btn-sm btn-success p-2 fs-13 fw-medium"
                                  style={{ background: "#228B22" }}
                                  disabled={disabled}
                                  onClick={() => {
                                    if (!linkedProductIdContext || !selectedProduct || !selectedWarehouse) return;
                                    const rotationalProductId = selectedProduct.value;
                                    const warehouseId = selectedWarehouse.value;

                                    const matched = selectedProduct?.fullProduct?.serialized_units?.find(
                                      (s: any) => s.serial_id === unit.serial_id
                                    );

                                    const newUnit = {
                                      rotationalProductId,
                                      warehouseId,
                                      serial_id: unit.serial_id,
                                      serial_number: unit.serial_number,
                                      product_name: selectedProduct?.label || "",
                                      sku: selectedProduct?.sku || "",
                                      storage_location: matched?.storage_location || null,
                                    };

                                    setAllocatedUnits((prev) => {
                                      const existing = prev[linkedProductIdContext] || [];
                                      if (existing.some(u => u.serial_id === unit.serial_id) || existing.length >= req) {
                                        showError("You can't allocate more than the required quantity.");
                                        return prev;
                                      }
                                      return { ...prev, [linkedProductIdContext]: [...existing, newUnit] };
                                    });

                                    showSuccess("Unit allocated.");
                                  }}
                                >
                                  Allocate
                                </button>
                              </td>
                            </tr>
                          );
                        });
                      })()
                    ) : (
                      <tr><td colSpan={3} className="text-center table-cells py-4">No product selected</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Sticky footer */}
            <div className="modal-footer re-alloc__footer">
              <button className="btn back-btn surface-btn fw-bold fs-16" onClick={() => setShowAllocateModal(false)}>Close</button>
              <button
                className="btn btn-primary table-addbutton"
                onClick={async () => {
                  const hasAllocations = allocatedUnits && Object.values(allocatedUnits).some(
                    (units) => Array.isArray(units) && units.length > 0
                  );

                  if (hasAllocations) {
                    const success = await patchRotationalAllocations();
                    if (success) {
                      showSuccess("Allocations saved successfully!");
                      setShowAllocateModal(false);
                    }
                  } else {
                    showError("No allocations to save.");
                  }
                }}
              >
                Save Allocation
              </button>
            </div>
          </div>
        </div>
      </div>



      {(showAllocateModal || showViewInventoryModal) && (
        <div className="modal-backdrop show"></div>
      )}

      {/* <div className={`modal fade ${showViewInventoryModal ? "show d-block" : ""}`} tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Non-Rotational Product Inventory</h5>
                  <button type="button" className="btn-close" onClick={() => setShowViewInventoryModal(false)}></button>
                </div>
                <div className="modal-body">
                  <p>Product: Panel XYZ</p>
                  <table className="table table-bordered default-table">
                    <tr>
                      <th>Warehouse </th>
                      <th>In Storage</th>
                      <th>Reserved</th>
                      <th>On Site </th>
                    </tr>
                    <tr>
                      <td>Warehouse A </td>
                      <td>50 </td>
                      <td>10 </td>
                      <td>5</td>
                    </tr>
                    <tr>
                      <td>Warehouse B </td>
                      <td>30 </td>
                      <td>5 </td>
                      <td>2</td>
                    </tr>
                  </table>

                </div>

              </div>
            </div>
          </div> */}

      {/* <DeleteConfirmModal
        open={showReportTaxConfirmModal}
        dynamicName="transaction"
        title="Confirm"
        message={<>Click <strong>Report Live Taxes</strong> to proceed and complete the transaction.</>}
        confirmLabel="OK"
        onCancel={() => setShowReportTaxConfirmModal(false)}
        onDelete={() => setShowReportTaxConfirmModal(false)}
      /> */}
    </div>
  );
};

export default SignageInstallationWorkOrder;
